
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("cKtMA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $77719c67cd7ac488$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8cVut = parcelRequire("8cVut");
const $77719c67cd7ac488$var$IssueViewDevPanel = ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8cVut.default), props);
var $77719c67cd7ac488$export$2e2bcd8739ae039 = $77719c67cd7ac488$var$IssueViewDevPanel;

});
parcelRegister("8cVut", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f1e4e8409c9a0b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f5qyR = parcelRequire("f5qyR");

var $ymYUx = parcelRequire("ymYUx");

var $doVrv = parcelRequire("doVrv");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $2gCtH = parcelRequire("2gCtH");

var $3fAi8 = parcelRequire("3fAi8");

var $80wkc = parcelRequire("80wkc");

var $dXq4S = parcelRequire("dXq4S");

var $5fc53 = parcelRequire("5fc53");

var $93Yeu = parcelRequire("93Yeu");

var $fiv1r = parcelRequire("fiv1r");

var $kfztd = parcelRequire("kfztd");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $bmGNV = parcelRequire("bmGNV");
function $e1f1e4e8409c9a0b$var$AllDevInfoPanel({ issueId: issueId, issueAri: issueAri }) {
    const user = (0, $90yGq.useAccountId)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const analyticsSource = (0, $2gCtH.useAnalyticsSource)();
    const projectKey = (0, $2gCtH.useProjectKey)();
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const cloudId = (0, $koeKL.useCloudId)();
    const isSimplifiedProject = (0, $93Yeu.useIsSimplifiedProject)(projectKey);
    const [{ value: summary }] = (0, $80wkc.useSummaryField)({
        issueKey: issueKey,
        issueId: issueId
    });
    const [statusFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.STATUS_TYPE)
    });
    const issueStatusCategory = statusFieldValue?.statusCategory.id || null;
    const hasSoftwareAccess = (0, $2gCtH.useHasSoftwareAccess)();
    const isJiraAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const issueContext = (0, $5uXOq.useMemo)(()=>({
            issueKey: issueKey,
            issueId: Number(issueId),
            issueStatusCategory: issueStatusCategory,
            projectAri: (0, $dXq4S.createAri)({
                resourceId: projectId || '',
                resourceOwner: 'jira',
                resourceType: 'project',
                cloudId: cloudId
            }),
            projectId: Number(projectId),
            projectType: projectType || '',
            isSimplifiedProject: isSimplifiedProject
        }), [
        issueKey,
        issueId,
        issueStatusCategory,
        projectId,
        projectType,
        isSimplifiedProject,
        cloudId
    ]);
    const devPanelAppProps = {
        hasSoftwareAccess: hasSoftwareAccess,
        issueId: issueId.toString(),
        issueAri: issueAri,
        issueKey: issueKey,
        issueStatusCategory: issueStatusCategory || '',
        projectId: projectId || '',
        projectType: projectType || '',
        nextGenProject: isSimplifiedProject,
        analyticsSource: analyticsSource || '',
        projectAri: (0, $dXq4S.createAri)({
            resourceId: projectId || '',
            resourceOwner: 'jira',
            resourceType: 'project',
            cloudId: cloudId
        }),
        isJiraAdmin: isJiraAdmin
    };
    // ProjectContext is still loading
    if (projectId == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "devInfoPanelApp",
        packageName: "jiraDevelopmentDevInfoPanelApp"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5qyR.default), devPanelAppProps), !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ymYUx.default), {
        issueContext: issueContext,
        hasSoftwareAccess: hasSoftwareAccess,
        analyticsSource: analyticsSource || '',
        summary: summary || '',
        user: user,
        isJiraAdmin: isJiraAdmin,
        isSiteAdmin: isSiteAdmin,
        cloudAri: cloudId
    }), !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && (0, $4R6GH.fg)('isotopes-security-page-in-jira-enabled-v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $doVrv.default), {
        issueAri: issueAri
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bmGNV.default), {
        scopeId: `devInfoPanelApp${issueContext.issueKey}`
    })));
}
var $e1f1e4e8409c9a0b$export$2e2bcd8739ae039 = $e1f1e4e8409c9a0b$var$AllDevInfoPanel;

});
parcelRegister("f5qyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d511ba42b0f21daa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bC2fB = parcelRequire("bC2fB");

var $eUefN = parcelRequire("eUefN");

var $jxvCJ = parcelRequire("jxvCJ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d511ba42b0f21daa$export$2e2bcd8739ae039 = ({ issueKey: issueKey, ...props })=>{
    const [store] = (0, $5uXOq.useState)((0, $eUefN.default)({
        issueKey: issueKey
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bC2fB.Provider), {
        store: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxvCJ.default), {
        ...props,
        issueKey: issueKey
    }));
};

});
parcelRegister("eUefN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc33e5ee371198bb$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $e1AU2 = parcelRequire("e1AU2");

var $7uUwQ = parcelRequire("7uUwQ");

var $hkadP = parcelRequire("hkadP");

var $9W8Dt = parcelRequire("9W8Dt");

var $cqpYx = parcelRequire("cqpYx");

var $k8xfJ = parcelRequire("k8xfJ");

var $eoX8A = parcelRequire("eoX8A");
const $fc33e5ee371198bb$var$defaultInitialState = (0, $7uUwQ.freeze)({
    context: (0, $cqpYx.initialState),
    entities: (0, $eoX8A.initialState)
});
const $fc33e5ee371198bb$export$a8a69c316169e623 = (state = $fc33e5ee371198bb$var$defaultInitialState, action)=>(0, $7uUwQ.freeze)((0, $3f2cs.combineReducers)({
        context: (0, $cqpYx.default),
        entities: (0, $eoX8A.default)
    })(state, action));
const $fc33e5ee371198bb$export$49b6a7dfc84f00c4 = ()=>(0, $e1AU2.combineEpics)((0, $k8xfJ.fetchDevPanel), (0, $k8xfJ.enrichDevPanelWithOneClickLinks), // @ts-expect-error - TS2345 - Argument of type '(action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) => Observable<{ eventData: any; analyticsEvent: any; action: any; actionSubjectId: any; }>' is not assignable to parameter of type 'Epic<State, DevPanelActions>'.
    (0, $9W8Dt.default));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fc33e5ee371198bb$export$2e2bcd8739ae039 = ({ initialState: initialState = $fc33e5ee371198bb$var$defaultInitialState, issueKey: issueKey = '' })=>(0, $3f2cs.createStore)($fc33e5ee371198bb$export$a8a69c316169e623, initialState, (0, $hkadP.default)({
        name: `DevPanel-${issueKey}`
    })((0, $3f2cs.applyMiddleware)((0, $e1AU2.createEpicMiddleware)($fc33e5ee371198bb$export$49b6a7dfc84f00c4()))));

});
parcelRegister("9W8Dt", function(module, exports) {

$parcel$export(module.exports, "default", () => $98998427488715c8$export$2e2bcd8739ae039);
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("64ZAE");
parcelRequire("hZWgu");

var $8zOmE = parcelRequire("8zOmE");

var $6GjmU = parcelRequire("6GjmU");
// @ts-expect-error - TS7031 - Binding element 'type' implicitly has an 'any' type. | TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ FETCH_DEV_PANEL_SUCCESS: (state: State, action: { analyticsEvent: UIAnalyticsEventInterface; }) => { eventNameSuffix: string; eventData: { issueId: string; issueStatusCategory: string; projectId: string; ... 4 more ...; isEmptyStateEnabled: boolean; }; analyticsEvent: UIAnalyticsEventInterface; action: string; act...'.
const $98998427488715c8$var$shouldActionTriggerAnalytics = ({ type: type })=>(0, $6GjmU.default)[type] !== undefined;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $98998427488715c8$var$getAnalyticsForAction = (state, action)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ FETCH_DEV_PANEL_SUCCESS: (state: State, action: { analyticsEvent: UIAnalyticsEventInterface; }) => { eventNameSuffix: string; eventData: { issueId: string; issueStatusCategory: string; projectId: string; ... 4 more ...; isEmptyStateEnabled: boolean; }; analyticsEvent: UIAnalyticsEventInterface; action: string; act...'.
    (0, $6GjmU.default)[action.type](state, action);
// @ts-expect-error - TS7031 - Binding element 'eventData' implicitly has an 'any' type. | TS7031 - Binding element 'analyticsEvent' implicitly has an 'any' type. | TS7031 - Binding element 'action' implicitly has an 'any' type. | TS7031 - Binding element 'actionSubjectId' implicitly has an 'any' type.
const $98998427488715c8$var$triggerAnalyticsForAction = ({ eventData: eventData, analyticsEvent: analyticsEvent, action: action, actionSubjectId: actionSubjectId })=>{
    if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, action, actionSubjectId, {
        ...eventData
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$98998427488715c8$export$2e2bcd8739ae039 = (action$, store)=>action$.filter($98998427488715c8$var$shouldActionTriggerAnalytics).map((action)=>$98998427488715c8$var$getAnalyticsForAction(store.getState(), action)).do($98998427488715c8$var$triggerAnalyticsForAction).ignoreElements();

});
parcelRegister("6GjmU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cd80f09f49f1649$export$2e2bcd8739ae039);

var $027Zr = parcelRequire("027Zr");

var $4QXBz = parcelRequire("4QXBz");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0cd80f09f49f1649$export$2e2bcd8739ae039 = {
    [(0, $027Zr.FETCH_DEV_PANEL_SUCCESS)]: (state, action)=>({
            eventNameSuffix: 'fetch.succeeded',
            eventData: (0, $4QXBz.getAnalyticsIssueData)(state),
            analyticsEvent: action.analyticsEvent,
            action: 'panel rendered',
            actionSubjectId: 'devpanelsummary'
        }),
    [(0, $027Zr.FETCH_DEV_PANEL_FAILURE)]: (state, action)=>({
            eventNameSuffix: 'fetch.failed',
            eventData: (0, $4QXBz.getAnalyticsIssueData)(state),
            analyticsEvent: action.analyticsEvent,
            action: 'panel failed',
            actionSubjectId: 'devpanelsummary'
        })
};

});
parcelRegister("027Zr", function(module, exports) {

$parcel$export(module.exports, "FETCH_DEV_PANEL_REQUEST", () => $e326769329edbd32$export$bbc62c19ae8d5cf2);
$parcel$export(module.exports, "FETCH_DEV_PANEL_SUCCESS", () => $e326769329edbd32$export$49acc9c095f6b36a);
$parcel$export(module.exports, "FETCH_DEV_PANEL_URL_DETAILS_SUCCESS", () => $e326769329edbd32$export$45a86e169e39400e);
$parcel$export(module.exports, "FETCH_DEV_PANEL_FAILURE", () => $e326769329edbd32$export$8317438e1e61dba2);
$parcel$export(module.exports, "DEV_PANEL_UNMOUNTED", () => $e326769329edbd32$export$2b6a364d21006071);
$parcel$export(module.exports, "TOGGLE_SUMMARY_SECTION_MESSAGE", () => $e326769329edbd32$export$9efb0389f7941b30);
$parcel$export(module.exports, "fetchDevPanelRequest", () => $e326769329edbd32$export$e272b9d3c8c7592d);
$parcel$export(module.exports, "fetchDevPanelFailure", () => $e326769329edbd32$export$2009dc8f2d7ae19e);
$parcel$export(module.exports, "fetchDevPanelSuccess", () => $e326769329edbd32$export$2d700a870e93952c);
$parcel$export(module.exports, "fetchDevPanelUrlDetailsSuccess", () => $e326769329edbd32$export$6235ecf44e113529);
$parcel$export(module.exports, "devPanelWillUnmount", () => $e326769329edbd32$export$17a40c054c1ce3d2);
$parcel$export(module.exports, "onClickDismissLink", () => $e326769329edbd32$export$e08c79c9b6badf94);
$parcel$export(module.exports, "SHOW_EMPTY_STATE_DIALOG", () => $e326769329edbd32$export$8f51b498d82c8c4d);
$parcel$export(module.exports, "CLOSE_EMPTY_STATE_DIALOG", () => $e326769329edbd32$export$3ee0ca31ae1c64e);
$parcel$export(module.exports, "TOGGLE_EMPTY_STATE_PANEL", () => $e326769329edbd32$export$7ec1c869208a9fdf);
$parcel$export(module.exports, "showEmptyStateDialog", () => $e326769329edbd32$export$397c34c503e1422c);
$parcel$export(module.exports, "closeEmptyStateDialog", () => $e326769329edbd32$export$2a4ad6c2ee7b351a);
$parcel$export(module.exports, "onToggleDismissButton", () => $e326769329edbd32$export$33ebfbc795cb0b7c);
const $e326769329edbd32$export$bbc62c19ae8d5cf2 = 'FETCH_DEV_PANEL_REQUEST';
const $e326769329edbd32$export$49acc9c095f6b36a = 'FETCH_DEV_PANEL_SUCCESS';
const $e326769329edbd32$export$45a86e169e39400e = 'FETCH_DEV_PANEL_URL_DETAILS_SUCCESS';
const $e326769329edbd32$export$8317438e1e61dba2 = 'FETCH_DEV_PANEL_FAILURE';
const $e326769329edbd32$export$2b6a364d21006071 = 'DEV_PANEL_UNMOUNTED';
const $e326769329edbd32$export$9efb0389f7941b30 = 'TOGGLE_SUMMARY_SECTION_MESSAGE';
const $e326769329edbd32$export$e272b9d3c8c7592d = (analyticsEvent)=>({
        type: $e326769329edbd32$export$bbc62c19ae8d5cf2,
        analyticsEvent: analyticsEvent
    });
const $e326769329edbd32$export$2009dc8f2d7ae19e = (analyticsEvent)=>({
        type: $e326769329edbd32$export$8317438e1e61dba2,
        analyticsEvent: analyticsEvent
    });
const $e326769329edbd32$export$2d700a870e93952c = (devPanel, analyticsEvent)=>({
        type: $e326769329edbd32$export$49acc9c095f6b36a,
        payload: devPanel,
        analyticsEvent: analyticsEvent
    });
const $e326769329edbd32$export$6235ecf44e113529 = (swagDetailsResponse)=>({
        type: $e326769329edbd32$export$45a86e169e39400e,
        payload: swagDetailsResponse
    });
const $e326769329edbd32$export$17a40c054c1ce3d2 = ()=>({
        type: $e326769329edbd32$export$2b6a364d21006071
    });
const $e326769329edbd32$export$e08c79c9b6badf94 = (showSection)=>({
        type: $e326769329edbd32$export$9efb0389f7941b30,
        payload: {
            showSummarySectionMessage: showSection
        }
    });
const $e326769329edbd32$export$8f51b498d82c8c4d = 'SHOW_EMPTY_STATE_DIALOG';
const $e326769329edbd32$export$3ee0ca31ae1c64e = 'CLOSE_EMPTY_STATE_DIALOG';
const $e326769329edbd32$export$7ec1c869208a9fdf = 'TOGGLE_EMPTY_STATE_PANEL';
const $e326769329edbd32$export$397c34c503e1422c = ()=>({
        type: $e326769329edbd32$export$8f51b498d82c8c4d
    });
const $e326769329edbd32$export$2a4ad6c2ee7b351a = ()=>({
        type: $e326769329edbd32$export$3ee0ca31ae1c64e
    });
const $e326769329edbd32$export$33ebfbc795cb0b7c = (showPanel)=>({
        type: $e326769329edbd32$export$7ec1c869208a9fdf,
        payload: {
            panelState: showPanel ? 'NOT_CONNECTED' : 'HIDDEN'
        }
    });

});

parcelRegister("4QXBz", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsIssueData", () => $0b9659a2f9876d46$export$7009ae149c507c45);

var $5km34 = parcelRequire("5km34");

var $idwnU = parcelRequire("idwnU");

var $faqOn = parcelRequire("faqOn");
const $0b9659a2f9876d46$var$getSummaryItemCounts = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $5km34.SUMMARY_ITEMS).reduce((items, itemKey)=>{
        const summaryItem = (0, $faqOn.summaryItemSelector)(state, itemKey);
        return summaryItem && typeof summaryItem.count === 'number' ? {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...items,
            [`${itemKey}Count`]: summaryItem.count
        } : items;
    }, {});
const $0b9659a2f9876d46$var$updateInstanceTypeCounts = (instanceTypeCounts, // @ts-expect-error - TS2304 - Cannot find name 'ByInstanceType'.
byInstanceType)=>Object.keys(byInstanceType).reduce((counts, typeKey)=>{
        const typeCountKey = `${typeKey}Count`;
        const updatedCount = typeof counts[typeCountKey] === 'number' ? counts[typeCountKey] + byInstanceType[typeKey] : byInstanceType[typeKey];
        return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...counts,
            [typeCountKey]: updatedCount
        };
    }, instanceTypeCounts);
const $0b9659a2f9876d46$var$getInstanceTypeCounts = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $5km34.SUMMARY_ITEMS).reduce((instanceTypeCounts, itemKey)=>{
        const summaryItem = (0, $faqOn.summaryItemSelector)(state, itemKey);
        return summaryItem && summaryItem.byInstanceType && typeof summaryItem.byInstanceType === 'object' ? $0b9659a2f9876d46$var$updateInstanceTypeCounts(instanceTypeCounts, summaryItem.byInstanceType) : instanceTypeCounts;
    }, {});
const $0b9659a2f9876d46$export$7009ae149c507c45 = (state)=>({
        ...$0b9659a2f9876d46$var$getSummaryItemCounts(state),
        ...$0b9659a2f9876d46$var$getInstanceTypeCounts(state),
        issueId: (0, $idwnU.issueIdSelector)(state),
        issueStatusCategory: (0, $idwnU.issueStatusCategorySelector)(state),
        projectId: (0, $idwnU.projectIdSelector)(state),
        projectType: (0, $idwnU.projectTypeSelector)(state),
        nextGenProject: (0, $idwnU.isSimplifiedProjectSelector)(state),
        analyticsSource: (0, $idwnU.analyticsSourceSelector)(state),
        isSiteAdmin: (0, $idwnU.isSiteAdminSelector)(state),
        isEmptyStateEnabled: true
    });

});
parcelRegister("5km34", function(module, exports) {

$parcel$export(module.exports, "SUMMARY_ITEM_BRANCH", () => $d4ea50ae9cde934b$export$f8cedd52860eb0c6);
$parcel$export(module.exports, "SUMMARY_ITEM_BUILD", () => $d4ea50ae9cde934b$export$6b8ec8efdecdf53a);
$parcel$export(module.exports, "SUMMARY_ITEM_COMMIT", () => $d4ea50ae9cde934b$export$befef22dc4a207fa);
$parcel$export(module.exports, "SUMMARY_ITEM_DEPLOYMENT", () => $d4ea50ae9cde934b$export$142531b80687303b);
$parcel$export(module.exports, "SUMMARY_ITEM_REMOTE_LINKS", () => $d4ea50ae9cde934b$export$c291fab954691bf6);
$parcel$export(module.exports, "SUMMARY_ITEM_PULLREQUEST", () => $d4ea50ae9cde934b$export$2ca8301ae4f309cb);
$parcel$export(module.exports, "SUMMARY_ITEM_REVIEW", () => $d4ea50ae9cde934b$export$e1520d4b87b6e628);
$parcel$export(module.exports, "SUMMARY_ITEM_FEATURE_FLAGS", () => $d4ea50ae9cde934b$export$14c52f7179b512b3);
$parcel$export(module.exports, "OAUTH_ANALYTICS_TYPE", () => $d4ea50ae9cde934b$export$f231da52e4714b2f);
$parcel$export(module.exports, "SUMMARY_ITEMS", () => $d4ea50ae9cde934b$export$fbab704f516d97ea);
const $d4ea50ae9cde934b$export$f8cedd52860eb0c6 = 'branch';
const $d4ea50ae9cde934b$export$6b8ec8efdecdf53a = 'build';
const $d4ea50ae9cde934b$export$befef22dc4a207fa = 'commit';
const $d4ea50ae9cde934b$export$142531b80687303b = 'deployment';
const $d4ea50ae9cde934b$export$c291fab954691bf6 = 'remote-links';
const $d4ea50ae9cde934b$export$2ca8301ae4f309cb = 'pullrequest';
const $d4ea50ae9cde934b$export$e1520d4b87b6e628 = 'review';
const $d4ea50ae9cde934b$export$14c52f7179b512b3 = 'feature-flags';
const $d4ea50ae9cde934b$export$f231da52e4714b2f = 'oAuth';
const $d4ea50ae9cde934b$export$fbab704f516d97ea = [
    $d4ea50ae9cde934b$export$f8cedd52860eb0c6,
    $d4ea50ae9cde934b$export$6b8ec8efdecdf53a,
    $d4ea50ae9cde934b$export$befef22dc4a207fa,
    $d4ea50ae9cde934b$export$142531b80687303b,
    $d4ea50ae9cde934b$export$2ca8301ae4f309cb,
    $d4ea50ae9cde934b$export$e1520d4b87b6e628
];

});

parcelRegister("idwnU", function(module, exports) {

$parcel$export(module.exports, "issueIdSelector", () => $5dcbd1dae2918898$export$31efbca30077ec1e);
$parcel$export(module.exports, "issueAriSelector", () => $5dcbd1dae2918898$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "issueKeySelector", () => $5dcbd1dae2918898$export$d22bc6271070f453);
$parcel$export(module.exports, "issueStatusCategorySelector", () => $5dcbd1dae2918898$export$a10c82b15d578e5c);
$parcel$export(module.exports, "projectIdSelector", () => $5dcbd1dae2918898$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectTypeSelector", () => $5dcbd1dae2918898$export$69316f88206ca90b);
$parcel$export(module.exports, "isSimplifiedProjectSelector", () => $5dcbd1dae2918898$export$d94d544d4b2e1310);
$parcel$export(module.exports, "analyticsSourceSelector", () => $5dcbd1dae2918898$export$85a9d212d56669b4);
$parcel$export(module.exports, "isSiteAdminSelector", () => $5dcbd1dae2918898$export$69b767f18b3bb094);
$parcel$export(module.exports, "projectAriSelector", () => $5dcbd1dae2918898$export$5106f43689b4a85c);
$parcel$export(module.exports, "isJiraAdminSelector", () => $5dcbd1dae2918898$export$7562da76c85fc278);

var $dGvGJ = parcelRequire("dGvGJ");
const $5dcbd1dae2918898$var$contextSelector = (state)=>state.context;
const $5dcbd1dae2918898$export$f7b7935883444b11 = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.locale);
const $5dcbd1dae2918898$export$31efbca30077ec1e = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.issueId);
const $5dcbd1dae2918898$export$a2cdbba2136e72d3 = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.issueAri);
const $5dcbd1dae2918898$export$d22bc6271070f453 = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.issueKey);
const $5dcbd1dae2918898$export$a10c82b15d578e5c = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.issueStatusCategory);
const $5dcbd1dae2918898$export$4c9d6034f65d22f4 = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.projectId);
const $5dcbd1dae2918898$export$69316f88206ca90b = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.projectType);
const $5dcbd1dae2918898$export$d94d544d4b2e1310 = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.nextGenProject);
const $5dcbd1dae2918898$export$85a9d212d56669b4 = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.analyticsSource);
const $5dcbd1dae2918898$export$69b767f18b3bb094 = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.isSiteAdmin);
const $5dcbd1dae2918898$export$5106f43689b4a85c = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.projectAri);
const $5dcbd1dae2918898$export$7562da76c85fc278 = (0, $dGvGJ.createSelector)($5dcbd1dae2918898$var$contextSelector, (context)=>context.isJiraAdmin);

});

parcelRegister("faqOn", function(module, exports) {

$parcel$export(module.exports, "panelStateSelector", () => $da84da9bb0dcdecd$export$4db67466d2142ff6);
$parcel$export(module.exports, "summarySectionMessageSelector", () => $da84da9bb0dcdecd$export$6288a95dc1e9fa82);
$parcel$export(module.exports, "hasBranchCapabilitiesSelector", () => $da84da9bb0dcdecd$export$ce27eee7f896f3ec);
$parcel$export(module.exports, "branchSelector", () => $da84da9bb0dcdecd$export$f6e2a4674b29f42d);
$parcel$export(module.exports, "summaryItemSelector", () => $da84da9bb0dcdecd$export$279a9274584d53c7);
$parcel$export(module.exports, "reviewSummaryItemSelector", () => $da84da9bb0dcdecd$export$906faa0920af59ca);
$parcel$export(module.exports, "buildSummaryItemSelector", () => $da84da9bb0dcdecd$export$827121cd798e25c0);
$parcel$export(module.exports, "deploymentSummaryItemSelector", () => $da84da9bb0dcdecd$export$ec75155dea010df);
$parcel$export(module.exports, "pullRequestSummaryItemSelector", () => $da84da9bb0dcdecd$export$244b92a64afca3ee);
$parcel$export(module.exports, "commitSummaryItemSelector", () => $da84da9bb0dcdecd$export$76e3496587cae227);
$parcel$export(module.exports, "errorsSelector", () => $da84da9bb0dcdecd$export$3c37ade598c5e9ac);
$parcel$export(module.exports, "configErrorsSelector", () => $da84da9bb0dcdecd$export$1289f902b7edde01);
$parcel$export(module.exports, "hasSummaryItemsSelector", () => $da84da9bb0dcdecd$export$549de3bd56af64bd);
$parcel$export(module.exports, "hasSummaryInformationSelector", () => $da84da9bb0dcdecd$export$7b03622ad1f8cf49);
$parcel$export(module.exports, "legacyDataInformationSelector", () => $da84da9bb0dcdecd$export$8ced1f44c2c172d0);
$parcel$export(module.exports, "detailsHasInstanceErrorsSelector", () => $da84da9bb0dcdecd$export$dc780f3efd24e350);
$parcel$export(module.exports, "isEmptyStateDialogShownSelector", () => $da84da9bb0dcdecd$export$2e400ffeacd51ab7);
$parcel$export(module.exports, "createBranchTargetsSelector", () => $da84da9bb0dcdecd$export$6c6618802c6368cd);
$parcel$export(module.exports, "hasCreateBranchTargetsSelector", () => $da84da9bb0dcdecd$export$8513b5682faea8d1);
$parcel$export(module.exports, "hasDevelopmentDataInProjectSelector", () => $da84da9bb0dcdecd$export$298b0b6799269967);
$parcel$export(module.exports, "isLoadingDevPanelSelector", () => $da84da9bb0dcdecd$export$ee4172fcbc68a753);

var $dGvGJ = parcelRequire("dGvGJ");

var $5km34 = parcelRequire("5km34");
const $da84da9bb0dcdecd$var$entitiesSelector = (state)=>state.entities;
const $da84da9bb0dcdecd$export$1e24ad2b2f2c3fc1 = (0, $dGvGJ.createSelector)([
    $da84da9bb0dcdecd$var$entitiesSelector
], (entities)=>entities.devPanel);
const $da84da9bb0dcdecd$export$4db67466d2142ff6 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$export$1e24ad2b2f2c3fc1, (devPanel)=>devPanel.panelState);
const $da84da9bb0dcdecd$export$6288a95dc1e9fa82 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$export$1e24ad2b2f2c3fc1, (devPanel)=>devPanel.showSummarySectionMessage);
/* Summary selectors */ const $da84da9bb0dcdecd$var$hasSummaryItemWithPositiveCount = (summary)=>(0, $5km34.SUMMARY_ITEMS).some(// @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
    (item)=>summary[item] && summary[item].count != null && summary[item].count > 0);
const $da84da9bb0dcdecd$var$hasItems = (items)=>!!(items && items.length);
const $da84da9bb0dcdecd$var$entitiesSummarySelector = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$export$1e24ad2b2f2c3fc1, (devPanel)=>devPanel.summary);
const $da84da9bb0dcdecd$export$ce27eee7f896f3ec = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$export$1e24ad2b2f2c3fc1, (devPanel)=>devPanel.hasBranchCapabilities);
const $da84da9bb0dcdecd$export$f6e2a4674b29f42d = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>{
    if (summary.branch) return summary.branch;
    return null;
});
const $da84da9bb0dcdecd$export$279a9274584d53c7 = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'State'.
(state)=>$da84da9bb0dcdecd$var$entitiesSummarySelector(state), // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
(state, itemType)=>itemType, (summary, itemType)=>{
    if (summary[itemType]) return summary[itemType];
    return null;
});
const $da84da9bb0dcdecd$export$906faa0920af59ca = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>summary[0, $5km34.SUMMARY_ITEM_REVIEW]);
const $da84da9bb0dcdecd$export$827121cd798e25c0 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>summary[0, $5km34.SUMMARY_ITEM_BUILD]);
const $da84da9bb0dcdecd$export$ec75155dea010df = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>summary[0, $5km34.SUMMARY_ITEM_DEPLOYMENT]);
const $da84da9bb0dcdecd$export$244b92a64afca3ee = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>summary[0, $5km34.SUMMARY_ITEM_PULLREQUEST]);
const $da84da9bb0dcdecd$export$76e3496587cae227 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>summary[0, $5km34.SUMMARY_ITEM_COMMIT]);
const $da84da9bb0dcdecd$export$3c37ade598c5e9ac = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>summary.errors);
const $da84da9bb0dcdecd$export$1289f902b7edde01 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>summary.configErrors);
const $da84da9bb0dcdecd$export$549de3bd56af64bd = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>!!$da84da9bb0dcdecd$var$hasSummaryItemWithPositiveCount(summary));
const $da84da9bb0dcdecd$var$hasSummaryErrorsSelector = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>!!(summary && ($da84da9bb0dcdecd$var$hasItems(summary.errors) || $da84da9bb0dcdecd$var$hasItems(summary.configErrors))));
const $da84da9bb0dcdecd$export$7b03622ad1f8cf49 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$export$549de3bd56af64bd, $da84da9bb0dcdecd$var$hasSummaryErrorsSelector, (hasSummaryItems, hasSummaryErrors)=>hasSummaryItems || hasSummaryErrors);
const $da84da9bb0dcdecd$export$8ced1f44c2c172d0 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>summary && summary?.legacyResponseData?.summary);
const $da84da9bb0dcdecd$export$922f0e499aac2772 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>!!summary.branch?.count);
const $da84da9bb0dcdecd$export$e648fd5b118a44e9 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>!!summary.pullrequest?.count);
const $da84da9bb0dcdecd$export$dc780f3efd24e350 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSummarySelector, (summary)=>!!summary.detailsHasInstanceErrors);
const $da84da9bb0dcdecd$export$2e400ffeacd51ab7 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSelector, (entities)=>entities.isEmptyStateDialogShown);
const $da84da9bb0dcdecd$export$6c6618802c6368cd = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSelector, (entities)=>entities.createBranchTargets);
const $da84da9bb0dcdecd$export$8513b5682faea8d1 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$export$6c6618802c6368cd, (targets)=>!!(targets && targets.length > 0));
const $da84da9bb0dcdecd$export$298b0b6799269967 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$export$1e24ad2b2f2c3fc1, (devPanel)=>devPanel.hasDevelopmentDataInProject);
const $da84da9bb0dcdecd$export$ee4172fcbc68a753 = (0, $dGvGJ.createSelector)($da84da9bb0dcdecd$var$entitiesSelector, (entities)=>entities.isLoading);

});




parcelRegister("cqpYx", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $2acf491d6b535b7e$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $2acf491d6b535b7e$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $lzeFL = parcelRequire("lzeFL");

var $gYrS0 = parcelRequire("gYrS0");
const $2acf491d6b535b7e$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    issueId: '',
    issueKey: '',
    issueStatusCategory: '',
    projectId: '',
    projectType: '',
    analyticsSource: null,
    locale: (0, $lzeFL.defaultLocale),
    isSiteAdmin: false,
    issueAri: '',
    nextGenProject: false,
    projectAri: '',
    isJiraAdmin: false
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2acf491d6b535b7e$export$2e2bcd8739ae039 = (state = $2acf491d6b535b7e$export$d4c72bab9d6cc13a, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $gYrS0.SET_CONTEXT:
            return (0, $7uUwQ.freeze)({
                ...state,
                ...payload
            });
        default:
            return state;
    }
};

});
parcelRegister("gYrS0", function(module, exports) {

$parcel$export(module.exports, "SET_CONTEXT", () => $37d1a0dcf6a01991$export$4bc4e62e7d72b94b);
$parcel$export(module.exports, "setContext", () => $37d1a0dcf6a01991$export$2f04de43fe27971a);
const $37d1a0dcf6a01991$export$4bc4e62e7d72b94b = 'SET_CONTEXT';
const $37d1a0dcf6a01991$export$2f04de43fe27971a = (context)=>({
        type: $37d1a0dcf6a01991$export$4bc4e62e7d72b94b,
        payload: context
    });

});


parcelRegister("k8xfJ", function(module, exports) {

$parcel$export(module.exports, "fetchDevPanel", () => $987f3fafca34f5aa$export$90fc97eda5e40724);
$parcel$export(module.exports, "enrichDevPanelWithOneClickLinks", () => $987f3fafca34f5aa$export$9f99316f0f0eb5f);
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("aSIuP");
parcelRequire("7qVV7");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $it1wb = parcelRequire("it1wb");

var $gn1v9 = parcelRequire("gn1v9");

var $kVLXA = parcelRequire("kVLXA");

var $gSIcW = parcelRequire("gSIcW");

var $2YZCu = parcelRequire("2YZCu");

var $5km34 = parcelRequire("5km34");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $cK8fQ = parcelRequire("cK8fQ");

var $4UisK = parcelRequire("4UisK");

var $ifcfz = parcelRequire("ifcfz");

var $iycku = parcelRequire("iycku");

var $idwnU = parcelRequire("idwnU");

var $027Zr = parcelRequire("027Zr");
const $987f3fafca34f5aa$export$2cca46dea398dd67 = ()=>(0, $it1wb.default)((0, $gn1v9.default)(new Date(), {
        weeks: 6
    })).toISOString();
const $987f3fafca34f5aa$export$90fc97eda5e40724 = (action$, store)=>action$.ofType((0, $027Zr.FETCH_DEV_PANEL_REQUEST)).switchMap(({ analyticsEvent: analyticsEvent })=>{
        (0, $cK8fQ.devPanelTimeToLoad).start();
        const state = store.getState();
        const issueAri = (0, $idwnU.issueAriSelector)(state);
        const issueId = (0, $idwnU.issueIdSelector)(state);
        const projectAri = (0, $idwnU.projectAriSelector)(state);
        const updatedFrom = $987f3fafca34f5aa$export$2cca46dea398dd67();
        const isJiraAdmin = (0, $idwnU.isJiraAdminSelector)(state);
        const isSiteAdmin = (0, $idwnU.isSiteAdminSelector)(state);
        return (0, $kVLXA.Observable).zip((0, $4UisK.fetchCreateBranchTargets)(issueId), (0, $iycku.fetchDevSummaryData)(issueAri), (0, $ifcfz.getHasDevelopmentDataInProject)(projectAri, updatedFrom, isJiraAdmin, isSiteAdmin), (createBranchTargets, { summary: summary, bannerType: bannerType, hasBranchCapabilities: hasBranchCapabilities, panelState: panelState }, hasDevelopmentDataInProject)=>(0, $027Zr.fetchDevPanelSuccess)({
                summary: summary || undefined,
                panelState: panelState || undefined,
                bannerType: bannerType || undefined,
                hasBranchCapabilities: !!hasBranchCapabilities,
                createBranchTargets: createBranchTargets,
                hasDevelopmentDataInProject: hasDevelopmentDataInProject
            }, analyticsEvent)).catch(()=>{
            (0, $2YZCu.default).safeWarnWithoutCustomerData('issue.dev-panel.fetch.epic', 'Failed to fetch the devPanel');
            return (0, $kVLXA.Observable).of((0, $027Zr.fetchDevPanelFailure)(analyticsEvent));
        });
    });
const $987f3fafca34f5aa$export$622f497494fcce79 = (summaryBuilds)=>{
    let targetBuildStatesForOneClickUrl;
    if (summaryBuilds?.failedBuildCount === 1) targetBuildStatesForOneClickUrl = [
        'FAILED'
    ];
    else if (summaryBuilds?.failedBuildCount === 0 && summaryBuilds?.successfulBuildCount === 1) targetBuildStatesForOneClickUrl = [
        'SUCCESSFUL'
    ];
    else if (summaryBuilds?.failedBuildCount === 0 && summaryBuilds?.successfulBuildCount === 0 && summaryBuilds?.count === 1) targetBuildStatesForOneClickUrl = [
        'IN_PROGRESS',
        'PENDING',
        'CANCELLED',
        'UNKNOWN'
    ];
    else // empty means that the build summary item will show a count greater than 1. So don't look for url matching target build state.
    targetBuildStatesForOneClickUrl = [];
    return targetBuildStatesForOneClickUrl;
};
const $987f3fafca34f5aa$export$65ec12ccacbb4546 = (summary)=>{
    const branchesCount = summary[0, $5km34.SUMMARY_ITEM_BRANCH]?.count ?? 0;
    const branchesStatisfied = branchesCount >= 1;
    return branchesStatisfied || summary[0, $5km34.SUMMARY_ITEM_COMMIT]?.count === 1 || summary[0, $5km34.SUMMARY_ITEM_PULLREQUEST]?.stateCount === 1 || $987f3fafca34f5aa$export$622f497494fcce79(summary[0, $5km34.SUMMARY_ITEM_BUILD]).length !== 0;
};
const $987f3fafca34f5aa$export$9f99316f0f0eb5f = (action$, store)=>action$.ofType((0, $027Zr.FETCH_DEV_PANEL_SUCCESS)).switchMap(({ payload: { summary: summary }, analyticsEvent: analyticsEvent })=>{
        const state = store.getState();
        const issueId = (0, $idwnU.issueIdSelector)(state);
        if (!summary || !$987f3fafca34f5aa$export$65ec12ccacbb4546(summary)) return (0, $kVLXA.Observable).empty();
        return (0, $ifcfz.query)(issueId).map((details)=>{
            (0, $8zOmE.fireOperationalAnalytics)(// @ts-expect-error - Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
            analyticsEvent, 'developmentDetailsSwagQuery.jiraDevelopmentSummaryDevelopmentField success');
            return (0, $027Zr.fetchDevPanelUrlDetailsSuccess)(details);
        }).catch((e)=>{
            (0, $jcw0u.default)({
                error: e,
                event: analyticsEvent,
                meta: {
                    id: 'developmentDetailsSwagQuery',
                    packageName: 'jiraDevelopmentSummaryDevelopmentField',
                    teamName: 'nova'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $kVLXA.Observable).empty();
        });
    });
const $987f3fafca34f5aa$export$8a87b6f1f86abbd0 = (action$)=>(0, $gSIcW.default)().takeUntil(action$.ofType((0, $027Zr.DEV_PANEL_UNMOUNTED))).switchMap((isVisible)=>{
        if (isVisible !== true) return (0, $kVLXA.Observable).empty();
        return (0, $kVLXA.Observable).of((0, $027Zr.fetchDevPanelRequest)());
    });

});
parcelRegister("gSIcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d01e218c271471$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("iQCJJ");
parcelRequire("d0pqD");

var $laTox = parcelRequire("laTox");
/**
 * Returns a stream of the current page visibility state whenever it changes.
 * Emits 'true' when the page is visible and 'false' when the page is hidden.
 *
 * Will emit `null` if document is not defined.
 *
 * This Observable WILL EMIT a value at the start of the load. If you're using
 * it to trigger refreshes, you should skip 1 value.
 */ const $63d01e218c271471$var$getVisibility$ = ()=>// @ts-expect-error - TS2322 - Type 'Observable<unknown>' is not assignable to type 'Observable<boolean | null>'.
    typeof document !== 'undefined' ? (0, $kVLXA.Observable).fromEvent(document, (0, $laTox.supportedVisiblityEvent))// We want to send the current visibility on a new subscription.
    // If we use `.startWith(isPageVisible())` then new subscribers
    // will get the initial visibility at load and not the current
    // visibility as the initial value.
    .startWith(null).map((0, $laTox.isPageVisible)) : new (0, $cab1K.Subject)().startWith(null);
var $63d01e218c271471$export$2e2bcd8739ae039 = $63d01e218c271471$var$getVisibility$;

});

parcelRegister("cK8fQ", function(module, exports) {

$parcel$export(module.exports, "devPanelTimeToLoad", () => $f58f41231cf6d29c$export$5fdf275a85d26686);

var $dGrdR = parcelRequire("dGrdR");
const $f58f41231cf6d29c$export$5fdf275a85d26686 = (0, $dGrdR.metrics).interaction({
    key: 'devPanelApp.time-to.load',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '300_1000_2500_4000_7000_10000'
    }
});

});

parcelRegister("4UisK", function(module, exports) {

$parcel$export(module.exports, "fetchCreateBranchTargets", () => $91f6fc9b6f3df58d$export$7b4e63bdbf1b6bf5);
parcelRequire("d0pqD");

var $487fd = parcelRequire("487fd");

var $aMnTS = parcelRequire("aMnTS");
const $91f6fc9b6f3df58d$export$7b4e63bdbf1b6bf5 = (issueId)=>(0, $487fd.default)(`/rest/dev-status/1.0/issue/create-branch-targets?issueId=${issueId}`).map(// @ts-expect-error - TS2304 - Cannot find name 'RemoteAppResponse'.
    (response)=>(0, $aMnTS.transformRemoteApps)(response));

});
parcelRegister("aMnTS", function(module, exports) {

$parcel$export(module.exports, "transformRemoteApps", () => $2c61e05ca8f54ec7$export$e4cc182e808e80ea);

var $hKyAu = parcelRequire("hKyAu");
const $2c61e05ca8f54ec7$export$e4cc182e808e80ea = ({ remoteApps: remoteApps = [] })=>remoteApps.map((remoteApp)=>({
            ...remoteApp,
            url: remoteApp.url !== null && remoteApp.url !== undefined ? (0, $hKyAu.toSanitizedUrl)(remoteApp.url) : undefined
        })).filter((target)=>target.url);

});
parcelRegister("hKyAu", function(module, exports) {

$parcel$export(module.exports, "toSanitizedUrl", () => $048f973bab2ee3ff$export$36fdccbdcd093523);

var $5kchp = parcelRequire("5kchp");
const $048f973bab2ee3ff$export$36fdccbdcd093523 = (url)=>(0, $5kchp.sanitizeUrl)(url);

});
parcelRegister("5kchp", function(module, exports) {
'use strict';
var $3e0858899f98084b$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
var $3e0858899f98084b$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
var $3e0858899f98084b$var$urlSchemeRegex = /^([^:]+):/gm;
var $3e0858899f98084b$var$relativeFirstCharacters = [
    '.',
    '/'
];
function $3e0858899f98084b$var$isRelativeUrl(url) {
    return $3e0858899f98084b$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
function $3e0858899f98084b$var$sanitizeUrl(url) {
    if (!url) return 'about:blank';
    var urlScheme, urlSchemeParseResults;
    var sanitizedUrl = url.replace($3e0858899f98084b$var$ctrlCharactersRegex, '');
    if ($3e0858899f98084b$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
    urlSchemeParseResults = sanitizedUrl.match($3e0858899f98084b$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return 'about:blank';
    urlScheme = urlSchemeParseResults[0];
    if ($3e0858899f98084b$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
    return sanitizedUrl;
}
module.exports = {
    sanitizeUrl: $3e0858899f98084b$var$sanitizeUrl
};

});




parcelRegister("ifcfz", function(module, exports) {

$parcel$export(module.exports, "query", () => $940b0fd6b577e333$export$2fa187e846a241c4);
$parcel$export(module.exports, "getHasDevelopmentDataInProject", () => $940b0fd6b577e333$export$13c6bf08097300d7);

var $6Udyx = parcelRequire("6Udyx");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");
parcelRequire("d0pqD");

var $5yJb9 = parcelRequire("5yJb9");

var $6Udyx = parcelRequire("6Udyx");

var $cBLvH = parcelRequire("cBLvH");
const $940b0fd6b577e333$var$OPERATION_NAME = 'DevSummaryPanelOneClickUrls';
const $940b0fd6b577e333$var$innerQuery = ()=>`
    details {
        instanceTypes {
            id
            type
            devStatusErrorMessages
            repository {
                avatarUrl
                name
                branches {
                    createPullRequestUrl
                    name
                    url
                }
                commits{
                    url
                }
                pullRequests {
                    url
                    status
                }
            }
            danglingPullRequests {
                url
                status
            }
            buildProviders {
                id
                builds {
                    url
                    state
                }
            }
         }
    }
`;
const $940b0fd6b577e333$var$swagGraphQLQuery = ()=>`
    query ${$940b0fd6b577e333$var$OPERATION_NAME} ($issueId: ID!) {
        developmentInformation(issueId: $issueId){
            ${$940b0fd6b577e333$var$innerQuery()}
        }
    }`;
const $940b0fd6b577e333$export$2fa187e846a241c4 = (issueId)=>// @ts-expect-error - TS2322 - Type 'Observable<unknown>' is not assignable to type 'Observable<ResponseData>'.
    (0, $cBLvH.query$)('', $940b0fd6b577e333$var$OPERATION_NAME, $940b0fd6b577e333$var$swagGraphQLQuery(), {
        issueId: issueId
    }).map((result)=>({
            data: result
        })).map((result)=>{
        // @ts-expect-error - TS2339 Property 'errors' does not exist on type '{ data: ResponseData; }'.
        if (result.errors && result.errors.length) {
            // @ts-expect-error - TS2339 Property 'errors' does not exist on type '{ data: ResponseData; }'.
            const errorMessages = result.errors// @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
            .map((error)=>error.message)// @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'current' implicitly has an 'any' type.
            .reduce((acc, current)=>`${acc}\n ${current}`, '');
            throw Error(`Error retrieving url details from service: ${errorMessages}`);
        }
        return result;
    });
const $940b0fd6b577e333$export$13c6bf08097300d7 = (projectAri, updatedFrom, isJiraAdmin, isSiteAdmin)=>{
    if (isJiraAdmin || isSiteAdmin) {
        const developmentDataQuery = (0, $6Udyx.default);
        const variables = {
            projectAri: projectAri,
            updatedFrom: updatedFrom
        };
        const request = (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), developmentDataQuery, variables, {
            fetchPolicy: 'store-or-network'
        });
        /* fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
         data will remain saved in the Relay store at any point after the request completes. We need to
         explicitly retain the operation to ensure it doesn't get deleted. See https://relay.dev/docs/api-reference/fetch-query/#behavior */ (0, $5yJb9.default)().retain((0, $eiowN.createOperationDescriptor)((0, $6Udyx.default), variables));
        return request.toPromise().then((result)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const data = result;
            return (data?.devOps?.ariGraph?.branchRelationships?.nodes ?? []).length > 0 || (data?.devOps?.ariGraph?.buildRelationships?.nodes ?? []).length > 0 || (data?.devOps?.ariGraph?.prRelationships?.nodes ?? []).length > 0;
        });
    }
    return Promise.resolve(false);
};

});
parcelRegister("6Udyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $98819ee9208d0af7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b5fcd39ff155b4b7f81d42a73651366>>
 * @relayHash 92b74832e1427424c007d113f6dffd74
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 397fdbc6c0cc480189efdc0912beed08f87eb4ea62f247a0b2b871b55ab34b30
const $98819ee9208d0af7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updatedFrom"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "from",
        "variableName": "projectAri"
    }, v2 = {
        "kind": "Variable",
        "name": "updatedFrom",
        "variableName": "updatedFrom"
    }, v3 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v4 = [
        {
            "concreteType": "AriGraphRelationship",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ], v5 = [
        {
            "concreteType": "DevOps",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AriGraph",
                    "kind": "LinkedField",
                    "name": "ariGraph",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "branchRelationships",
                            "args": [
                                {
                                    "fields": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-branch"
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filter"
                                },
                                v3 /*: any*/ 
                            ],
                            "concreteType": "AriGraphRelationshipConnection",
                            "kind": "LinkedField",
                            "name": "relationships",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "buildRelationships",
                            "args": [
                                {
                                    "fields": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-build"
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filter"
                                },
                                v3 /*: any*/ 
                            ],
                            "concreteType": "AriGraphRelationshipConnection",
                            "kind": "LinkedField",
                            "name": "relationships",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "alias": "prRelationships",
                            "args": [
                                {
                                    "fields": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-pr"
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filter"
                                },
                                v3 /*: any*/ 
                            ],
                            "concreteType": "AriGraphRelationshipConnection",
                            "kind": "LinkedField",
                            "name": "relationships",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "detailsHasDevelopmentDataInProjectQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "detailsHasDevelopmentDataInProjectQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "id": "397fdbc6c0cc480189efdc0912beed08f87eb4ea62f247a0b2b871b55ab34b30",
            "metadata": {},
            "name": "detailsHasDevelopmentDataInProjectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$98819ee9208d0af7$var$node.hash = "23fe9927a99afda98b0233664e8a0667";
var $98819ee9208d0af7$export$2e2bcd8739ae039 = $98819ee9208d0af7$var$node;

});

parcelRegister("cBLvH", function(module, exports) {

$parcel$export(module.exports, "query$", () => $b2e62d4903324e0d$export$a332dd84c3221bf2);

var $4nUsC = parcelRequire("4nUsC");
const $b2e62d4903324e0d$export$a332dd84c3221bf2 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $4nUsC.operation$)('query', baseUrl, operationName, query, variables, analyticOptions);

});
parcelRegister("4nUsC", function(module, exports) {

$parcel$export(module.exports, "operation$", () => $9d6dd91dc35e6aa9$export$cbc7c612df05bda);
parcelRequire("fp4O3");
parcelRequire("3q49N");
parcelRequire("inj9P");
parcelRequire("64ZAE");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $9XE6b = parcelRequire("9XE6b");

var $aZFhV = parcelRequire("aZFhV");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $dGrdR = parcelRequire("dGrdR");

var $2YZCu = parcelRequire("2YZCu");

var $kobfu = parcelRequire("kobfu");

var $487fd = parcelRequire("487fd");

var $fnyT4 = parcelRequire("fnyT4");

var $4tcSU = parcelRequire("4tcSU");

var $fjcgS = parcelRequire("fjcgS");

var $4R6GH = parcelRequire("4R6GH");

var $cNrxd = parcelRequire("cNrxd");

var $04zaL = parcelRequire("04zaL");
const $9d6dd91dc35e6aa9$var$sendOperationalEvent = (analyticKey, statusCode)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'swag operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily
            },
            source: 'swagOperation'
        });
    });
};
const $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark = (analyticKey, slo, statusCode, concurrentId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
bm3Interaction)=>{
    if (analyticKey !== undefined) {
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, statusCode);
        if (bm3Interaction) bm3Interaction.cancel();
    }
};
const $9d6dd91dc35e6aa9$var$callSwag$ = ({ operationName: operationName, query: query, variables: variables, action: action, headersProcessor: headersProcessor })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let headers = {};
    // set empty xsrfToken for SSR as cookies are unavailable
    const xsrfToken = false ? '' : (0, $4tcSU.default)();
    if (action === 'mutation') {
        if (!xsrfToken) (0, $2YZCu.default).safeErrorWithoutCustomerData('board.xsrf-token.load.failure', 'XSRF Token failed to load');
        headers = {
            'atl-xsrf-token': xsrfToken
        };
    }
    return (0, $487fd.default)(`/jsw2/graphql?operation=${operationName}`, {
        method: 'POST',
        body: JSON.stringify({
            operationName: operationName,
            query: query,
            variables: variables
        }),
        headers: headers,
        headersProcessor: headersProcessor
    });
};
const $9d6dd91dc35e6aa9$export$cbc7c612df05bda = (action, baseUrl, operationName, query, variables, analyticOptions)=>{
    const { analyticKey: analyticKey, slo: slo, useBm3Interaction: useBm3Interaction, concurrentMetricDefinition: concurrentMetricDefinition } = analyticOptions || {};
    let traceId = '';
    const headersProcessor = (headers)=>{
        traceId = headers.get((0, $fnyT4.TRACE_ID_HEADER)) || '';
    };
    const concurrentId = (0, $7Jxgt.v4)();
    let bm3Interaction = null;
    if (analyticKey && useBm3Interaction) bm3Interaction = (0, $dGrdR.metrics).interaction({
        key: analyticKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: '1000_2000_3000_4000_5000_6000'
        }
    });
    return (0, $kVLXA.Observable).defer(()=>{
        if (bm3Interaction) bm3Interaction.start();
        if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).start();
        return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        });
    }).catch((error)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const isRetryStatusCode = [
            502,
            503,
            504
        ].includes(Number(statusCode));
        if (isRetryStatusCode && action === 'query') return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        }).do(()=>{
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: true,
                retryStatusCode: null
            });
        }, (retryError)=>{
            const retryStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(retryError, [
                'statusCode'
            ], null);
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: false,
                retryStatusCode: retryStatusCode
            });
        });
        // throw exception to the next level
        return (0, $kVLXA.Observable).throw(error);
    })// catch network error
    .catch((error)=>{
        const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const errorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'name'
        ], null);
        const swagError = new (0, $cNrxd.SwagError)({
            networkError: error,
            traceId: traceId
        });
        const hash = (0, $kobfu.getErrorHash)(swagError);
        (0, $04zaL.logRestNetworkError)(e, statusCode, operationName, errorName, hash);
        $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
        return (0, $kVLXA.Observable).throw(swagError);
    }).flatMap((response)=>{
        if (!response || !response.data) (0, $04zaL.logRestParsingError)('empty response.data', operationName);
        try {
            // SWAG errors from response
            if (response.errors) {
                if (response.errors.length > 100) {
                    if ((0, $4R6GH.fg)('tnk_try_to_mitigate_unknown_backlog_errors')) {
                        const errorWithMaxStatusCode = response.errors.filter((error)=>error.extensions?.statusCode).reduce((currentMax, current)=>{
                            const currentStatusCode = Number((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(current, [
                                'extensions',
                                'statusCode'
                            ]));
                            const maxStatusCode = currentMax ? Number((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(currentMax, [
                                'extensions',
                                'statusCode'
                            ])) : 0;
                            return currentStatusCode > maxStatusCode ? current : currentMax;
                        }, null);
                        const statusCode = Number(errorWithMaxStatusCode?.extensions?.statusCode) || null;
                        let genericMessage = `Too many Errors in response for ${operationName} (${response.errors.length} errors)`;
                        if (errorWithMaxStatusCode) genericMessage += `. With highest status code error message of: "${errorWithMaxStatusCode.message}"`;
                        (0, $04zaL.logRestError)([
                            genericMessage
                        ], null, operationName, 'too-many-errors');
                        $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, null, concurrentId, bm3Interaction);
                        return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                            graphQLErrors: [
                                {
                                    message: genericMessage,
                                    path: [
                                        genericMessage
                                    ],
                                    extensions: {
                                        statusCode: statusCode,
                                        errorType: 'too-many-errors'
                                    }
                                }
                            ],
                            traceId: traceId
                        }));
                    }
                    const genericMessage = `Too many Errors in response for ${operationName}`;
                    (0, $04zaL.logRestError)([
                        genericMessage
                    ], null, operationName, 'too-many-errors');
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, null, concurrentId, bm3Interaction);
                    return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                        graphQLErrors: [
                            {
                                message: genericMessage,
                                path: [
                                    genericMessage
                                ],
                                extensions: {
                                    statusCode: null,
                                    errorType: 'too-many-errors'
                                }
                            }
                        ],
                        traceId: traceId
                    }));
                }
                const payload = response.errors.map((e)=>{
                    const { path: path, message: message } = e;
                    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'statusCode'
                    ], null);
                    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'errorType'
                    ], undefined);
                    const userMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'userMessage'
                    ], undefined);
                    (0, $04zaL.logRestError)(path, statusCode, operationName, errorType);
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
                    return {
                        message: message,
                        path: path,
                        extensions: {
                            statusCode: statusCode ? Number(statusCode) : null,
                            errorType: errorType,
                            userMessage: userMessage
                        }
                    };
                });
                return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                    graphQLErrors: payload,
                    traceId: traceId
                }));
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
            (0, $04zaL.logRestParsingError)(e, operationName);
            $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, 'unknown', concurrentId, bm3Interaction);
            throw error;
        }
        if (analyticKey !== undefined) {
            // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Response<Data>'.
            $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, response.statusCode ?? '200');
            if (bm3Interaction) bm3Interaction.stop();
            if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).stop();
        }
        return (0, $kVLXA.Observable).of(response.data);
    });
};

});
parcelRegister("cNrxd", function(module, exports) {

$parcel$export(module.exports, "SwagError", () => $116bdf44a4142aa3$export$c6b77322a15ada4f);
$parcel$export(module.exports, "isJson", () => $116bdf44a4142aa3$export$952e1d8683e4d0c4);
$parcel$export(module.exports, "isFetchError", () => $116bdf44a4142aa3$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isSwagError", () => $116bdf44a4142aa3$export$7d7253f3a1a7c031);

var $jJZqs = parcelRequire("jJZqs");
const $116bdf44a4142aa3$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `GraphQL error: ${errorMessage}\n`;
    });
    if (err.networkError) message += `Network error: ${err.networkError.message}\n`;
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $116bdf44a4142aa3$export$c6b77322a15ada4f extends Error {
    constructor({ graphQLErrors: graphQLErrors, networkError: networkError, errorMessage: errorMessage, traceId: traceId = '' }){
        super(errorMessage), this.graphQLErrors = [], this.networkError = null, // SWAG trace id, extracted from "atl-traceid" response-header
        // Helps to find relevant error in SWAG logs
        this.traceId = '';
        this.graphQLErrors = graphQLErrors || [];
        this.networkError = networkError || null;
        if (!errorMessage) this.message = $116bdf44a4142aa3$var$generateErrorMessage(this);
        else this.message = errorMessage;
        this.name = this.constructor.name;
        this.traceId = traceId;
        this.cause = networkError || graphQLErrors?.[0];
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(this.message).stack;
    }
    skipSentry() {
        return this.networkError != null || this.graphQLErrors.length > 0;
    }
}
const $116bdf44a4142aa3$export$952e1d8683e4d0c4 = (value)=>{
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $116bdf44a4142aa3$export$96f7e6db4105d70c = (error)=>error !== null && typeof error === 'object' && error instanceof (0, $jJZqs.default);
const $116bdf44a4142aa3$export$7d7253f3a1a7c031 = (error)=>{
    if (error !== null && typeof error === 'object' && error instanceof $116bdf44a4142aa3$export$c6b77322a15ada4f) return 'graphQLErrors' in error || 'networkError' in error;
    return false;
};

});

parcelRegister("04zaL", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $1590485f1b901936$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $1590485f1b901936$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $1590485f1b901936$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $1590485f1b901936$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $1590485f1b901936$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $1590485f1b901936$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $1590485f1b901936$export$3e50530825dee9d1);

var $2YZCu = parcelRequire("2YZCu");
const $1590485f1b901936$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $2YZCu.default).safeErrorWithoutCustomerData(type, m, params);
};
const $1590485f1b901936$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $1590485f1b901936$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$1590485f1b901936$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $1590485f1b901936$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $1590485f1b901936$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $1590485f1b901936$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $1590485f1b901936$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $1590485f1b901936$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $1590485f1b901936$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $1590485f1b901936$export$25d52be9f4671e9e = (error, queryName)=>{
    $1590485f1b901936$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $1590485f1b901936$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $2YZCu.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $1590485f1b901936$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $2YZCu.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});




parcelRegister("iycku", function(module, exports) {

$parcel$export(module.exports, "fetchDevSummaryData", () => $746655b5df02298e$export$cf3f33145959151a);
parcelRequire("9o0uh");

var $kVLXA = parcelRequire("kVLXA");

var $dRAiH = parcelRequire("dRAiH");
const $746655b5df02298e$export$cf3f33145959151a = (issueAri)=>(0, $kVLXA.Observable).fromPromise((0, $dRAiH.fetchDevSummaryData)(issueAri));
const $746655b5df02298e$export$ead66e42ed1ccbb = (_baseUrl)=>fetch('/rest/atlassian-connect/latest/addons-gh4j/properties/is-configured').then((response)=>response.status === 200 ? response.json() : Promise.resolve(null));

});
parcelRegister("dRAiH", function(module, exports) {

$parcel$export(module.exports, "fetchDevSummaryData", () => $a6f7bbbaf6a30eb1$export$cf3f33145959151a);

var $gFUjk = parcelRequire("gFUjk");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $5yJb9 = parcelRequire("5yJb9");

var $gFUjk = parcelRequire("gFUjk");

var $5EDwy = parcelRequire("5EDwy");
const $a6f7bbbaf6a30eb1$export$cf3f33145959151a = (issueAri)=>{
    /* eslint-disable @atlassian/relay/unused-fields */ const query = (0, $gFUjk.default);
    /* eslint-enable @atlassian/relay/unused-fields */ const variables = {
        issueId: issueAri
    };
    const request = (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), query, variables, {
        fetchPolicy: 'store-or-network'
    });
    /* fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
      data will remain saved in the Relay store at any point after the request completes. We need to
      explicitly retain the operation to ensure it doesn't get deleted. See https://relay.dev/docs/api-reference/fetch-query/#behavior */ (0, $5yJb9.default)().retain((0, $eiowN.createOperationDescriptor)((0, $gFUjk.default), variables));
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return request.toPromise().then((summary)=>(0, $5EDwy.transformSummary)(summary));
};

});
parcelRegister("gFUjk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a34dff6219ae68c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53b8a068a359283acd10e01a066694e0>>
 * @relayHash 1fa04742645fc628264ccada8ffe90a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4b267c1054c9c8b62435530871c2db879a6fd9d0a1debb12c0b384f64029369
const $a34dff6219ae68c5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "hasBranchCapabilities"
    }, v3 = {
        "kind": "ScalarField",
        "name": "panelState"
    }, v4 = {
        "kind": "ScalarField",
        "name": "devOpsIssuePanelBanner"
    }, v5 = {
        "kind": "ScalarField",
        "name": "count"
    }, v6 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v7 = [
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "JiraIssueBranchDevSummary",
        "kind": "LinkedField",
        "name": "overall",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "concreteType": "JiraIssueDevSummaryByProvider",
        "kind": "LinkedField",
        "name": "summaryByProvider",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "providerId"
            },
            v9 /*: any*/ ,
            v5 /*: any*/ 
        ]
    }, v11 = {
        "concreteType": "JiraIssueCommitDevSummary",
        "kind": "LinkedField",
        "name": "overall",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v12 = {
        "kind": "ScalarField",
        "name": "state"
    }, v13 = {
        "kind": "ScalarField",
        "name": "stateCount"
    }, v14 = {
        "concreteType": "JiraIssuePullRequestDevSummary",
        "kind": "LinkedField",
        "name": "overall",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v12 /*: any*/ ,
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "open"
            }
        ]
    }, v15 = {
        "concreteType": "JiraIssueBuildDevSummary",
        "kind": "LinkedField",
        "name": "overall",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "failedBuildCount"
            },
            {
                "kind": "ScalarField",
                "name": "successfulBuildCount"
            },
            {
                "kind": "ScalarField",
                "name": "unknownBuildCount"
            }
        ]
    }, v16 = {
        "concreteType": "JiraIssueReviewDevSummary",
        "kind": "LinkedField",
        "name": "overall",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v12 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v17 = {
        "concreteType": "JiraIssueDeploymentEnvironment",
        "kind": "LinkedField",
        "name": "topEnvironments",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "title"
            }
        ]
    }, v18 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "concreteType": "JiraIssueDevSummaryErrorProviderInstance",
            "kind": "LinkedField",
            "name": "instance",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "baseUrl"
                }
            ]
        }
    ], v19 = {
        "concreteType": "JiraIssueDevSummaryError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": v18 /*: any*/ 
    }, v20 = {
        "concreteType": "JiraIssueDevSummaryError",
        "kind": "LinkedField",
        "name": "configErrors",
        "plural": true,
        "selections": v18 /*: any*/ 
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesMainJiraDevSummaryDevInfoSummaryQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraDevOpsQuery",
                                    "kind": "LinkedField",
                                    "name": "devOps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v1 /*: any*/ ,
                                                "concreteType": "JiraDevOpsIssuePanel",
                                                "kind": "LinkedField",
                                                "name": "devOpsIssuePanel",
                                                "plural": false,
                                                "selections": [
                                                    v2 /*: any*/ ,
                                                    v3 /*: any*/ ,
                                                    v4 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraIssueDevSummaryResult",
                                                        "kind": "LinkedField",
                                                        "name": "devSummaryResult",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueDevSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "devSummary",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "branch",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v8 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.branch.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.branch.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.branch"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "commit",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v11 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.commit.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.commit.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.commit"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "pullrequest",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v14 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.pullrequest.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.pullrequest.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.pullrequest"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "build",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v15 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.build.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.build.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.build"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "review",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v16 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.review.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.review.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.review"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "deploymentEnvironments",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "RequiredField",
                                                                                                    "field": v17 /*: any*/ ,
                                                                                                    "action": "THROW",
                                                                                                    "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.deploymentEnvironments.overall.topEnvironments"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.deploymentEnvironments.overall"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v10 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.deploymentEnvironments.summaryByProvider"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary.deploymentEnvironments"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.devOps.devOpsIssuePanel.devSummaryResult.devSummary"
                                                            },
                                                            v19 /*: any*/ ,
                                                            v20 /*: any*/ 
                                                        ]
                                                    },
                                                    v21 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.devOps.devOpsIssuePanel"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.devOps"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesMainJiraDevSummaryDevInfoSummaryQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraDevOpsIssuePanel",
                                    "kind": "LinkedField",
                                    "name": "devOpsIssuePanel",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueDevSummaryResult",
                                            "kind": "LinkedField",
                                            "name": "devSummaryResult",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "devSummary",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "branch",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "commit",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "pullrequest",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "build",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "review",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "deploymentEnvironments",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "overall",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v21 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f4b267c1054c9c8b62435530871c2db879a6fd9d0a1debb12c0b384f64029369",
            "metadata": {},
            "name": "servicesMainJiraDevSummaryDevInfoSummaryQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a34dff6219ae68c5$var$node.hash = "9ab7eb465e7cc94e7d42163b251e7887";
var $a34dff6219ae68c5$export$2e2bcd8739ae039 = $a34dff6219ae68c5$var$node;

});

parcelRegister("5EDwy", function(module, exports) {

$parcel$export(module.exports, "transformSummary", () => $5fc5a2f267afd183$export$18d1fe37ef2c5ee2);

var $bMyd4 = parcelRequire("bMyd4");

var $5km34 = parcelRequire("5km34");
// @ts-expect-error - TS7006 - Parameter 'date' implicitly has an 'any' type.
const $5fc5a2f267afd183$var$transformDate = (date)=>{
    if (date !== undefined && date !== null) return (0, $bMyd4.default)(date);
    return null;
};
const $5fc5a2f267afd183$var$transformError = ({ instance: instance, message: message })=>({
        instanceName: instance?.name ?? '',
        instanceUrl: instance?.baseUrl ?? '',
        error: message ?? ''
    });
const $5fc5a2f267afd183$var$transformBySummaryProvider = (summaryByProvider)=>// @ts-expect-error - TS2322 - Type '{ readonly count: number | null; readonly name: string | null; readonly providerId: string | null; } | {}' is not assignable to type 'ByInstanceType'.
    summaryByProvider ? summaryByProvider.reduce((instanceTypes, providerInstance)=>{
        if (providerInstance.providerId !== null && providerInstance.providerId !== undefined) return {
            [providerInstance.providerId]: providerInstance.count,
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...instanceTypes
        };
        return instanceTypes;
    }, {}) : {};
function $5fc5a2f267afd183$var$getPullRequestState(state) {
    switch(state){
        case 'DECLINED':
            return 'DECLINED';
        case 'MERGED':
            return 'MERGED';
        case 'OPEN':
            return 'OPEN';
        case 'DRAFT':
            return 'DRAFT';
        default:
            return null;
    }
}
const $5fc5a2f267afd183$var$transformPullRequest = (summary)=>{
    const { pullrequest: pullrequest } = summary;
    return {
        url: null,
        count: pullrequest?.overall?.count ?? 0,
        lastUpdated: $5fc5a2f267afd183$var$transformDate(pullrequest?.overall?.lastUpdated ?? null),
        stateCount: pullrequest?.overall?.stateCount ?? 0,
        state: $5fc5a2f267afd183$var$getPullRequestState(pullrequest?.overall?.state),
        byInstanceType: $5fc5a2f267afd183$var$transformBySummaryProvider(pullrequest?.summaryByProvider)
    };
};
const $5fc5a2f267afd183$var$transformBuild = (summary)=>{
    const { build: build } = summary;
    return {
        url: null,
        count: build?.overall?.count ?? 0,
        lastUpdated: $5fc5a2f267afd183$var$transformDate(build.overall.lastUpdated),
        failedBuildCount: build?.overall?.failedBuildCount ?? 0,
        successfulBuildCount: build?.overall?.successfulBuildCount ?? 0,
        unknownBuildCount: build?.overall?.unknownBuildCount ?? 0,
        byInstanceType: $5fc5a2f267afd183$var$transformBySummaryProvider(build?.summaryByProvider)
    };
};
function $5fc5a2f267afd183$var$getReviewState(state) {
    switch(state){
        case 'APPROVAL':
            return 'APPROVAL';
        case 'CLOSED':
            return 'CLOSED';
        case 'DEAD':
            return 'DEAD';
        case 'DRAFT':
            return 'DRAFT';
        case 'REJECTED':
            return 'REJECTED';
        case 'REVIEW':
            return 'REVIEW';
        case 'SUMMARIZE':
            return 'SUMMARIZE';
        case 'UNKNOWN':
            return 'UNKNOWN';
        default:
            return null;
    }
}
const $5fc5a2f267afd183$var$transformReview = (summary)=>{
    const { review: review } = summary;
    return {
        count: review?.overall?.count ?? 0,
        lastUpdated: $5fc5a2f267afd183$var$transformDate(review?.overall?.lastUpdated),
        stateCount: review?.overall?.stateCount ?? 0,
        state: $5fc5a2f267afd183$var$getReviewState(review?.overall?.state),
        byInstanceType: $5fc5a2f267afd183$var$transformBySummaryProvider(review?.summaryByProvider)
    };
};
const $5fc5a2f267afd183$var$transformCommit = (summary)=>{
    const { commit: commit } = summary;
    return {
        url: null,
        count: commit?.overall?.count ?? 0,
        lastUpdated: $5fc5a2f267afd183$var$transformDate(commit?.overall?.lastUpdated),
        byInstanceType: $5fc5a2f267afd183$var$transformBySummaryProvider(commit?.summaryByProvider)
    };
};
const $5fc5a2f267afd183$var$transformBranch = (summary)=>{
    const { branch: branch } = summary;
    return {
        url: null,
        count: branch?.overall?.count ?? 0,
        lastUpdated: $5fc5a2f267afd183$var$transformDate(branch?.overall?.lastUpdated),
        byInstanceType: $5fc5a2f267afd183$var$transformBySummaryProvider(branch?.summaryByProvider)
    };
};
const $5fc5a2f267afd183$var$transformDeployment = (summary)=>{
    const { deploymentEnvironments: deploymentEnvironments } = summary;
    return {
        count: deploymentEnvironments?.overall?.count ?? 0,
        environments: (deploymentEnvironments?.overall?.topEnvironments ?? []).map((environment)=>environment?.title ?? ''),
        byInstanceType: $5fc5a2f267afd183$var$transformBySummaryProvider(deploymentEnvironments?.summaryByProvider)
    };
};
// @ts-expect-error - TS7006 - Parameter 'byProvider' implicitly has an 'any' type.
const $5fc5a2f267afd183$var$mapToLegacyByInstanceType = (byProvider)=>byProvider.reduce(// @ts-expect-error - TS7006 - Parameter 'instanceAcc' implicitly has an 'any' type. | TS7031 - Binding element 'providerId' implicitly has an 'any' type. | TS7031 - Binding element 'name' implicitly has an 'any' type. | TS7031 - Binding element 'count' implicitly has an 'any' type.
    (instanceAcc, { providerId: providerId, name: name, count: count })=>providerId !== null && providerId !== undefined ? {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...instanceAcc,
            [providerId]: {
                name: name,
                count: count
            }
        } : instanceAcc, {});
const $5fc5a2f267afd183$var$mapToLegacyDataStructure = (result)=>({
        configErrors: (result.configErrors ?? []).map((error)=>({
                instance: error.instance,
                error: error.message
            })),
        errors: (result.errors ?? []).map((error)=>({
                instance: error.instance,
                error: error.message
            })),
        summary: {
            branch: {
                overall: {
                    count: result.devSummary.branch.overall.count || 0,
                    lastUpdated: result.devSummary.branch.overall.lastUpdated || ''
                },
                byInstanceType: $5fc5a2f267afd183$var$mapToLegacyByInstanceType(result.devSummary.branch.summaryByProvider)
            },
            repository: {
                overall: {
                    count: result.devSummary.commit.overall.count || 0,
                    lastUpdated: result.devSummary.commit.overall.lastUpdated || ''
                },
                byInstanceType: $5fc5a2f267afd183$var$mapToLegacyByInstanceType(result.devSummary.commit.summaryByProvider)
            },
            pullrequest: {
                overall: {
                    count: result.devSummary.pullrequest.overall.count || 0,
                    lastUpdated: result.devSummary.pullrequest.overall.lastUpdated || '',
                    state: $5fc5a2f267afd183$var$getPullRequestState(result.devSummary.pullrequest.overall.state),
                    stateCount: result.devSummary.pullrequest.overall.stateCount || 0,
                    open: result.devSummary.pullrequest.overall.open || false
                },
                byInstanceType: $5fc5a2f267afd183$var$mapToLegacyByInstanceType(result.devSummary.pullrequest.summaryByProvider)
            },
            build: {
                overall: {
                    count: result.devSummary.build.overall.count || 0,
                    lastUpdated: result.devSummary.build.overall.lastUpdated || '',
                    failedBuildCount: result.devSummary.build.overall.failedBuildCount || 0,
                    successfulBuildCount: result.devSummary.build.overall.successfulBuildCount || 0,
                    unknownBuildCount: result.devSummary.build.overall.unknownBuildCount || 0
                },
                byInstanceType: $5fc5a2f267afd183$var$mapToLegacyByInstanceType(result.devSummary.build.summaryByProvider)
            },
            review: {
                overall: {
                    count: result.devSummary.review.overall.count || 0,
                    lastUpdated: result.devSummary.review.overall.lastUpdated || '',
                    state: $5fc5a2f267afd183$var$getReviewState(result.devSummary.review.overall.state),
                    stateCount: result.devSummary.review.overall.stateCount || 0
                },
                byInstanceType: $5fc5a2f267afd183$var$mapToLegacyByInstanceType(result.devSummary.review.summaryByProvider)
            },
            'deployment-environment': {
                overall: {
                    count: result.devSummary.deploymentEnvironments.overall.count || 0,
                    lastUpdated: '',
                    topEnvironments: [],
                    showProjects: false,
                    successfulCount: 0
                },
                byInstanceType: $5fc5a2f267afd183$var$mapToLegacyByInstanceType(result.devSummary.deploymentEnvironments.summaryByProvider)
            }
        }
    });
const $5fc5a2f267afd183$export$72ddd42e3cc8539f = (result)=>{
    if (!result) return {
        legacyResponseData: undefined,
        [(0, $5km34.SUMMARY_ITEM_PULLREQUEST)]: undefined,
        [(0, $5km34.SUMMARY_ITEM_BUILD)]: undefined,
        [(0, $5km34.SUMMARY_ITEM_REVIEW)]: undefined,
        [(0, $5km34.SUMMARY_ITEM_COMMIT)]: undefined,
        [(0, $5km34.SUMMARY_ITEM_BRANCH)]: undefined,
        [(0, $5km34.SUMMARY_ITEM_DEPLOYMENT)]: undefined,
        errors: [],
        configErrors: []
    };
    const { errors: errors, configErrors: configErrors, devSummary: summary } = result;
    return {
        // TODO: legacyResponseData is only used for legacy dialogue, needs to be cleaned up when legacy dialogue is removed.
        legacyResponseData: $5fc5a2f267afd183$var$mapToLegacyDataStructure(result),
        [(0, $5km34.SUMMARY_ITEM_BRANCH)]: $5fc5a2f267afd183$var$transformBranch(summary),
        [(0, $5km34.SUMMARY_ITEM_COMMIT)]: $5fc5a2f267afd183$var$transformCommit(summary),
        [(0, $5km34.SUMMARY_ITEM_PULLREQUEST)]: $5fc5a2f267afd183$var$transformPullRequest(summary),
        [(0, $5km34.SUMMARY_ITEM_BUILD)]: $5fc5a2f267afd183$var$transformBuild(summary),
        [(0, $5km34.SUMMARY_ITEM_REVIEW)]: $5fc5a2f267afd183$var$transformReview(summary),
        [(0, $5km34.SUMMARY_ITEM_DEPLOYMENT)]: $5fc5a2f267afd183$var$transformDeployment(summary),
        errors: errors ? errors.map($5fc5a2f267afd183$var$transformError) : [],
        configErrors: configErrors ? configErrors.map($5fc5a2f267afd183$var$transformError) : []
    };
};
function $5fc5a2f267afd183$var$getPanelState(state) {
    switch(state){
        case 'DEV_SUMMARY':
            return 'DEV_SUMMARY';
        case 'NOT_CONNECTED':
            return 'NOT_CONNECTED';
        case 'HIDDEN':
        default:
            return 'HIDDEN';
    }
}
function $5fc5a2f267afd183$var$getDevOpsIssuePanelBanner(item) {
    switch(item){
        case 'ISSUE_KEY_ONBOARDING':
            return 'ISSUE_KEY_ONBOARDING';
        default:
            return null;
    }
}
const $5fc5a2f267afd183$export$18d1fe37ef2c5ee2 = (relaySummary)=>{
    const issuePanelSummary = relaySummary.jira.devOps.devOpsIssuePanel;
    return {
        summary: $5fc5a2f267afd183$export$72ddd42e3cc8539f(issuePanelSummary.devSummaryResult),
        panelState: $5fc5a2f267afd183$var$getPanelState(issuePanelSummary.panelState),
        bannerType: $5fc5a2f267afd183$var$getDevOpsIssuePanelBanner(issuePanelSummary.devOpsIssuePanelBanner),
        hasBranchCapabilities: issuePanelSummary.hasBranchCapabilities || false
    };
};

});




parcelRegister("eoX8A", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $a873d73491707649$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $a873d73491707649$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $cK8fQ = parcelRequire("cK8fQ");

var $7IqTJ = parcelRequire("7IqTJ");

var $027Zr = parcelRequire("027Zr");
const $a873d73491707649$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    devPanel: {
        summary: {},
        panelState: 'HIDDEN',
        showSummarySectionMessage: false,
        hasBranchCapabilities: false,
        hasDevelopmentDataInProject: false
    },
    isLoading: false,
    createBranchTargets: [],
    // To show the empty state diag.
    isEmptyStateDialogShown: false
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a873d73491707649$export$2e2bcd8739ae039 = (state = $a873d73491707649$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $027Zr.FETCH_DEV_PANEL_REQUEST:
            return (0, $7uUwQ.set)(state, 'isLoading', true);
        case 0, $027Zr.FETCH_DEV_PANEL_SUCCESS:
            {
                (0, $cK8fQ.devPanelTimeToLoad).stop();
                const updatedState = (0, $7uUwQ.chain)(state).set('createBranchTargets', action.payload.createBranchTargets).set('isLoading', false).value();
                return (0, $7uUwQ.set)(updatedState, 'devPanel', {
                    summary: action.payload.summary,
                    panelState: action.payload.panelState,
                    hasBranchCapabilities: action.payload.hasBranchCapabilities,
                    showSummarySectionMessage: action.payload.bannerType === 'ISSUE_KEY_ONBOARDING',
                    hasDevelopmentDataInProject: action.payload.hasDevelopmentDataInProject
                });
            }
        case 0, $027Zr.FETCH_DEV_PANEL_URL_DETAILS_SUCCESS:
            {
                const currentSummary = state.devPanel.summary;
                if (currentSummary) {
                    const enrichedSummary = (0, $7IqTJ.enrichSummary)(currentSummary, action.payload);
                    return (0, $7uUwQ.setIn)(state, [
                        'devPanel',
                        'summary'
                    ], enrichedSummary);
                }
                return state;
            }
        case 0, $027Zr.FETCH_DEV_PANEL_FAILURE:
            (0, $cK8fQ.devPanelTimeToLoad).cancel();
            return (0, $7uUwQ.set)(state, 'isLoading', false);
        case 0, $027Zr.SHOW_EMPTY_STATE_DIALOG:
            return (0, $7uUwQ.set)(state, 'isEmptyStateDialogShown', true);
        case 0, $027Zr.CLOSE_EMPTY_STATE_DIALOG:
            return (0, $7uUwQ.set)(state, 'isEmptyStateDialogShown', false);
        case 0, $027Zr.TOGGLE_EMPTY_STATE_PANEL:
            return (0, $7uUwQ.set)(state, 'devPanel', {
                ...state.devPanel,
                panelState: action.payload.panelState
            });
        case 0, $027Zr.TOGGLE_SUMMARY_SECTION_MESSAGE:
            return (0, $7uUwQ.set)(state, 'devPanel', {
                ...state.devPanel,
                showSummarySectionMessage: action.payload.showSummarySectionMessage
            });
        default:
            return state;
    }
};

});
parcelRegister("7IqTJ", function(module, exports) {

$parcel$export(module.exports, "enrichSummary", () => $ac3933bf612c15b1$export$580ec73975159411);

var $LpImS = parcelRequire("LpImS");

var $5km34 = parcelRequire("5km34");
// Do not use this function on entity types that have state/status
const $ac3933bf612c15b1$var$shouldStoreEntityUrl = (// @ts-expect-error - TS7006 - Parameter 'summary' implicitly has an 'any' type.
summary, summaryItemType, // @ts-expect-error - TS2304 - Cannot find name 'BranchesType'. | TS2304 - Cannot find name 'CommitsType'.
entities)=>summary[summaryItemType]?.url === null && summary[summaryItemType]?.count === 1 && entities.length === 1;
const $ac3933bf612c15b1$var$shouldStorePullRequestUrl = (// @ts-expect-error - TS7006 - Parameter 'summary' implicitly has an 'any' type.
summary, pullRequest)=>summary[0, $5km34.SUMMARY_ITEM_PULLREQUEST]?.stateCount === 1 && summary[0, $5km34.SUMMARY_ITEM_PULLREQUEST]?.url === null && summary[0, $5km34.SUMMARY_ITEM_PULLREQUEST]?.state === pullRequest.status;
const $ac3933bf612c15b1$export$622f497494fcce79 = (summaryBuilds)=>{
    let targetBuildStatesForOneClickUrl;
    if (summaryBuilds?.failedBuildCount === 1) targetBuildStatesForOneClickUrl = [
        'FAILED'
    ];
    else if (summaryBuilds?.failedBuildCount === 0 && summaryBuilds?.successfulBuildCount === 1) targetBuildStatesForOneClickUrl = [
        'SUCCESSFUL'
    ];
    else if (summaryBuilds?.failedBuildCount === 0 && summaryBuilds?.successfulBuildCount === 0 && summaryBuilds?.count === 1) targetBuildStatesForOneClickUrl = [
        'IN_PROGRESS',
        'PENDING',
        'CANCELLED',
        'UNKNOWN'
    ];
    else // empty means that the build summary item will show a count greater than 1. So don't look for url matching target build state.
    targetBuildStatesForOneClickUrl = [];
    return targetBuildStatesForOneClickUrl;
};
const $ac3933bf612c15b1$export$580ec73975159411 = (transformedSummary, swagResponse)=>{
    const enrichedSummary = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(transformedSummary);
    const targetBuildStatesForOneClickUrl = $ac3933bf612c15b1$export$622f497494fcce79(enrichedSummary[0, $5km34.SUMMARY_ITEM_BUILD]);
    const createPullRequestTargets = [];
    enrichedSummary.detailsHasInstanceErrors = false;
    swagResponse.data.developmentInformation.details.instanceTypes.forEach((instanceType)=>{
        if (instanceType.devStatusErrorMessages.length > 0) enrichedSummary.detailsHasInstanceErrors = true;
        // Repository types
        instanceType.repository.forEach(({ name: name, avatarUrl: avatarUrl, commits: commits, branches: branches, pullRequests: pullRequests })=>{
            // Find the first pull request matching state of summary pull request to be shown (see above note about PRs)
            const pullRequestToStore = pullRequests.find((pullRequest)=>$ac3933bf612c15b1$var$shouldStorePullRequestUrl(enrichedSummary, pullRequest));
            if (enrichedSummary[0, $5km34.SUMMARY_ITEM_PULLREQUEST] && pullRequestToStore !== undefined) enrichedSummary[0, $5km34.SUMMARY_ITEM_PULLREQUEST].url = pullRequestToStore.url;
            if (enrichedSummary[0, $5km34.SUMMARY_ITEM_COMMIT] && $ac3933bf612c15b1$var$shouldStoreEntityUrl(enrichedSummary, (0, $5km34.SUMMARY_ITEM_COMMIT), commits)) enrichedSummary[0, $5km34.SUMMARY_ITEM_COMMIT].url = commits[0].url;
            if (enrichedSummary[0, $5km34.SUMMARY_ITEM_BRANCH] && $ac3933bf612c15b1$var$shouldStoreEntityUrl(enrichedSummary, (0, $5km34.SUMMARY_ITEM_BRANCH), branches)) enrichedSummary[0, $5km34.SUMMARY_ITEM_BRANCH].url = branches[0].url;
            if (name != null && branches.length > 0) createPullRequestTargets.push(...branches.filter((branch)=>branch.createPullRequestUrl != null && branch.name != null).map((branch)=>({
                    repositoryName: name,
                    repositoryAvatarUrl: avatarUrl,
                    branchName: branch.name ?? '',
                    createPullRequestUrl: branch.createPullRequestUrl ?? '',
                    scmProvider: instanceType.type !== undefined && instanceType.type.startsWith((0, $5km34.OAUTH_ANALYTICS_TYPE)) ? (0, $5km34.OAUTH_ANALYTICS_TYPE) : instanceType.type ?? ''
                })));
        });
        // Dangling Pull requests - if PR url hasn't already been set by above repository check
        // Find the first pull request matching state of summary pull request to be shown (see above note about PRs)
        if (instanceType.danglingPullRequests !== null && instanceType.danglingPullRequests !== undefined) {
            const pullRequestToStore = instanceType.danglingPullRequests.find((pullRequest)=>$ac3933bf612c15b1$var$shouldStorePullRequestUrl(enrichedSummary, pullRequest));
            if (enrichedSummary[0, $5km34.SUMMARY_ITEM_PULLREQUEST] && pullRequestToStore !== undefined) enrichedSummary[0, $5km34.SUMMARY_ITEM_PULLREQUEST].url = pullRequestToStore.url;
        }
        // Builds
        if (targetBuildStatesForOneClickUrl.length !== 0) instanceType.buildProviders.forEach((buildProvider)=>{
            const buildToStore = buildProvider.builds.find((build)=>enrichedSummary[0, $5km34.SUMMARY_ITEM_BUILD]?.url === null && targetBuildStatesForOneClickUrl.includes(build.state));
            if (enrichedSummary[0, $5km34.SUMMARY_ITEM_BUILD] && buildToStore !== undefined) enrichedSummary[0, $5km34.SUMMARY_ITEM_BUILD].url = buildToStore.url;
        });
    });
    createPullRequestTargets.sort((a, b)=>a.repositoryName.localeCompare(b.repositoryName) || a.branchName.localeCompare(b.branchName));
    if (enrichedSummary[0, $5km34.SUMMARY_ITEM_PULLREQUEST]) enrichedSummary[0, $5km34.SUMMARY_ITEM_PULLREQUEST].createPullRequestTargets = createPullRequestTargets;
    return enrichedSummary;
};

});



parcelRegister("jxvCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $58d72b8486213387$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fNobW = parcelRequire("fNobW");

var $cutA3 = parcelRequire("cutA3");

var $jD5no = parcelRequire("jD5no");

var $7iJwP = parcelRequire("7iJwP");

var $iXVV6 = parcelRequire("iXVV6");
var $2NMNM = parcelRequire("2NMNM");

var $bC2fB = parcelRequire("bC2fB");

var $g5X3G = parcelRequire("g5X3G");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");

var $gYrS0 = parcelRequire("gYrS0");

var $027Zr = parcelRequire("027Zr");

var $faqOn = parcelRequire("faqOn");

var $9ImuZ = parcelRequire("9ImuZ");

var $iowbr = parcelRequire("iowbr");
class $58d72b8486213387$export$23c3014dd13d0108 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            issueAri: '',
            issueId: '',
            issueKey: (0, $g5X3G.toIssueKey)(''),
            issueStatusCategory: '',
            isSiteAdmin: false,
            hasSoftwareAccess: false,
            projectId: '',
            projectType: '',
            nextGenProject: false,
            analyticsSource: '',
            panelState: 'HIDDEN',
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onFetchDevPanel: ()=>{},
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onWillUnMount: ()=>{},
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSetContext: ()=>{},
            projectAri: '',
            isJiraAdmin: false,
            isLoading: false
        };
    }
    constructor(props){
        super(props);
        this.dispatchSetContext();
    }
    UNSAFE_componentWillMount() {
        this.props.onFetchDevPanel();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isLoading !== prevProps.isLoading) return;
        if (this.props.panelState !== prevProps.panelState) return;
        this.dispatchSetContext();
        this.props.onFetchDevPanel();
    }
    componentWillUnmount() {
        this.props.onWillUnMount();
    }
    dispatchSetContext() {
        const { issueId: issueId, issueAri: issueAri, issueKey: issueKey, issueStatusCategory: issueStatusCategory, projectId: projectId, projectType: projectType, nextGenProject: nextGenProject, analyticsSource: analyticsSource, isSiteAdmin: isSiteAdmin, onSetContext: onSetContext, projectAri: projectAri, isJiraAdmin: isJiraAdmin } = this.props;
        onSetContext({
            issueId: issueId,
            issueAri: issueAri,
            issueKey: issueKey,
            issueStatusCategory: issueStatusCategory,
            projectId: projectId,
            projectType: projectType,
            nextGenProject: nextGenProject,
            analyticsSource: analyticsSource,
            isSiteAdmin: isSiteAdmin || false,
            projectAri: projectAri,
            isJiraAdmin: isJiraAdmin || false
        });
    }
    render() {
        return this.props.hasSoftwareAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            attributes: {
                analyticsSource: this.props.analyticsSource,
                issueId: this.props.issueId,
                isEmptyStateEnabled: true,
                isSiteAdmin: this.props.isSiteAdmin
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "devPanelApp",
            packageName: "jiraDevelopmentSummaryDevelopmentField"
        }, this.props.panelState === 'DEV_SUMMARY' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iowbr.default), null), this.props.panelState === 'NOT_CONNECTED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ImuZ.default), null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    }
}
const $58d72b8486213387$export$28b914daf6888d9 = (unstableProps)=>{
    const props = (0, $cutA3.useShallowStableReference)(unstableProps, (0, $4R6GH.fg)('jfp_magma_issue-stability-phase1'));
    const { issueAri: issueAri = '', issueId: issueId = '', issueKey: issueKey = (0, $g5X3G.toIssueKey)(''), issueStatusCategory: issueStatusCategory = '', isSiteAdmin: isSiteAdmin = false, hasSoftwareAccess: hasSoftwareAccess = false, projectId: projectId = '', projectType: projectType = '', nextGenProject: nextGenProject = false, analyticsSource: analyticsSource = '', panelState: panelState = 'HIDDEN', onFetchDevPanel: onFetchDevPanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onWillUnMount: onWillUnMount = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSetContext: onSetContext = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), projectAri: projectAri = '', isJiraAdmin: isJiraAdmin = false, isLoading: isLoading = false } = props;
    const dispatchSetContext = (0, $5uXOq.useCallback)(()=>{
        onSetContext({
            issueId: issueId,
            issueAri: issueAri,
            issueKey: issueKey,
            issueStatusCategory: issueStatusCategory,
            projectId: projectId,
            projectType: projectType,
            nextGenProject: nextGenProject,
            analyticsSource: analyticsSource,
            isSiteAdmin: isSiteAdmin || false,
            projectAri: projectAri,
            isJiraAdmin: isJiraAdmin || false
        });
    }, [
        analyticsSource,
        isJiraAdmin,
        isSiteAdmin,
        issueAri,
        issueId,
        issueKey,
        issueStatusCategory,
        nextGenProject,
        onSetContext,
        projectAri,
        projectId,
        projectType
    ]);
    const hasMounted = (0, $5uXOq.useRef)(false);
    // UNSAFE_componentWillMount
    (0, $5uXOq.useEffect)(()=>{
        if (!issueId || hasMounted.current) return;
        dispatchSetContext();
        onFetchDevPanel();
        hasMounted.current = true;
        // componentWillUnmount
        return ()=>{
            onWillUnMount();
        };
    }, [
        dispatchSetContext,
        issueId,
        onFetchDevPanel,
        onWillUnMount
    ]);
    const previousProps = (0, $5uXOq.useRef)(props);
    (0, $5uXOq.useEffect)(()=>{
        const { isLoading: prevIsLoading, panelState: prevPanelState } = previousProps.current || {};
        previousProps.current = props;
        if (!hasMounted.current) return;
        if (isLoading !== prevIsLoading) return;
        if (panelState !== prevPanelState) return;
        dispatchSetContext();
        onFetchDevPanel();
    }, [
        dispatchSetContext,
        isLoading,
        onFetchDevPanel,
        panelState,
        props
    ]);
    return hasSoftwareAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: analyticsSource,
            issueId: issueId,
            isEmptyStateEnabled: true,
            isSiteAdmin: isSiteAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "devPanelApp",
        packageName: "jiraDevelopmentSummaryDevelopmentField"
    }, panelState === 'DEV_SUMMARY' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iowbr.default), null), panelState === 'NOT_CONNECTED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ImuZ.default), null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $58d72b8486213387$export$ffe6c71b6facbc2b = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira-concurrent-create-branch-double-call'), $58d72b8486213387$export$28b914daf6888d9, $58d72b8486213387$export$23c3014dd13d0108);
const $58d72b8486213387$var$DevPanelWithTenantContext = ({ onFetchDevPanel: onFetchDevPanel, ...props })=>{
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const wrappedOnFetchDevPanel = (0, $5uXOq.useCallback)(()=>onFetchDevPanel(createAnalyticsEvent({
            actionSubject: 'panel'
        })), [
        onFetchDevPanel,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        hold: props.isLoading,
        name: "issue-dev-panel-data-hold"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58d72b8486213387$export$ffe6c71b6facbc2b, {
        ...props,
        onFetchDevPanel: wrappedOnFetchDevPanel,
        isSiteAdmin: isSiteAdmin
    }));
};
var // This connect uses the store prop thats passed though not the provider that its underneath.
$58d72b8486213387$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        panelState: (0, $faqOn.panelStateSelector)(state),
        isLoading: (0, $faqOn.isLoadingDevPanelSelector)(state)
    }), (dispatch)=>({
        onFetchDevPanel: (analyticsEvent)=>{
            dispatch((0, $027Zr.fetchDevPanelRequest)(analyticsEvent));
        },
        onWillUnMount: ()=>dispatch((0, $027Zr.devPanelWillUnmount)()),
        onSetContext: (issueContext)=>dispatch((0, $gYrS0.setContext)(issueContext))
    }))($58d72b8486213387$var$DevPanelWithTenantContext);

});
parcelRegister("9ImuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $044b44914fbc1b4d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $aYAc3 = parcelRequire("aYAc3");

var $9raOO = parcelRequire("9raOO");

var $c5h9X = parcelRequire("c5h9X");

var $7rNJI = parcelRequire("7rNJI");

var $2SC5w = parcelRequire("2SC5w");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");

var $bC2fB = parcelRequire("bC2fB");

var $6Saiz = parcelRequire("6Saiz");

var $027Zr = parcelRequire("027Zr");

var $ixsVf = parcelRequire("ixsVf");

var $hCEGj = parcelRequire("hCEGj");

var $3t0A0 = parcelRequire("3t0A0");


const $044b44914fbc1b4d$var$ConditionalSlideDown = (parcelRequire("cXjK2")).default;
const $044b44914fbc1b4d$export$ea887ee58e627c40 = ({ onOpenEmptyStateDialog: onOpenEmptyStateDialog })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const notIntegratedLabel = formatMessage((0, $3t0A0.default).notIntegrated);
    const buttonCTA = formatMessage((0, $3t0A0.default).buttonCta); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onButtonClick = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openDevPanelEmptyStateModal');
        onOpenEmptyStateDialog();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        eventName: "viewed devPanelEmptyState"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($044b44914fbc1b4d$var$RelativeFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Saiz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($044b44914fbc1b4d$var$ConditionalSlideDown, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItemContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, notIntegratedLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9raOO.BranchEmptyState), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5h9X.CommitEmptyState), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2SC5w.PullRequestEmptyState), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItemContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "none",
        appearance: "link",
        onClick: onButtonClick
    }, buttonCTA)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ixsVf.default), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCEGj.default), null));
};
var $044b44914fbc1b4d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $bC2fB.connect)(()=>({}), {
    onOpenEmptyStateDialog: (0, $027Zr.showEmptyStateDialog)
})($044b44914fbc1b4d$export$ea887ee58e627c40);
const $044b44914fbc1b4d$var$RelativeFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9raOO", function(module, exports) {

$parcel$export(module.exports, "BranchEmptyState", () => $076f3b64e9746d91$export$2c13bb47265d991b);
$parcel$export(module.exports, "default", () => $076f3b64e9746d91$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kEVMo = parcelRequire("kEVMo");

var $iy9RA = parcelRequire("iy9RA");

var $4iPF3 = parcelRequire("4iPF3");

var $b0XU0 = parcelRequire("b0XU0");

var $gwIPs = parcelRequire("gwIPs");


var $8YTUU = parcelRequire("8YTUU");

var $Iny5X = parcelRequire("Iny5X");

var $7rNJI = parcelRequire("7rNJI");

var $ousew = parcelRequire("ousew");
var $7VHMR = parcelRequire("7VHMR");

var $aWse0 = parcelRequire("aWse0");

var $2gCtH = parcelRequire("2gCtH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $6s1PB = parcelRequire("6s1PB");

var $3WHeu = parcelRequire("3WHeu");

var $gKoXX = parcelRequire("gKoXX");

var $3bnyK = parcelRequire("3bnyK");

var $gc6fQ = parcelRequire("gc6fQ");


const $076f3b64e9746d91$var$ConditionalCreateBranchDropdown = (parcelRequire("7Jxiw")).default;
// eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $076f3b64e9746d91$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_s7n4nkob",
            __cmplp.className
        ])
    });
});
const $076f3b64e9746d91$var$BranchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($076f3b64e9746d91$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iPF3))), {
    color: "var(--ds-link, #0C66E4)",
    label: ""
}));
const $076f3b64e9746d91$var$BranchIconOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($076f3b64e9746d91$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0XU0))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));
const $076f3b64e9746d91$export$f99233281efd08a0 = /*#__PURE__*/ (0, $5uXOq.memo)(({ count: count })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $3bnyK.default).title,
        values: {
            count: count,
            styledCount: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($076f3b64e9746d91$var$BoldFont, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VHMR.FormattedNumber), {
                value: count
            }))
        }
    }));
const $076f3b64e9746d91$var$CreateBranchSummaryItem = ({ branchTargets: branchTargets, shouldForceVisibleSecondary: shouldForceVisibleSecondary, setShouldForceVisibleSecondary: setShouldForceVisibleSecondary, hasBranchCapabilities: hasBranchCapabilities })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const downChevron = (0, $5uXOq.useMemo)(()=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iy9RA))), {
            color: "var(--ds-link, #0C66E4)",
            label: formatMessage((0, $3bnyK.default).createBranchDropdownIconLabelLowercase),
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $3bnyK.default).createBranchDropdownIconLabelLowercase),
            size: "small"
        }), [
        formatMessage
    ]);
    const urlArray = (0, $5uXOq.useMemo)(()=>branchTargets.map((target)=>target.url), [
        branchTargets
    ]);
    const hasSingleTarget = urlArray.length === 1;
    const hasMultipleTargets = urlArray.length > 1;
    if (!hasSingleTarget && !hasMultipleTargets && !hasBranchCapabilities) return null;
    const commonSummaryItemProps = {
        title: formatMessage((0, $3bnyK.default).createBranchTitleLowercase),
        issueKey: issueKey,
        linkFormatting: true,
        icon: (0, $dCm1o.isVisualRefreshEnabled)() ? $076f3b64e9746d91$var$BranchIcon : $076f3b64e9746d91$var$BranchIconOld
    };
    return hasSingleTarget ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        ...commonSummaryItemProps,
        href: urlArray[0],
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createBranchButton', {
                singleScmProvider: true,
                redirectToScmProviderPage: true
            });
        },
        secondaryHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($076f3b64e9746d91$var$ConditionalCreateBranchDropdown, {
            getDropdownTrigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WHeu.CreateBranchCommandButton), props),
            createBranchTargets: branchTargets,
            hideCreateBranchLinks: true,
            onOpenDropdown: ({ isOpen: isOpen })=>{
                setShouldForceVisibleSecondary(isOpen);
            }
        }),
        forceVisibleSecondary: shouldForceVisibleSecondary,
        "data-testid": "development-summary-branch.ui.summary-item"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($076f3b64e9746d91$var$ConditionalCreateBranchDropdown, {
        createBranchTargets: branchTargets,
        onOpenDropdown: ({ isOpen: isOpen })=>{
            setShouldForceVisibleSecondary(isOpen);
        },
        getDropdownTrigger: ({ ref: ref, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
                secondaryData: downChevron,
                forceVisibleSecondary: shouldForceVisibleSecondary,
                reference: ref,
                ...commonSummaryItemProps,
                ...props,
                onClick: ()=>{
                    props.onClick();
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createBranchButton', {
                        singleScmProvider: false,
                        redirectToScmProviderPage: false
                    });
                },
                "data-testid": "development-summary-branch.ui.summary-item"
            })
    });
};
const $076f3b64e9746d91$export$2c13bb47265d991b = ()=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const icon = (0, $dCm1o.isVisualRefreshEnabled)() ? $076f3b64e9746d91$var$BranchIcon : $076f3b64e9746d91$var$BranchIconOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        icon: icon,
        disabled: true,
        title: formatMessage((0, $3bnyK.default).emptyStateUpdate),
        "data-testid": "development-summary-branch.ui.summary-item"
    });
};
const $076f3b64e9746d91$var$BranchInner = ({ branch: branch, onClick: onClick, hasBranchCapabilities: hasBranchCapabilities, branchTargets: branchTargets, issueId: issueId, issueKey: issueKey, shouldForceVisibleSecondary: initialShouldForceVisibleSecondary = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const [shouldForceVisibleSecondary, setShouldForceVisibleSecondary] = (0, $5uXOq.useState)(initialShouldForceVisibleSecondary);
    const vsCodeBranchTarget = (0, $5uXOq.useMemo)(()=>(0, $gc6fQ.createVsCodeBranchTarget)(formatMessage((0, $3bnyK.default).atlascodeProductName), issueKey, // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.location.hostname), [
        formatMessage,
        issueKey
    ]);
    const branchTargetsWithUrls = (0, $5uXOq.useMemo)(()=>{
        const list = branchTargets.filter((target)=>target.url);
        if (vsCodeBranchTarget?.url && branchTargets.length > 0 && (0, $6s1PB.expVal)('jira-work-suggestions-open-in-ide-experiment', 'createBranchButton', false)) list.unshift(vsCodeBranchTarget);
        return list;
    }, [
        branchTargets,
        vsCodeBranchTarget
    ]);
    const { count: count = 0 } = branch ?? {};
    const title = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($076f3b64e9746d91$export$f99233281efd08a0, {
            count: count
        }), [
        count
    ]);
    const icon = (0, $dCm1o.isVisualRefreshEnabled)() ? $076f3b64e9746d91$var$BranchIcon : $076f3b64e9746d91$var$BranchIconOld;
    const summaryItemComponent = (branchInput)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
            title: title,
            href: null,
            onClick: onClick,
            itemType: "branch",
            itemCount: branchInput.count,
            oneClickUrl: branchInput.url,
            oneClickToolTipContent: formatMessage((0, $3bnyK.default).tooltip),
            secondaryHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($076f3b64e9746d91$var$ConditionalCreateBranchDropdown, {
                getDropdownTrigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gKoXX.CreateBranchIconButton), props),
                createBranchTargets: branchTargetsWithUrls,
                onOpenDropdown: ({ isOpen: isOpen })=>{
                    setShouldForceVisibleSecondary(isOpen);
                }
            }),
            icon: icon,
            forceVisibleSecondary: shouldForceVisibleSecondary,
            "data-testid": "development-summary-branch.ui.summary-item"
        });
    if (branch && branch.count > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Iny5X.default), {
        devInfoType: (0, $8YTUU.DevInfoTypes).BRANCH,
        issueId: Number(issueId),
        customTrigger: summaryItemComponent(branch),
        scopeId: `devInfoPanelApp${issueKey}`,
        placement: "bottom-end",
        offset: [
            -8,
            8
        ],
        zIndex: (0, $gwIPs.layers).modal,
        location: (0, $4ebd35f903e92a1a$export$76a449e52fa0e1e8)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($076f3b64e9746d91$var$CreateBranchSummaryItem, {
        branchTargets: branchTargetsWithUrls,
        hasBranchCapabilities: hasBranchCapabilities,
        shouldForceVisibleSecondary: shouldForceVisibleSecondary,
        setShouldForceVisibleSecondary: setShouldForceVisibleSecondary
    });
};
const $076f3b64e9746d91$var$Branch = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "development-summary-branch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($076f3b64e9746d91$var$BranchInner, props));
var $076f3b64e9746d91$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $076f3b64e9746d91$var$Branch;
const $076f3b64e9746d91$var$BoldFont = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4iPF3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3220eab15e59539d$var$_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3220eab15e59539d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3220eab15e59539d$var$BranchIcon = (props)=>/*#__PURE__*/ $3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;

});

parcelRegister("b0XU0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5f697d891cc6bba8e40c46639eb125>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $804e2928682a9df6$var$_react = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $804e2928682a9df6$var$_branch = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("4iPF3")));

var $804e2928682a9df6$var$_branches = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("9XvX5")));
function $804e2928682a9df6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BranchIcon.
 * This component is BranchIcon, with `UNSAFE_fallbackIcon` set to "BitbucketBranchesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $804e2928682a9df6$var$BranchIcon = (props)=>/*#__PURE__*/ $804e2928682a9df6$var$_react.default.createElement($804e2928682a9df6$var$_branch.default, Object.assign({
        LEGACY_fallbackIcon: $804e2928682a9df6$var$_branches.default
    }, props));
$804e2928682a9df6$var$BranchIcon.Name = 'BranchIconMigration';
var $804e2928682a9df6$var$_default = module.exports.default = $804e2928682a9df6$var$BranchIcon;

});
parcelRegister("9XvX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $740268c474e86b43$var$_react = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $740268c474e86b43$var$_branch = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("4iPF3")));
function $740268c474e86b43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $740268c474e86b43$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $740268c474e86b43$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $740268c474e86b43$var$_branch.default
    }));
$740268c474e86b43$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $740268c474e86b43$var$_default = module.exports.default = $740268c474e86b43$var$BitbucketBranchesIcon;

});


const $4ebd35f903e92a1a$export$9b8283d5878d2491 = 'board';
const $4ebd35f903e92a1a$export$76a449e52fa0e1e8 = 'issue';
const $4ebd35f903e92a1a$export$ede40e627a0cbf14 = 'version_details';
const $4ebd35f903e92a1a$export$464c50016d069471 = 'issue_view_child_issues_list';
const $4ebd35f903e92a1a$export$3a46c5b594c0f84c = 'issue_view_linked_issues_list';

parcelRegister("7rNJI", function(module, exports) {

$parcel$export(module.exports, "SummaryItem", () => $ea3834908582274b$export$f1c2de779b6eb7bc);
$parcel$export(module.exports, "SummaryItemContainer", () => $ea3834908582274b$export$1bf84b639674dc7a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $fVnbM = parcelRequire("fVnbM");

var $ggICg = parcelRequire("ggICg");

var $7paD5 = parcelRequire("7paD5");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $i0vxP = parcelRequire("i0vxP");

var $k1L82 = parcelRequire("k1L82");

var $koVbs = parcelRequire("koVbs");

var $ahQce = parcelRequire("ahQce");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $hjSul = parcelRequire("hjSul");

var $3ni6Z = parcelRequire("3ni6Z");
const $ea3834908582274b$export$f1c2de779b6eb7bc = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { userPreferredLayout: userPreferredLayout } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    const getIconAfter = (0, $5uXOq.useCallback)(()=>// temporary ternary for visual refresh update
        // eslint-disable-next-line no-nested-ternary
        props.href !== undefined && props.href != null ? (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
            color: "var(--ds-link, #0C66E4)",
            label: formatMessage((0, $3ni6Z.default).externalLink)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            LEGACY_size: "small",
            label: formatMessage((0, $3ni6Z.default).externalLink)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        }), [
        formatMessage,
        props.href
    ]);
    const iconBeforeProps = {
        iconBefore: props.icon
    };
    const renderClickableSummaryItem = (title, secondaryData, isOneClickLinkEnabled, secondaryHover)=>{
        const plainLinkContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$PlainLink, {
            href: props.href,
            onClick: props.onClick,
            "data-testid": "development-summary-common.ui.summary-item.plain-link"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$ContentContainer, {
            tabIndex: 0
        }, props.showIconInPlainLink && props.icon !== null && props.icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$BeforeIconContainer, null, props.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$LeftContent, null, title), props.relativeDate !== undefined && props.relativeDate !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$RelativeDateContainer, null, props.relativeDate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$SecondaryDataContainer, {
            "data-testid": "development-summary-common.ui.summary-item.secondary-data-container"
        }, secondaryData)));
        const linkFormattedButtonContainer = props.routerLinkConfig ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$LinkFormattedButton, {
            appearance: "link",
            component: (0, $hjSul.Link),
            to: props.routerLinkConfig.route,
            params: props.routerLinkConfig.params,
            prefetch: props.routerLinkConfig.prefetch,
            onClick: props.onClick,
            ...iconBeforeProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$LeftAlignedContent, null, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$LinkFormattedButton, {
            ...userPreferredLayout === 'WIDE' ? {} : {
                shouldFitContainer: true
            },
            shouldFitContainer: true,
            appearance: "link",
            type: "button",
            onClick: props.onClick,
            href: props.href ?? '',
            ...iconBeforeProps,
            target: props.target,
            isSelected: props.isSelected,
            iconAfter: props.secondaryData !== undefined && props.secondaryData != null ? props.secondaryData : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$IconOnHoverContainer, null, getIconAfter()),
            testId: "development-summary-common.ui.summary-item.link-formatted-button",
            "aria-controls": props['aria-controls'],
            "aria-expanded": props['aria-expanded'],
            "aria-haspopup": props['aria-haspopup']
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$LeftAlignedContent, null, title));
        const handlerContentWithTooltip = !props.linkFormatting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: title
        }, plainLinkContainer) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$LinkFormattedContainer, {
            isSecondaryHoverExisting: secondaryHover !== undefined && secondaryHover != null,
            "data-testid": "development-summary-common.ui.summary-item.link-formatted-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: title
        }, linkFormattedButtonContainer));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$RelativeContainer, {
            oneClickLinkEnabled: isOneClickLinkEnabled,
            forceVisibleSecondary: props.forceVisibleSecondary,
            isSecondaryHoverExisting: secondaryHover !== undefined && secondaryHover != null,
            "data-testid": "development-summary-common.ui.summary-item.relative-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
            onEnter: (event)=>{
                props?.onClick?.(event, createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                }));
            }
        }, handlerContentWithTooltip), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$ActionItemsContainer, null, isOneClickLinkEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$ActionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: props.oneClickToolTipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            target: "_blank",
            rel: "noreferrer noopener",
            href: props.oneClickUrl || '',
            onClick: (_, analyticsEvent)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'devPanelSummaryOneClickLink', {
                    summaryItemType: props.itemType
                });
            },
            iconBefore: (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
                color: "var(--ds-link, #0C66E4)",
                label: props.oneClickToolTipContent || ''
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                label: props.oneClickToolTipContent || ''
            }),
            testId: "development-summary-common.ui.summary-item.one-click-link-button"
        }))), secondaryHover !== undefined && secondaryHover != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$ActionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            attributes: {
                summaryItemType: props.itemType
            }
        }, secondaryHover))));
    };
    const renderDisabledSummaryItem = (title)=>// @ts-expect-error - TS2741 - Property 'tabIndex' is missing in type '{ children: (false | Element)[]; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { tabIndex: any; }, any>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$ContentContainer, null, props.icon !== undefined && props.icon !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.icon, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$LeftContent, null, title));
    const isOneClickLinkEnabled = props.itemCount === 1 && props.oneClickUrl !== null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$Row // @ts-expect-error - TS2322 - Type 'Ref<ElementType<any>> | undefined' is not assignable to type '((instance: any) => void) | RefObject<HTMLElement | SVGElement | Component<{}, {}, any>> | undefined'.
    , {
        innerRef: props.reference,
        disabled: props.disabled,
        isWideViewLayout: userPreferredLayout === 'WIDE',
        "data-testid": props['data-testid'],
        showIconInPlainLink: props.showIconInPlainLink
    }, props.disableAnimationOnUpdates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !props.disabled ? renderClickableSummaryItem(props.title, props.secondaryData, isOneClickLinkEnabled, props.secondaryHover) : renderDisabledSummaryItem(props.title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ahQce.UpdateAnimator), {
        animationOut: $ea3834908582274b$var$FadeOutAnimation,
        animationIn: $ea3834908582274b$var$FadeInAnimation,
        updateProps: {
            title: props.title,
            secondaryData: props.secondaryData
        }
    }, ({ title: title, secondaryData: secondaryData })=>!props.disabled ? renderClickableSummaryItem(title, secondaryData, isOneClickLinkEnabled, props.secondaryHover) : renderDisabledSummaryItem(title)));
};
$ea3834908582274b$export$f1c2de779b6eb7bc.defaultProps = {
    disabled: false,
    secondaryData: null,
    href: null,
    itemType: null,
    itemCount: null,
    issueKey: null,
    oneClickUrl: null,
    oneClickToolTipContent: null,
    linkFormatting: false,
    target: '_blank',
    secondaryHover: null,
    // secondary hover component next to the one click button
    'aria-controls': '',
    'aria-expanded': false,
    'aria-haspopup': false,
    isSelected: false,
    showIconInPlainLink: false,
    disableAnimationOnUpdates: false
};
const $ea3834908582274b$export$1bf84b639674dc7a = ({ children: children })=>// @ts-expect-error - TS2741 - Property 'showIconInPlainLink' is missing in type '{ children: Element; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { showIconInPlainLink: boolean; disabled?: any; }, any>>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea3834908582274b$var$ContentContainer, null, children)); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$IconOnHoverContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1s55t3a-0"
})({});
const $ea3834908582274b$var$LinkFormattedButton = /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
(0, $47bDC.default)((0, $fVnbM.default)).withConfig({
    componentId: "sc-1s55t3a-1"
})({}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$LinkFormattedContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1s55t3a-2"
})`flex:1 0 100%;${({ isSecondaryHoverExisting: isSecondaryHoverExisting })=>isSecondaryHoverExisting && (0, $47bDC.css)({
        marginRight: `${"var(--ds-space-300, 24px)"}`
    })} ${$ea3834908582274b$var$LinkFormattedButton}{padding:0 ${"var(--ds-space-025, 2px)"};${({ isSecondaryHoverExisting: isSecondaryHoverExisting })=>isSecondaryHoverExisting && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $47bDC.css)({
        marginRight: `padding: 0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-025, 2px)"};`
    })}}${$ea3834908582274b$var$IconOnHoverContainer}{opacity:0;}&:hover,&:focus-within{background-color:${"var(--ds-background-neutral-subtle-hovered, #091E420F)"};border-radius:3px;${$ea3834908582274b$var$IconOnHoverContainer}{opacity:1;}}`;
const $ea3834908582274b$var$fadeIn = /*#__PURE__*/ (0, $47bDC.keyframes)({
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
const $ea3834908582274b$var$fadeOut = /*#__PURE__*/ (0, $47bDC.keyframes)({
    '0%': {
        opacity: 1
    },
    '100%': {
        opacity: 0
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$ActionItemsContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1s55t3a-3"
})({
    position: 'absolute',
    right: 0,
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ea3834908582274b$var$getSecondaryDataMarginRight = (isSecondaryHoverExisting, oneClickLinkEnabled)=>{
    if (oneClickLinkEnabled && isSecondaryHoverExisting) return (0, $47bDC.css)({
        // With that spacing, we end up having 48px + 8px of paddingRight from the parent = 56px margin to the right
        // with the two icons on the right being 52px
        marginRight: `${"var(--ds-space-600, 48px)"}`
    });
    if (oneClickLinkEnabled || isSecondaryHoverExisting) return (0, $47bDC.css)({
        marginRight: `${"var(--ds-space-250, 20px)"}`
    });
    return (0, $47bDC.css)({
        marginRight: 0
    });
}; // FIXME: type error in object syntax
// WORKAROUND: return a plain object instead of `css()` call
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$SecondaryDataContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1s55t3a-4"
})({
    marginRight: 0,
    transition: 'margin 0.22s ease-in-out'
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$RelativeContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1s55t3a-5"
})`position:relative;${$ea3834908582274b$var$ActionItemsContainer}{opacity:0;transition:opacity 0.3s ease-out;}&:hover,&:focus-within{${$ea3834908582274b$var$ActionItemsContainer}{opacity:1;}${$ea3834908582274b$var$SecondaryDataContainer}{${(props)=>$ea3834908582274b$var$getSecondaryDataMarginRight(props.isSecondaryHoverExisting, props.oneClickLinkEnabled)}}}${({ forceVisibleSecondary: forceVisibleSecondary })=>forceVisibleSecondary && // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $47bDC.css)`${$ea3834908582274b$var$ActionItemsContainer}{opacity:1;}${$ea3834908582274b$var$SecondaryDataContainer}{${(props)=>$ea3834908582274b$var$getSecondaryDataMarginRight(props.isSecondaryHoverExisting, props.oneClickLinkEnabled)}}`}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$FadeOutAnimation = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1s55t3a-6"
})({
    animation: `${$ea3834908582274b$var$fadeOut} 0.8s ease-out`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$FadeInAnimation = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1s55t3a-7"
})({
    animation: `${$ea3834908582274b$var$fadeIn} 0.8s ease-in`
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$ContentContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1s55t3a-8"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ tabIndex: tabIndex })=>tabIndex !== undefined && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        borderRadius: '3px',
        '&:focus': {
            boxShadow: `inset 2px 2px ${"var(--ds-border-focused, #388BFF)"}, inset -2px -2px ${"var(--ds-border-focused, #388BFF)"}`
        },
        '&:hover': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        '&:active': {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)"
        }
    })); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$Row = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1s55t3a-9"
})`margin:0 ${"var(--ds-space-negative-100, -8px)"};${$ea3834908582274b$var$ContentContainer}{height:32px;${({ showIconInPlainLink: showIconInPlainLink })=>showIconInPlainLink ? (0, $47bDC.css)({
        padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-025, 2px)"}`
    }) : (0, $47bDC.css)({
        padding: `0 ${"var(--ds-space-100, 8px)"}`
    })} ${({ disabled: disabled = false })=>disabled ? (0, $47bDC.css)({
        color: "var(--ds-text-subtlest, #626F86)"
    }) : (0, $47bDC.css)({
        color: "var(--ds-text, #172B4D)"
    })}}width:${({ isWideViewLayout: isWideViewLayout })=>isWideViewLayout ? '60%' : '100%'};`;
const $ea3834908582274b$var$ellipsisStyles = /*#__PURE__*/ (0, $47bDC.css)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$BeforeIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19pkidpf _2hwxv77o _otyridpf _18u0v77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$LeftAlignedContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _y3gn1e5h _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $ea3834908582274b$var$PlainLink = /*#__PURE__*/ (0, $47bDC.default).a.withConfig({
    componentId: "sc-1s55t3a-10"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: props.onClick ? 'pointer' : 'default',
        '&:hover, &:focus, &:active': {
            textDecoration: 'none'
        }
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$ActionContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _18u0v77o",
            __cmplp.className
        ])
    });
}); // FIXME: type error in object syntax from ellipsisStyles
const $ea3834908582274b$var$RelativeDateContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1s55t3a-11"
})`${$ea3834908582274b$var$ellipsisStyles} flex:0 5 auto;div[role='presentation']{${$ea3834908582274b$var$ellipsisStyles}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea3834908582274b$var$LeftContent = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1s55t3a-12"
})({
    flexDirection: 'column',
    textAlign: 'left',
    margin: `0 ${"var(--ds-space-025, 2px)"}`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$ea3834908582274b$var$ellipsisStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        marginRight: "var(--ds-space-050, 4px)",
        flex: '1 1 auto'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea3834908582274b$export$7ed12d2a5241e393 = {
    IconOnHoverContainer: $ea3834908582274b$var$IconOnHoverContainer,
    PlainLink: $ea3834908582274b$var$PlainLink,
    ActionContainer: $ea3834908582274b$var$ActionContainer,
    LeftContent: $ea3834908582274b$var$LeftContent,
    ContentContainer: $ea3834908582274b$var$ContentContainer,
    LeftAlignedContent: $ea3834908582274b$var$LeftAlignedContent,
    LinkFormattedButton: $ea3834908582274b$var$LinkFormattedButton,
    BeforeIconContainer: $ea3834908582274b$var$BeforeIconContainer,
    RelativeDateContainer: $ea3834908582274b$var$RelativeDateContainer
};

});
parcelRegister("ahQce", function(module, exports) {

$parcel$export(module.exports, "UpdateAnimator", () => $99b2ffa3083afba8$export$5790c81d12f4c05);

var $5uXOq = parcelRequire("5uXOq");

var $9pe79 = parcelRequire("9pe79");
class $99b2ffa3083afba8$export$5790c81d12f4c05 extends (0, $5uXOq.Component) {
    render() {
        const animatedProps = this.state.prevUpdateProps || this.props.updateProps;
        return this.animationWrapper(this.props.children(animatedProps));
    }
    constructor(...args){
        super(...args), this.state = {
            prevUpdateProps: null,
            shouldAnimateIn: false,
            shouldAnimateOut: false
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!(0, $9pe79.default)(nextProps.updateProps, this.props.updateProps)) this.setState({
                prevUpdateProps: this.props.updateProps,
                shouldAnimateOut: true
            });
        }, this.onAnimationOutEnd = ()=>{
            this.setState({
                prevUpdateProps: null,
                shouldAnimateOut: false,
                shouldAnimateIn: true
            });
        }, this.onAnimationInEnd = ()=>{
            this.setState({
                shouldAnimateIn: false
            });
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.animationWrapper = (element)=>{
            const { animationOut: AnimationOut, animationIn: AnimationIn } = this.props;
            if (this.state.shouldAnimateOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AnimationOut, {
                onAnimationEnd: this.onAnimationOutEnd
            }, element);
            if (this.state.shouldAnimateIn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AnimationIn, {
                onAnimationEnd: this.onAnimationInEnd
            }, element);
            return element;
        };
    }
}

});

parcelRegister("3ni6Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $385667386924fcc1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $385667386924fcc1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    externalLink: {
        "id": "development-summary-common.summary-item.external-link",
        "defaultMessage": "Link to external website in new tab"
    }
});

});


parcelRegister("3WHeu", function(module, exports) {

$parcel$export(module.exports, "CreateBranchCommandButton", () => $6fc7e611e6dfbc81$export$20c6aa8af564477c);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $5LWLA = parcelRequire("5LWLA");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $ejb4R = parcelRequire("ejb4R");
const $6fc7e611e6dfbc81$var$TerminalGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        d: "M11.236 12C11.236 11.6675 11.104 11.3487 10.8689 11.1135L5.1101 5.35474C4.87652 5.12584 4.56205 4.99836 4.23501 5.00002C3.90798 5.00167 3.59481 5.13231 3.36356 5.36356C3.13231 5.59481 3.00167 5.90798 3.00002 6.23501C2.99836 6.56205 3.12584 6.87652 3.35474 7.11009L8.24465 12L3.35474 16.8899C3.12584 17.1234 2.99836 17.438 3.00002 17.765C3.00167 18.0921 3.13231 18.4052 3.36356 18.6365C3.59481 18.8677 3.90798 18.9983 4.23501 19C4.56205 19.0017 4.87652 18.8742 5.1101 18.6452L10.8689 12.8865C11.104 12.6513 11.236 12.3325 11.236 12ZM13.0305 16.2844C12.3381 16.2844 11.7768 16.8458 11.7768 17.5382C11.7768 18.2307 12.3381 18.7921 13.0305 18.7921H20.5535C21.246 18.7921 21.8073 18.2307 21.8073 17.5382C21.8073 16.8458 21.246 16.2844 20.5535 16.2844H13.0305Z"
    }));
const $6fc7e611e6dfbc81$var$TerminalIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $6fc7e611e6dfbc81$var$TerminalGlyph,
        ...props
    });
const $6fc7e611e6dfbc81$export$20c6aa8af564477c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClickProp, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = formatMessage((0, $ejb4R.default).tooltipContent);
    const onClick = (e, analyticsEvent)=>{
        onClickProp && onClickProp();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createBranchCommandButton');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: ref,
        ...props,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6fc7e611e6dfbc81$var$TerminalIcon, {
            label: tooltipContent,
            size: "small"
        }),
        onClick: onClick,
        testId: "development-summary-branch.ui.create-branch-command-button.create-branch-command-button"
    }));
});

});
parcelRegister("ejb4R", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a54172cb9a43ed2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5a54172cb9a43ed2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltipContent: {
        "id": "development-summary-branch.create-branch-command-button.tooltip-content",
        "defaultMessage": "Create and checkout new branch"
    }
});

});


parcelRegister("gKoXX", function(module, exports) {

$parcel$export(module.exports, "CreateBranchIconButton", () => $350f51efb333bc77$export$d8c6bc0d6d054dcd);

var $5uXOq = parcelRequire("5uXOq");

var $dZbEw = parcelRequire("dZbEw");

var $fVnbM = parcelRequire("fVnbM");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $jNiCM = parcelRequire("jNiCM");
const $350f51efb333bc77$export$d8c6bc0d6d054dcd = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClickProp, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = formatMessage((0, $jNiCM.default).tooltipContent);
    const onClick = (e, analyticsEvent)=>{
        onClickProp && onClickProp();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createBranchIconButton');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: ref,
        ...props,
        testId: "development-summary-branch.ui.create-branch-icon-button.button",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
            label: tooltipContent,
            color: "var(--ds-icon, #44546F)",
            size: "small"
        }),
        onClick: onClick
    }));
});

});
parcelRegister("jNiCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e217d0d0b7c43e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $64e217d0d0b7c43e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltipContent: {
        "id": "development-summary-branch.create-branch-icon-button.tooltip-content",
        "defaultMessage": "Create new branch"
    }
});

});


parcelRegister("3bnyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc4f44f12cc73404$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dc4f44f12cc73404$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "development-summary-branch.title",
        "defaultMessage": "{styledCount} {count, plural, one {branch} other {branches}}"
    },
    emptyState: {
        "id": "development-summary-branch.empty-state",
        "defaultMessage": "{Icon} Branch"
    },
    emptyStateUpdate: {
        "id": "development-summary-branch.empty-state-update",
        "defaultMessage": "Branch"
    },
    createBranchTitle: {
        "id": "development-summary-branch.create-branch-title",
        "defaultMessage": "{Icon} Create Branch"
    },
    createBranchTitleLowercase: {
        "id": "development-summary-branch.create-branch-title-lowercase",
        "defaultMessage": "Create branch"
    },
    createBranchDropdownIconLabelLowercase: {
        "id": "development-summary-branch.create-branch-dropdown-icon-label-lowercase",
        "defaultMessage": "Create branch"
    },
    tooltip: {
        "id": "development-summary-branch.tooltip",
        "defaultMessage": "Open branch"
    },
    atlascodeProductName: {
        "id": "development-summary-branch-atlascode-product-name",
        "defaultMessage": "VS Code"
    }
});

});

parcelRegister("gc6fQ", function(module, exports) {

$parcel$export(module.exports, "createVsCodeBranchTarget", () => $d4e66e4f4ad5709c$export$282914c8eb7cb11b);
const $d4e66e4f4ad5709c$var$buildVsCodeUrl = (issueKey, host)=>{
    const issueKeyQs = encodeURIComponent(issueKey);
    const hostQs = encodeURIComponent(host);
    return `vscode://atlassian.atlascode/startWorkOnJira?key=${issueKeyQs}&site=${hostQs}&source=jira`;
};
const $d4e66e4f4ad5709c$export$282914c8eb7cb11b = (productName, issueKey, host)=>({
        name: productName,
        url: $d4e66e4f4ad5709c$var$buildVsCodeUrl(issueKey, host),
        baseUrl: null,
        applicationLinkId: null,
        applicationType: 'vscode.atlascode',
        iconClass: null,
        iconUrl: 'https://atlassian.gallerycdn.vsassets.io/extensions/atlassian/atlascode/3.9.11/1749169574887/Microsoft.VisualStudio.Services.Icons.Small'
    });

});

parcelRegister("7Jxiw", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('create-branch-dropdown-iv-llc-dev-panel', function() {
    return parcelRequire('1feRM');
}, function() {
    return parcelRequire('dqBV0');
});

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});



parcelRegister("c5h9X", function(module, exports) {

$parcel$export(module.exports, "CommitEmptyState", () => $ee961cfc30522969$export$9487062309268bce);
$parcel$export(module.exports, "default", () => $ee961cfc30522969$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZDAP = parcelRequire("eZDAP");

var $kEVMo = parcelRequire("kEVMo");

var $iy9RA = parcelRequire("iy9RA");

var $bFklq = parcelRequire("bFklq");

var $f0oLC = parcelRequire("f0oLC");

var $gwIPs = parcelRequire("gwIPs");


var $8YTUU = parcelRequire("8YTUU");

var $Iny5X = parcelRequire("Iny5X");

var $J1tqp = parcelRequire("J1tqp");

var $jFgzT = parcelRequire("jFgzT");

var $7rNJI = parcelRequire("7rNJI");

var $8Q4sF = parcelRequire("8Q4sF");

var $aWse0 = parcelRequire("aWse0");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $fGBuc = parcelRequire("fGBuc");

var $gkLdi = parcelRequire("gkLdi");
const $ee961cfc30522969$var$COMMIT_SUMMARY_ITEM_TEST_ID = 'development-summary-commit.ui.summary-item'; // eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee961cfc30522969$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_s7n4nkob",
            __cmplp.className
        ])
    });
});
const $ee961cfc30522969$var$CommitIconOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee961cfc30522969$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0oLC))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));
const $ee961cfc30522969$var$CommitIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee961cfc30522969$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bFklq))), {
    color: "var(--ds-link, #0C66E4)",
    label: ""
}));


const $ee961cfc30522969$var$ConditionalCreateCommitDropdown = (parcelRequire("gtMmG")).default;
const $ee961cfc30522969$var$CreateCommitSummaryItem = ({ shouldForceVisibleSecondary: shouldForceVisibleSecondary, setShouldForceVisibleSecondary: setShouldForceVisibleSecondary, hasCommitCapabilities: hasCommitCapabilities, commitCount: commitCount })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const downChevron = (0, $5uXOq.useMemo)(()=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iy9RA))), {
            color: "var(--ds-link, #0C66E4)",
            label: formatMessage((0, $gkLdi.default).createCommitDropdownIconLabel),
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $gkLdi.default).createCommitDropdownIconLabel),
            size: "small"
        }), [
        formatMessage
    ]);
    const commonSummaryItemProps = {
        title: formatMessage((0, $gkLdi.default).createCommitTitleLowercase),
        linkFormatting: true,
        icon: (0, $dCm1o.isVisualRefreshEnabled)() ? $ee961cfc30522969$var$CommitIcon : $ee961cfc30522969$var$CommitIconOld
    };
    return hasCommitCapabilities ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        key: "viewed button createDevAction",
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "createDevAction",
        attributes: {
            inline: false,
            summaryItemType: 'commit',
            isCommitSummary: Boolean(commitCount)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee961cfc30522969$var$ConditionalCreateCommitDropdown, {
        onOpenDropdown: ({ isOpen: isOpen })=>{
            setShouldForceVisibleSecondary(isOpen);
        },
        getDropdownTrigger: ({ ref: ref, onClick: onClick, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
                secondaryData: downChevron,
                forceVisibleSecondary: shouldForceVisibleSecondary,
                reference: ref,
                ...commonSummaryItemProps,
                ...props,
                onClick: ()=>{
                    onClick();
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createDevAction', {
                        inline: false,
                        summaryItemType: 'commit'
                    });
                },
                "data-testid": $ee961cfc30522969$var$COMMIT_SUMMARY_ITEM_TEST_ID
            })
    })) : null;
};
const $ee961cfc30522969$export$b141efd0b0fb9174 = (previousProps, nextProps)=>nextProps.commit?.count === previousProps.commit?.count && nextProps.commit?.lastUpdated === previousProps.commit?.lastUpdated && nextProps.commit?.url === previousProps.commit?.url;
const $ee961cfc30522969$var$CommitInner = /*#__PURE__*/ (0, $5uXOq.memo)(({ onClick: onClick, commit: commit, hasCommitCapabilities: hasCommitCapabilities, issueId: issueId, issueKey: issueKey })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { locale: locale, timeZone: timeZone } = (0, $J1tqp.useLocaleTimeZone)();
    const [shouldForceVisibleSecondary, setShouldForceVisibleSecondary] = (0, $5uXOq.useState)(false);
    const { count: count = 0, lastUpdated: lastUpdated } = commit ?? {};
    const title = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
            componentsMapping: {
                bold: $ee961cfc30522969$var$BoldFont
            },
            message: formatMessage((0, $gkLdi.default).title, {
                count: formatNumber(count),
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }), [
        formatMessage,
        formatNumber,
        count
    ]);
    const relativeDate = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee961cfc30522969$var$RelativeDateContainer, null, lastUpdated !== null && lastUpdated !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFgzT.default), {
            date: (0, $eZDAP.default)(lastUpdated),
            locale: locale,
            timeZone: timeZone,
            strict: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)), [
        lastUpdated,
        locale,
        timeZone
    ]);
    const summaryItemComponent = (commitInput)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
            title: title,
            relativeDate: relativeDate,
            onClick: onClick,
            itemType: "commit",
            itemCount: commitInput.count,
            oneClickUrl: commitInput.url,
            oneClickToolTipContent: formatMessage((0, $gkLdi.default).tooltip),
            secondaryHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee961cfc30522969$var$ConditionalCreateCommitDropdown, {
                getDropdownTrigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fGBuc.CreateCommitIconButton), props),
                onOpenDropdown: ({ isOpen: isOpen })=>{
                    setShouldForceVisibleSecondary(isOpen);
                }
            }),
            forceVisibleSecondary: shouldForceVisibleSecondary,
            "data-testid": $ee961cfc30522969$var$COMMIT_SUMMARY_ITEM_TEST_ID
        });
    if (commit && count > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Iny5X.default), {
        devInfoType: (0, $8YTUU.DevInfoTypes).COMMIT,
        issueId: Number(issueId),
        customTrigger: summaryItemComponent(commit),
        scopeId: `devInfoPanelApp${issueKey}`,
        placement: "bottom-end",
        offset: [
            -8,
            8
        ],
        zIndex: (0, $gwIPs.layers).modal,
        location: (0, $4ebd35f903e92a1a$export$76a449e52fa0e1e8)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee961cfc30522969$var$CreateCommitSummaryItem, {
        hasCommitCapabilities: hasCommitCapabilities,
        shouldForceVisibleSecondary: shouldForceVisibleSecondary,
        setShouldForceVisibleSecondary: setShouldForceVisibleSecondary,
        commitCount: count
    });
}, $ee961cfc30522969$export$b141efd0b0fb9174);
const $ee961cfc30522969$export$9487062309268bce = ()=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const icon = (0, $dCm1o.isVisualRefreshEnabled)() ? $ee961cfc30522969$var$CommitIcon : $ee961cfc30522969$var$CommitIconOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        icon: icon,
        disabled: true,
        title: formatMessage((0, $gkLdi.default).emptyStateUpdate),
        "data-testid": $ee961cfc30522969$var$COMMIT_SUMMARY_ITEM_TEST_ID
    });
};
const $ee961cfc30522969$var$Commit = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "development-summary-commit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee961cfc30522969$var$CommitInner, props)));
var $ee961cfc30522969$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ee961cfc30522969$var$Commit;
const $ee961cfc30522969$var$BoldFont = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee961cfc30522969$var$RelativeDateContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1gjq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bFklq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06952e599791aaa8e8e82dba5053d210>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e34e0db8f20450$var$_react = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e34e0db8f20450$var$_baseNew = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e34e0db8f20450$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e34e0db8f20450$var$CommitIcon = (props)=>/*#__PURE__*/ $87e34e0db8f20450$var$_react.default.createElement($87e34e0db8f20450$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$87e34e0db8f20450$var$CommitIcon.displayName = 'CommitIcon';
var $87e34e0db8f20450$var$_default = module.exports.default = $87e34e0db8f20450$var$CommitIcon;

});

parcelRegister("f0oLC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1201ab50caa951687977050b2b11e97b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aeca11506e43c7df$var$_react = $aeca11506e43c7df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aeca11506e43c7df$var$_commit = $aeca11506e43c7df$var$_interopRequireDefault((parcelRequire("bFklq")));

var $aeca11506e43c7df$var$_commits = $aeca11506e43c7df$var$_interopRequireDefault((parcelRequire("1TUd3")));
function $aeca11506e43c7df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CommitIcon.
 * This component is CommitIcon, with `UNSAFE_fallbackIcon` set to "BitbucketCommitsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aeca11506e43c7df$var$CommitIcon = (props)=>/*#__PURE__*/ $aeca11506e43c7df$var$_react.default.createElement($aeca11506e43c7df$var$_commit.default, Object.assign({
        LEGACY_fallbackIcon: $aeca11506e43c7df$var$_commits.default
    }, props));
$aeca11506e43c7df$var$CommitIcon.Name = 'CommitIconMigration';
var $aeca11506e43c7df$var$_default = module.exports.default = $aeca11506e43c7df$var$CommitIcon;

});
parcelRegister("1TUd3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $162687911a858d49$var$_react = $162687911a858d49$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $162687911a858d49$var$_commit = $162687911a858d49$var$_interopRequireDefault((parcelRequire("bFklq")));
function $162687911a858d49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162687911a858d49$var$BitbucketCommitsIcon = (props)=>/*#__PURE__*/ $162687911a858d49$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9m-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"/></svg>`
    }, props, {
        newIcon: $162687911a858d49$var$_commit.default
    }));
$162687911a858d49$var$BitbucketCommitsIcon.displayName = 'BitbucketCommitsIcon';
var $162687911a858d49$var$_default = module.exports.default = $162687911a858d49$var$BitbucketCommitsIcon;

});


parcelRegister("J1tqp", function(module, exports) {

$parcel$export(module.exports, "useLocaleTimeZone", () => $dec080187e30b37a$export$180a82d4f668e1c9);

var $DVljb = parcelRequire("DVljb");

var $leRCk = parcelRequire("leRCk");
function $dec080187e30b37a$export$180a82d4f668e1c9() {
    const locale = (0, $DVljb.useLocale)();
    const [{ data: data }] = (0, $leRCk.useUserSubscriber)();
    return {
        locale: locale,
        timeZone: data?.timeZone
    };
}

});

parcelRegister("jFgzT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cd578a7f969a3cb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");

var $az4zD = parcelRequire("az4zD");

var $aWse0 = parcelRequire("aWse0");

var $21iV6 = parcelRequire("21iV6");

var $1p96B = parcelRequire("1p96B");

var $6rLK1 = parcelRequire("6rLK1");
const $5cd578a7f969a3cb$export$45c85543ba71221d = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
function $5cd578a7f969a3cb$var$RelativeDate(props) {
    const { locale: locale = (0, $21iV6.defaultLocale), date: date, timeZone: timeZone, intl: { formatDate: formatDate }, strict: strict = false, delay: delay, position: position = 'top' } = props;
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const options = timeZone !== undefined && timeZone.trim() !== '' && timeZone !== null ? {
        ...$5cd578a7f969a3cb$export$45c85543ba71221d,
        timeZone: timeZone
    } : {
        ...$5cd578a7f969a3cb$export$45c85543ba71221d
    };
    const timeElapsed = strict ? (0, $1p96B.formatDistanceStrictWithLocale)(date, new Date(), locale) : (0, $1p96B.formatDistanceWithLocale)(date, new Date(), locale);
    const lastUpdateDateTime = formatDate(date.valueOf(), options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: lastUpdateDateTime,
        position: position,
        delay: delay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "span",
        testId: "development-common.ui.relative-date"
    }, formatMessage((0, $6rLK1.default).relativeDate, {
        relativeDate: timeElapsed
    })));
}
var $5cd578a7f969a3cb$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($5cd578a7f969a3cb$var$RelativeDate);

});
parcelRegister("6rLK1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd5fa9e32b8dfb6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7cd5fa9e32b8dfb6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    relativeDate: {
        "id": "development.common.components.relative-date.text",
        "defaultMessage": "{relativeDate} ago"
    }
});

});


parcelRegister("fGBuc", function(module, exports) {

$parcel$export(module.exports, "CreateCommitIconButton", () => $309d19e507a1c566$export$fa4479da71fc8551);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $99M5v = parcelRequire("99M5v");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");

var $jA4l9 = parcelRequire("jA4l9");
const $309d19e507a1c566$export$fa4479da71fc8551 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClickProp, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = formatMessage((0, $jA4l9.default).tooltipContent);
    const onClick = (e, analyticsEvent)=>{
        onClickProp && onClickProp();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createDevAction', {
            inline: true,
            summaryItemType: 'commit'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "createDevAction",
        attributes: {
            inline: true,
            summaryItemType: 'commit',
            isCommitSummary: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: ref,
        ...props,
        appearance: "subtle",
        testId: "development-summary-commit.ui.create-commit-icon-button.button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            LEGACY_size: "small",
            label: tooltipContent
        }),
        onClick: onClick
    }));
});

});
parcelRegister("jA4l9", function(module, exports) {

$parcel$export(module.exports, "default", () => $535490f138af56b4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $535490f138af56b4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltipContent: {
        "id": "development-summary-commit.create-commit-icon-button.tooltip-content",
        "defaultMessage": "Create new commit"
    }
});

});


parcelRegister("gkLdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef2e5d3b6fe9d40$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bef2e5d3b6fe9d40$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "development-summary-commit.title",
        "defaultMessage": "{boldStart}{count}{boldEnd} {count, plural, one {commit} other {commits}}"
    },
    emptyState: {
        "id": "development-summary-commit.empty-state",
        "defaultMessage": "{Icon} Commit"
    },
    emptyStateUpdate: {
        "id": "development-summary-commit.empty-state-update",
        "defaultMessage": "Commit"
    },
    createCommitTitleLowercase: {
        "id": "development-summary-commit.create-commit-title-lowercase",
        "defaultMessage": "Create commit"
    },
    createCommitDropdownIconLabel: {
        "id": "development-summary-commit.create-commit-dropdown-icon-label",
        "defaultMessage": "Open create commit dropdown"
    },
    tooltip: {
        "id": "development-summary-commit.tooltip",
        "defaultMessage": "Open commit"
    }
});

});

parcelRegister("gtMmG", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('create-commit-dropdown-iv-llc-dev-panel', function() {
    return parcelRequire('fZTy7');
}, function() {
    return parcelRequire('jtTPi');
});

});


parcelRegister("2SC5w", function(module, exports) {

$parcel$export(module.exports, "PullRequestEmptyState", () => $060c731a51a3404f$export$a7840d0eddc64f6e);
$parcel$export(module.exports, "default", () => $060c731a51a3404f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fb5SF = parcelRequire("fb5SF");

var $aYAc3 = parcelRequire("aYAc3");

var $gwIPs = parcelRequire("gwIPs");


var $8YTUU = parcelRequire("8YTUU");

var $Iny5X = parcelRequire("Iny5X");

var $7rNJI = parcelRequire("7rNJI");

var $8Q4sF = parcelRequire("8Q4sF");

var $aWse0 = parcelRequire("aWse0");

var $l8ruj = parcelRequire("l8ruj");

var $ig8ur = parcelRequire("ig8ur");

var $kI07N = parcelRequire("kI07N");

var $6VQ7H = parcelRequire("6VQ7H");


const $060c731a51a3404f$var$ConditionalCreatePullrequestDropdown = (parcelRequire("gqwvj")).default;
const $060c731a51a3404f$var$statusCategoryToAppearenceMap = {
    OPEN: 'inprogress',
    DRAFT: 'inprogress',
    MERGED: 'success',
    DECLINED: 'removed'
};
const $060c731a51a3404f$export$b141efd0b0fb9174 = (previousProps, nextProps)=>nextProps.pullRequest?.count === previousProps.pullRequest?.count && nextProps.pullRequest?.lastUpdated === previousProps.pullRequest?.lastUpdated && nextProps.pullRequest?.stateCount === previousProps.pullRequest?.stateCount && nextProps.pullRequest?.state === previousProps.pullRequest?.state && nextProps.pullRequest?.url === previousProps.pullRequest?.url && nextProps.pullRequest?.createPullRequestTargets?.length === previousProps.pullRequest?.createPullRequestTargets?.length;
const $060c731a51a3404f$var$PullRequestInner = /*#__PURE__*/ (0, $5uXOq.memo)(({ onClick: onClick, branchesCount: branchesCount, pullRequest: pullRequest, hasErrors: hasErrors, issueId: issueId, issueKey: issueKey })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { count: pullRequestsCount = 0, stateCount: stateCount = 0, state: state } = pullRequest ?? {};
    const [shouldForceVisibleSecondary, setShouldForceVisibleSecondary] = (0, $5uXOq.useState)(false);
    const title = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
            componentsMapping: {
                bold: $060c731a51a3404f$var$BoldFont
            },
            message: formatMessage((0, $6VQ7H.default).title, {
                count: formatNumber(stateCount),
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }), [
        formatMessage,
        formatNumber,
        stateCount
    ]);
    const secondaryData = (0, $5uXOq.useMemo)(()=>state ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
            appearance: $060c731a51a3404f$var$statusCategoryToAppearenceMap[state]
        }, state) : undefined, [
        state
    ]);
    const summaryItemComponent = (pullRequestInput, targetsLength, href)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
            title: title,
            secondaryData: secondaryData,
            onClick: onClick,
            itemType: "pullrequest",
            itemCount: pullRequestInput.stateCount,
            oneClickUrl: pullRequestInput.url,
            oneClickToolTipContent: formatMessage((0, $6VQ7H.default).tooltip),
            "data-testid": "development-summary-pull-request.ui.summary-item",
            secondaryHover: targetsLength > 0 || hasErrors ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($060c731a51a3404f$var$ConditionalCreatePullrequestDropdown, {
                hasErrors: hasErrors,
                onAuthErrorClick: onClick,
                createPullRequestTargets: pullRequestInput.createPullRequestTargets,
                renderDropdownTrigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ig8ur.CreatePRIconButton), {
                        ...props,
                        href: href
                    }),
                onOpenDropdown: ({ isOpen: isOpen })=>{
                    setShouldForceVisibleSecondary(isOpen);
                }
            }) : null,
            forceVisibleSecondary: shouldForceVisibleSecondary
        });
    if (pullRequest && pullRequestsCount) {
        const targetsLength = pullRequest.createPullRequestTargets?.length || 0;
        const isSingleTarget = pullRequest.createPullRequestTargets?.length === 1;
        const href = isSingleTarget && !hasErrors // if there are error messages in response we want to show the dropdown to show the error message.
         ? pullRequest?.createPullRequestTargets?.[0]?.createPullRequestUrl : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Iny5X.default), {
            devInfoType: (0, $8YTUU.DevInfoTypes).PULLREQUEST,
            issueId: Number(issueId),
            customTrigger: summaryItemComponent(pullRequest, targetsLength, href),
            scopeId: `devInfoPanelApp${issueKey}`,
            placement: "bottom-end",
            offset: [
                -8,
                8
            ],
            zIndex: (0, $gwIPs.layers).modal,
            location: (0, $4ebd35f903e92a1a$export$76a449e52fa0e1e8)
        });
    }
    if (pullRequest && branchesCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kI07N.CreatePullRequestSummaryItem), {
        createPullRequestTargets: pullRequest.createPullRequestTargets,
        hasErrors: hasErrors,
        onAuthErrorClick: onClick,
        branchesCount: branchesCount
    });
    return null;
}, $060c731a51a3404f$export$b141efd0b0fb9174);
// eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $060c731a51a3404f$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_s7n4nkob",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $060c731a51a3404f$export$1f4774b4dbeafbe4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($060c731a51a3404f$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fb5SF))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));
const $060c731a51a3404f$export$a7840d0eddc64f6e = ()=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const icon = $060c731a51a3404f$export$1f4774b4dbeafbe4;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        icon: icon,
        disabled: true,
        title: formatMessage((0, $6VQ7H.default).emptyStateUpdate),
        "data-testid": "development-summary-pull-request.ui.summary-item"
    });
};
const $060c731a51a3404f$var$PullRequest = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "development-summary-pullrequest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($060c731a51a3404f$var$PullRequestInner, props)));
var $060c731a51a3404f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $060c731a51a3404f$var$PullRequest;
const $060c731a51a3404f$var$BoldFont = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fb5SF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0df86e9f58670341f0be02decae626a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0cc71de29a7bd8c$var$_react = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b0cc71de29a7bd8c$var$_pullRequest = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("hXgVM")));

var $b0cc71de29a7bd8c$var$_pullrequests = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("dMzAR")));
function $b0cc71de29a7bd8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PullRequestIcon.
 * This component is PullRequestIcon, with `UNSAFE_fallbackIcon` set to "BitbucketPullrequestsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0cc71de29a7bd8c$var$PullRequestIcon = (props)=>/*#__PURE__*/ $b0cc71de29a7bd8c$var$_react.default.createElement($b0cc71de29a7bd8c$var$_pullRequest.default, Object.assign({
        LEGACY_fallbackIcon: $b0cc71de29a7bd8c$var$_pullrequests.default
    }, props));
$b0cc71de29a7bd8c$var$PullRequestIcon.Name = 'PullRequestIconMigration';
var $b0cc71de29a7bd8c$var$_default = module.exports.default = $b0cc71de29a7bd8c$var$PullRequestIcon;

});
parcelRegister("hXgVM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a083285ccf5836110a489694f045affe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1251477351c10fe$var$_react = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d1251477351c10fe$var$_baseNew = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d1251477351c10fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1251477351c10fe$var$PullRequestIcon = (props)=>/*#__PURE__*/ $d1251477351c10fe$var$_react.default.createElement($d1251477351c10fe$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$d1251477351c10fe$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $d1251477351c10fe$var$_default = module.exports.default = $d1251477351c10fe$var$PullRequestIcon;

});

parcelRegister("dMzAR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a08b5e30d2d36873$var$_react = $a08b5e30d2d36873$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $a08b5e30d2d36873$var$_pullRequest = $a08b5e30d2d36873$var$_interopRequireDefault((parcelRequire("hXgVM")));
function $a08b5e30d2d36873$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a08b5e30d2d36873$var$BitbucketPullrequestsIcon = (props)=>/*#__PURE__*/ $a08b5e30d2d36873$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2q.3 0 .6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8M17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1M7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3m0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1"/></svg>`
    }, props, {
        newIcon: $a08b5e30d2d36873$var$_pullRequest.default
    }));
$a08b5e30d2d36873$var$BitbucketPullrequestsIcon.displayName = 'BitbucketPullrequestsIcon';
var $a08b5e30d2d36873$var$_default = module.exports.default = $a08b5e30d2d36873$var$BitbucketPullrequestsIcon;

});


parcelRegister("ig8ur", function(module, exports) {

$parcel$export(module.exports, "CreatePRIconButton", () => $ba3a07c0e4a039f2$export$406668a983d2447c);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $99M5v = parcelRequire("99M5v");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2FEAF = parcelRequire("2FEAF");
const $ba3a07c0e4a039f2$export$406668a983d2447c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClickProp, href: href, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'button'
        }), 'createDevAction', {
            summaryItemType: 'pullrequest',
            inline: true
        });
    }, [
        createAnalyticsEvent
    ]);
    const tooltipContent = formatMessage((0, $2FEAF.default).tooltipContent);
    const onClick = (e, analyticsEvent)=>{
        href === undefined && onClickProp && onClickProp();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createDevAction', {
            summaryItemType: 'pullrequest',
            inline: true
        });
    };
    const buttonProps = href !== undefined && href !== null ? {
        href: href,
        target: '_blank'
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: ref,
        ...props,
        ...buttonProps,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            LEGACY_size: "small",
            label: tooltipContent
        }),
        onClick: onClick,
        testId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pr-icon-button.button"
    }));
});

});
parcelRegister("2FEAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a95963b95766f72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7a95963b95766f72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltipContent: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pr-icon-button.tooltip-content",
        "defaultMessage": "Create new pull request"
    }
});

});


parcelRegister("kI07N", function(module, exports) {

$parcel$export(module.exports, "CreatePullRequestSummaryItem", () => $b348ab0c84f86a1f$export$47ec9685588d5f1a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kEVMo = parcelRequire("kEVMo");

var $fb5SF = parcelRequire("fb5SF");

var $7rNJI = parcelRequire("7rNJI");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $gxQWg = parcelRequire("gxQWg");
const $b348ab0c84f86a1f$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_s7n4nkob",
            __cmplp.className
        ])
    });
});
const $b348ab0c84f86a1f$export$1f4774b4dbeafbe4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b348ab0c84f86a1f$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fb5SF))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));


const $b348ab0c84f86a1f$var$ConditionalCreatePullrequestDropdown = (parcelRequire("gqwvj")).default;
const $b348ab0c84f86a1f$export$47ec9685588d5f1a = ({ branchesCount: branchesCount, createPullRequestTargets: createPullRequestTargets, hasErrors: hasErrors, onAuthErrorClick: onAuthErrorClick })=>{
    const PULL_REQUEST_SUMMARY_TYPE = 'pullrequest';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const createPullRequestTitle = formatMessage((0, $gxQWg.default).createPullRequestTitle);
    const downChevron = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $gxQWg.default).createPullRequestDropdownIconLabel),
            size: "small"
        }), [
        formatMessage
    ]);
    const commonSummaryItemProps = {
        title: createPullRequestTitle,
        issueKey: issueKey,
        linkFormatting: true,
        icon: $b348ab0c84f86a1f$export$1f4774b4dbeafbe4
    };
    const commonAnalyticsAttributes = {
        summaryItemType: PULL_REQUEST_SUMMARY_TYPE,
        inline: false
    };
    const isLoading = createPullRequestTargets === null || createPullRequestTargets === undefined;
    const hasUrlLoaded = createPullRequestTargets !== null && createPullRequestTargets !== undefined && createPullRequestTargets.length === 1; // only show link if theres one branch, no errors,
    // and if its either currently loading (show spinner) or theres exactly one link (show external link)
    // otherwise show the dropdown
    if (branchesCount === 1 && !hasErrors && (isLoading || hasUrlLoaded)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        ...commonSummaryItemProps,
        href: hasUrlLoaded ? createPullRequestTargets?.[0].createPullRequestUrl : null,
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'createPullRequestLink', {
                ...commonAnalyticsAttributes,
                linkListLength: 1
            });
        },
        "data-testid": "development-summary-pull-request.ui.create-pull-request-inline-summary-item"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "button",
        action: "viewed",
        actionSubjectId: "createDevAction",
        attributes: commonAnalyticsAttributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b348ab0c84f86a1f$var$ConditionalCreatePullrequestDropdown, {
        hasErrors: hasErrors,
        onAuthErrorClick: onAuthErrorClick,
        createPullRequestTargets: createPullRequestTargets,
        renderDropdownTrigger: ({ ref: ref, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
                secondaryData: downChevron,
                reference: ref,
                ...commonSummaryItemProps,
                ...props,
                onClick: ()=>{
                    props.onClick();
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createDevAction', commonAnalyticsAttributes);
                },
                "data-testid": "development-summary-pull-request.ui.create-pull-request-summary-item"
            })
    }));
};

});
parcelRegister("gxQWg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67b6a42b252cbf3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d67b6a42b252cbf3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createPullRequestTitle: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-title",
        "defaultMessage": "Create pull request"
    },
    createPullRequestDropdownIconLabel: {
        "id": "development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown-icon-label",
        "defaultMessage": "Create pull request"
    }
});

});

parcelRegister("gqwvj", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
    return parcelRequire('6Wja6');
}, function() {
    return parcelRequire('44gMI');
});

});


parcelRegister("6VQ7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2f1e75d5b2d45b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a2f1e75d5b2d45b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "development-summary-pull-request.title",
        "defaultMessage": "{boldStart}{count}{boldEnd} {count, plural, one {pull request} other {pull requests}}"
    },
    emptyState: {
        "id": "development-summary-pull-request.empty-state",
        "defaultMessage": "{Icon} Pull request"
    },
    emptyStateUpdate: {
        "id": "development-summary-pull-request.empty-state-update",
        "defaultMessage": "Pull request"
    },
    tooltip: {
        "id": "development-summary-pull-request.tooltip",
        "defaultMessage": "Open pull request"
    }
});

});


parcelRegister("6Saiz", function(module, exports) {

$parcel$export(module.exports, "default", () => $310797153bd7e665$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $cSD7y = parcelRequire("cSD7y");

var $koVbs = parcelRequire("koVbs");

var $hjSnd = parcelRequire("hjSnd");

var $knyf6 = parcelRequire("knyf6");

var $k1L82 = parcelRequire("k1L82");

var $5fc53 = parcelRequire("5fc53");

var $cMrTd = parcelRequire("cMrTd");
const $310797153bd7e665$export$34c298764f320025 = ({ children: children, afterHeadingNode: afterHeadingNode, pinnable: pinnable = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const titleLabel = formatMessage((0, $cMrTd.default).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSnd.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($310797153bd7e665$var$DevPanelFieldHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSnd.FieldHeadingTitle), null, titleLabel), afterHeadingNode, pinnable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $knyf6.FieldPin), {
        fieldId: (0, $5fc53.DEV_SUMMARY_TYPE),
        label: titleLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSnd.SideBySideField), null, children));
};
var $310797153bd7e665$export$2e2bcd8739ae039 = $310797153bd7e665$export$34c298764f320025;
const $310797153bd7e665$var$DevPanelFieldHeadingNew = ({ children: children })=>{
    const { userPreferredLayout: userPreferredLayout } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    const isWideViewLayout = userPreferredLayout === 'WIDE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $310797153bd7e665$var$fieldHeadingSideBySideCssStylesNew,
            isWideViewLayout && $310797153bd7e665$var$wideLayoutStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $310797153bd7e665$var$devPanelFieldHeadingOuterStyles
    }, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $310797153bd7e665$var$DevPanelFieldHeadingOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSnd.FieldHeadingSideBySide), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _u5f3idpf",
            __cmplp.className
        ])
    });
});
const $310797153bd7e665$var$fieldHeadingSideBySideCssStylesNew = (0, $8CUq3.xcss)({
    position: 'relative',
    boxSizing: 'border-box',
    minWidth: '120px',
    width: '40%',
    flex: '1 0 0%',
    display: 'flex',
    paddingRight: 'space.200',
    paddingTop: 'space.100'
});
const $310797153bd7e665$var$wideLayoutStyles = (0, $8CUq3.xcss)({
    maxWidth: '148px',
    paddingRight: 'space.0'
});
const $310797153bd7e665$var$devPanelFieldHeadingOuterStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    height: 'fit-content',
    paddingBottom: 'space.100',
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    borderRadius: '4px',
    width: 'fit-content',
    marginLeft: 'space.negative.050',
    gap: 'space.100',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $310797153bd7e665$var$DevPanelFieldHeading = (0, $cSD7y.componentWithFG)('issue_view_field_config_edit', $310797153bd7e665$var$DevPanelFieldHeadingNew, $310797153bd7e665$var$DevPanelFieldHeadingOld);

});
parcelRegister("cMrTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecdfe91346d3125f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ecdfe91346d3125f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "development-summary-development-field.common.development-field-wrapper.label",
        "defaultMessage": "Development"
    },
    sectionFirstAction: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-first-action",
        "defaultMessage": "Learn more"
    },
    sectionSecondAction: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-second-action",
        "defaultMessage": "Dismiss"
    },
    sectionMessageCanCreate: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-message-can-create",
        "defaultMessage": "Link this issue to your code by including issue keys when creating a branch, commit, or pull request below."
    },
    sectionMessageCantCreate: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-message-cant-create",
        "defaultMessage": "Link this issue to your code by including issue keys when creating a branch, commit, or pull request."
    },
    sectionTitle: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-title",
        "defaultMessage": "Quick start development"
    },
    sectionMessageCanCreateIssueTermRefresh: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-message-can-create-issue-term-refresh",
        "defaultMessage": "Link this work item to your code by including keys when creating a branch, commit, or pull request below."
    },
    sectionMessageCantCreateIssueTermRefresh: {
        "id": "development-summary-development-field.common.development-field-wrapper.section-message-cant-create-issue-term-refresh",
        "defaultMessage": "Link this work item to your code by including keys when creating a branch, commit, or pull request."
    }
});

});


parcelRegister("ixsVf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bab1747ee4ef2e28$export$2e2bcd8739ae039);

var $5YDkU = parcelRequire("5YDkU");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h4EJ8 = parcelRequire("h4EJ8");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $1IoOM = parcelRequire("1IoOM");

var $467lJ = parcelRequire("467lJ");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $bC2fB = parcelRequire("bC2fB");

var $01j5n = parcelRequire("01j5n");

var $3vXOY = parcelRequire("3vXOY");

var $koeKL = parcelRequire("koeKL");

var $027Zr = parcelRequire("027Zr");

var $bqTfx = parcelRequire("bqTfx");
const $bab1747ee4ef2e28$export$8f1dc3b33a81bbdb = ({ setPanelShownState: setPanelShownState })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const dismissLabel = formatMessage((0, $bqTfx.default).dismissState);
    const fireCompleteAnalytics = (analyticsEvent, errors)=>{
        const statusCode = errors ? (0, $3vXOY.getStatusCodeFromGraphQLErrors)(errors) : 200;
        const isFailure = (0, $01j5n.isFailureStatusCode)(statusCode); // response contains graphql errors
        if (errors && errors.length > 0 && isFailure) {
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'optOutOfDevEmptyState failed', {
                statusCode: statusCode,
                errorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($h4EJ8)))(errors[0].message, {
                    length: 140
                })
            });
            showFlag((0, $467lJ.default).genericError());
            return;
        }
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'optOutOfDevEmptyState success', {
            statusCode: statusCode
        });
    };
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $5YDkU.default));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onDismiss = (_, analyticsEvent)=>{
        // optimistic update.
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'optOutOfDevEmptyState');
        setPanelShownState(false);
        commitMutation({
            variables: {
                cloudId: cloudId
            },
            onCompleted: (data, errors)=>{
                setPanelShownState(data // @ts-expect-error(Suppressed for relay bump) - 'data.jira' is possibly 'null' or 'undefined'. | 'data.jira.devOps' is possibly 'null' or 'undefined'. | 'data.jira.devOps.optoutOfDevOpsIssuePanelNotConnectedState' is possibly 'null' or 'undefined'.
                 ? !data.jira.devOps.optoutOfDevOpsIssuePanelNotConnectedState.success : true);
                fireCompleteAnalytics(analyticsEvent, errors);
            },
            onError: ()=>{
                setPanelShownState(true);
                showFlag((0, $467lJ.default).genericError());
                (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'optOutOfDevEmptyState failed', {
                    statusCode: 'unknown',
                    errorMessage: 'networkError'
                });
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bab1747ee4ef2e28$var$AbsoluteContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1IoOM))), {
            label: dismissLabel,
            LEGACY_size: "small"
        }),
        appearance: "subtle",
        onClick: onDismiss
    }));
};
var $bab1747ee4ef2e28$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $bC2fB.connect)(()=>({}), {
    setPanelShownState: (0, $027Zr.onToggleDismissButton)
})($bab1747ee4ef2e28$export$8f1dc3b33a81bbdb);
const $bab1747ee4ef2e28$var$AbsoluteContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1xi2idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5YDkU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b695225bb4b3e95$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0a99b5771c2326b275543886559dc3ca>>
 * @relayHash f0f958ebdc206ec225be6fc12de3956d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71e0e1bec419b0d916f639a1da879bf2df3ece36a7031439c655ab8412a81b9c
const $8b695225bb4b3e95$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "GenericMutationErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsMutation",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraOptoutDevOpsIssuePanelNotConnectedPayload",
                                    "kind": "LinkedField",
                                    "name": "optoutOfDevOpsIssuePanelNotConnectedState",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsMutation",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraOptoutDevOpsIssuePanelNotConnectedPayload",
                                    "kind": "LinkedField",
                                    "name": "optoutOfDevOpsIssuePanelNotConnectedState",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ],
                                                            "type": "BulkMutationErrorExtension"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71e0e1bec419b0d916f639a1da879bf2df3ece36a7031439c655ab8412a81b9c",
            "metadata": {},
            "name": "absoluteCloseButtonJiraDevSummaryUserOptOutNotConnectedStateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$8b695225bb4b3e95$var$node.hash = "0189524f2e02f5faf49500efb2d22c19";
var $8b695225bb4b3e95$export$2e2bcd8739ae039 = $8b695225bb4b3e95$var$node;

});

parcelRegister("h4EJ8", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $gvFfr = parcelRequire("gvFfr");

var $axH2S = parcelRequire("axH2S");

var $k0qYG = parcelRequire("k0qYG");

var $cErmc = parcelRequire("cErmc");

var $ifYxh = parcelRequire("ifYxh");

var $jx6Tp = parcelRequire("jx6Tp");

var $kPZpS = parcelRequire("kPZpS");

var $jJVtR = parcelRequire("jJVtR");
/** Used as default options for `_.truncate`. */ var $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH = 30, $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION = '...';
/** Used to match `RegExp` flags from their coerced string values. */ var $c6e266ef199f8e9f$var$reFlags = /\w*$/;
/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */ function $c6e266ef199f8e9f$var$truncate(string, options) {
    var length = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH, omission = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION;
    if ($k0qYG(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? $kPZpS(options.length) : length;
        omission = 'omission' in options ? $kHBB0(options.omission) : omission;
    }
    string = $jJVtR(string);
    var strLength = string.length;
    if ($axH2S(string)) {
        var strSymbols = $jx6Tp(string);
        strLength = strSymbols.length;
    }
    if (length >= strLength) return string;
    var end = length - $ifYxh(omission);
    if (end < 1) return omission;
    var result = strSymbols ? $gvFfr(strSymbols, 0, end).join('') : string.slice(0, end);
    if (separator === undefined) return result + omission;
    if (strSymbols) end += result.length - end;
    if ($cErmc(separator)) {
        if (string.slice(end).search(separator)) {
            var match, substring = result;
            if (!separator.global) separator = RegExp(separator.source, $jJVtR($c6e266ef199f8e9f$var$reFlags.exec(separator)) + 'g');
            separator.lastIndex = 0;
            while(match = separator.exec(substring))var newEnd = match.index;
            result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
    } else if (string.indexOf($kHBB0(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) result = result.slice(0, index);
    }
    return result + omission;
}
module.exports = $c6e266ef199f8e9f$var$truncate;

});
parcelRegister("cErmc", function(module, exports) {

var $3euyi = parcelRequire("3euyi");

var $cW28x = parcelRequire("cW28x");

var $lMQGH = parcelRequire("lMQGH");
/* Node.js helper references. */ var $935e70fe57caa939$var$nodeIsRegExp = $lMQGH && $lMQGH.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $935e70fe57caa939$var$isRegExp = $935e70fe57caa939$var$nodeIsRegExp ? $cW28x($935e70fe57caa939$var$nodeIsRegExp) : $3euyi;
module.exports = $935e70fe57caa939$var$isRegExp;

});
parcelRegister("3euyi", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $25aa60f3dfdc1028$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $25aa60f3dfdc1028$var$baseIsRegExp(value) {
    return $fC1Kz(value) && $beQoo(value) == $25aa60f3dfdc1028$var$regexpTag;
}
module.exports = $25aa60f3dfdc1028$var$baseIsRegExp;

});



parcelRegister("467lJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc639d9ac2372482$export$2e2bcd8739ae039);

var $8BkAH = parcelRequire("8BkAH");

var $8hiuq = parcelRequire("8hiuq");

var $l7mS2 = parcelRequire("l7mS2");

var $5jDRa = parcelRequire("5jDRa");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc639d9ac2372482$export$2e2bcd8739ae039 = {
    forbidden: $8BkAH.default,
    genericError: $8hiuq.default,
    serverError: $l7mS2.default,
    unauthorized: $5jDRa.default
};

});
parcelRegister("8BkAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $47acdb71562a5159$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $47acdb71562a5159$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.forbidden.title",
        "defaultMessage": "You don't have permission to do that"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.forbidden.description",
        "defaultMessage": "Ask your Jira admin for help."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47acdb71562a5159$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $47acdb71562a5159$var$messages.title,
        description: $47acdb71562a5159$var$messages.description,
        messageId: 'flags.ui.configurations.errors.forbidden.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("8hiuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd4533bf12eb3f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ffd4533bf12eb3f1$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.generic-error.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.generic-error.description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffd4533bf12eb3f1$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $ffd4533bf12eb3f1$var$messages.title,
        description: $ffd4533bf12eb3f1$var$messages.description,
        messageId: 'flags.ui.configurations.errors.generic-error.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("l7mS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a915dd4c1d2142$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $31a915dd4c1d2142$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.server-error.title",
        "defaultMessage": "We're having some trouble"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.server-error.description",
        "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31a915dd4c1d2142$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $31a915dd4c1d2142$var$messages.title,
        description: $31a915dd4c1d2142$var$messages.description,
        messageId: 'flags.ui.configurations.errors.server-error.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("5jDRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8754751d720d57d4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $8754751d720d57d4$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.unauthorized.title",
        "defaultMessage": "You're logged out"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.unauthorized.description",
        "defaultMessage": "Log back in and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8754751d720d57d4$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $8754751d720d57d4$var$messages.title,
        description: $8754751d720d57d4$var$messages.description,
        messageId: 'flags.ui.configurations.errors.unauthorized.flag.error',
        messageType: 'transactional'
    });

});


parcelRegister("01j5n", function(module, exports) {

$parcel$export(module.exports, "isUserNetworkError", () => $5ca31bd2f34603ab$export$34bc86f6bf17f1e0);
$parcel$export(module.exports, "isClientSideThirdPartyAppError", () => $5ca31bd2f34603ab$export$ed0f33c09abc69f3);
$parcel$export(module.exports, "isFailureStatusCode", () => $5ca31bd2f34603ab$export$790c76b8c83c3421);
$parcel$export(module.exports, "default", () => $5ca31bd2f34603ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $g0Gtc = parcelRequire("g0Gtc");

var $2YZCu = parcelRequire("2YZCu");

var $kobfu = parcelRequire("kobfu");

var $fZneA = parcelRequire("fZneA");

var $7tQej = parcelRequire("7tQej");

var $4R6GH = parcelRequire("4R6GH");

var $hdE8g = parcelRequire("hdE8g");

var $3vXOY = parcelRequire("3vXOY");

var $e2KRD = parcelRequire("e2KRD");

const $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus = ({ location: location, statusCode: statusCode, traceId: traceId, hash: hash, buildKey: buildKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReasonWithStatusCode)((0, $3e83829bdc9c581d$export$a3bb34ea5a520df8), statusCode),
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
const $5ca31bd2f34603ab$export$34bc86f6bf17f1e0 = (error)=>{
    const networkErrorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'name'
    ], null);
    const networkErrorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'statusCode'
    ], null);
    if (networkErrorName && !networkErrorStatusCode) (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.network.error.unknown.error.name', networkErrorName);
    // A fetch() promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side,
    // although this usually means permission issues or similar — a 404 does not constitute a network error
    // more https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
    return networkErrorName === 'TypeError' || networkErrorName === 'AbortError';
};
const $5ca31bd2f34603ab$export$8a5d666d6e5b82fc = (error)=>{
    if (error?.name === 'ChunkLoadError') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.chunk.load.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $5ca31bd2f34603ab$export$7193151b5738a995 = (error)=>{
    if (error?.name === 'ResponseNullError') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.response.null.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $5ca31bd2f34603ab$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS = [
    'FPClassifier is not defined'
];
const $5ca31bd2f34603ab$var$KNOWN_REACT_PERFORMANCE_ERRORS = [
    'Maximum update depth exceeded',
    'Minified React error #185'
];
const $5ca31bd2f34603ab$export$ed0f33c09abc69f3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error.message) && !!$5ca31bd2f34603ab$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $5ca31bd2f34603ab$export$d6897bdd9fc569e3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error.message) && !!$5ca31bd2f34603ab$var$KNOWN_REACT_PERFORMANCE_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $5ca31bd2f34603ab$export$790c76b8c83c3421 = (statusCode)=>{
    if (statusCode == null || statusCode === 429 || statusCode >= 500) // jira is too busy, unknown error or server error
    return true;
    if (statusCode >= 400 && statusCode < 500) return false;
    return true;
};
const $5ca31bd2f34603ab$var$detectLocalNetworkErrors = (errorResponse)=>{
    if ($5ca31bd2f34603ab$export$34bc86f6bf17f1e0(errorResponse)) return 0, $3e83829bdc9c581d$export$3c39b2049cd1acb3;
    if ($5ca31bd2f34603ab$export$8a5d666d6e5b82fc(errorResponse)) return 0, $3e83829bdc9c581d$export$fdfe3175a0c7be80;
    if ((0, $fZneA.isClientFetchError)(errorResponse)) return 0, $3e83829bdc9c581d$export$38fe4329f59f7ac5;
    if ($5ca31bd2f34603ab$export$7193151b5738a995(errorResponse)) return 0, $3e83829bdc9c581d$export$49d11848b43d6dbf;
    if ($5ca31bd2f34603ab$export$ed0f33c09abc69f3(errorResponse)) return 0, $3e83829bdc9c581d$export$32e56551129a1642;
    if ($5ca31bd2f34603ab$export$d6897bdd9fc569e3(errorResponse) && (0, $4R6GH.fg)('tnk-ignore-react-performance-error-for-slo')) return 0, $3e83829bdc9c581d$export$23146e1063f522c4;
    return null;
};
const $5ca31bd2f34603ab$var$responseToSla = (errorResponse, location)=>{
    const statusCode = (0, $3vXOY.extractStatusCode)(errorResponse);
    const abortFailureReason = $5ca31bd2f34603ab$var$detectLocalNetworkErrors(errorResponse);
    const traceId = (0, $hdE8g.extractTraceId)(errorResponse) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const hash = (0, $kobfu.getErrorHash)(errorResponse) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const buildKey = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(window, [
        'BUILD_KEY'
    ]) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const errorResponseMessage = errorResponse?.message || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const isAbortReactPerformanceError = abortFailureReason === (0, $3e83829bdc9c581d$export$23146e1063f522c4);
    const isBacklogLocation = location === 'ng-backlog' || location === 'cmp-backlog';
    if (abortFailureReason && (!isAbortReactPerformanceError || isAbortReactPerformanceError && isBacklogLocation)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReason)(abortFailureReason),
            error: errorResponseMessage,
            statusCode: statusCode || '',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === null) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.unknown.failure', (0, $3e83829bdc9c581d$export$b4f05a271d0831dc), {
            networkErrorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'networkError',
                'name'
            ], ''),
            networkStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'networkError',
                'statusCode'
            ], ''),
            graphqlStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'graphQLErrors',
                0,
                'extensions',
                'statusCode'
            ], ''),
            location: location,
            error: JSON.stringify(errorResponse, Object.getOwnPropertyNames(errorResponse)),
            hash: hash
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$b4f05a271d0831dc)),
                traceId: traceId,
                buildKey: buildKey,
                error: JSON.stringify({
                    message: errorResponseMessage
                }),
                hash: hash
            }
        });
    }
    // based on https://hello.atlassian.net/wiki/spaces/agile/pages/512782292/SWAG+response+handling+on+the+client
    // `EXPERIENCE_TRACKER_LOCATION_BACKLOG`, defined in `src/packages/software/backlog/src/common/constants/analytics.tsx`
    if (location === 'ng-backlog') {
        if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$c4493605407b2630)),
                error: errorResponseMessage,
                statusCode: statusCode.toString(),
                buildKey: buildKey,
                traceId: traceId,
                hash: hash
            }
        });
    }
    if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode === 429) // jira is too busy
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$7b9f56c34c008ec2)),
            error: errorResponseMessage,
            statusCode: '429',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === 404) // redirect to "all-projects" page or error page, when page is not found
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/software/projects/not-found"
    });
    if (statusCode > 400 && statusCode < 500) // the rest of 40X
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode >= 500) return $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
    return $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
};
var $5ca31bd2f34603ab$export$2e2bcd8739ae039 = $5ca31bd2f34603ab$var$responseToSla;

});
parcelRegister("hdE8g", function(module, exports) {

$parcel$export(module.exports, "extractTraceId", () => $6db1ddf832c04f2d$export$431eacb6aecbacdf);
const $6db1ddf832c04f2d$export$431eacb6aecbacdf = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>String(error?.traceId || error?.networkError?.traceId || '');

});

parcelRegister("e2KRD", function(module, exports) {

$parcel$export(module.exports, "createFailureReason", () => $360af9265ac477eb$export$b9e48ed6f1b092c7);
$parcel$export(module.exports, "createFailureReasonWithStatusCode", () => $360af9265ac477eb$export$cc7dce678df87fe9);
const $360af9265ac477eb$export$b9e48ed6f1b092c7 = (reason)=>({
        failureReason: reason,
        errorMessage: reason
    });
const $360af9265ac477eb$export$cc7dce678df87fe9 = (reason, statusCode)=>{
    if (statusCode === undefined || statusCode === null) return {
        failureReason: reason,
        statusCode: '[unknown]',
        errorMessage: `${reason}-unknown`
    };
    return {
        failureReason: reason,
        statusCode: `${statusCode}`,
        errorMessage: `${reason}-${statusCode}`
    };
};

});

const $3e83829bdc9c581d$export$b4f05a271d0831dc = 'critical-data-failed-unknown-reason';
const $3e83829bdc9c581d$export$a3bb34ea5a520df8 = 'critical-data-failed-with-status-code';
const $3e83829bdc9c581d$export$7b9f56c34c008ec2 = '429-error';
const $3e83829bdc9c581d$export$c4493605407b2630 = 'client-error';
const $3e83829bdc9c581d$export$23146e1063f522c4 = 'react-performance-error';
const $3e83829bdc9c581d$export$3c39b2049cd1acb3 = 'user-network-error';
const $3e83829bdc9c581d$export$fdfe3175a0c7be80 = 'chunk-load-error';
const $3e83829bdc9c581d$export$38fe4329f59f7ac5 = 'client-fetch-error';
const $3e83829bdc9c581d$export$49d11848b43d6dbf = 'response-null-error';
const $3e83829bdc9c581d$export$32e56551129a1642 = 'client-third-party-app-error';
const $3e83829bdc9c581d$export$fa14a20fcf1b1eb4 = 'unknown';


parcelRegister("bqTfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $be5de4c81d111b39$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $be5de4c81d111b39$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dismissState: {
        "id": "development-summary-development-field.empty-summary.absolute-close-button.dismiss-state",
        "defaultMessage": "Hide empty development information"
    }
});

});


parcelRegister("hCEGj", function(module, exports) {

$parcel$export(module.exports, "default", () => $60913ca92852b4fe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gal8o = parcelRequire("gal8o");

var $2gCtH = parcelRequire("2gCtH");

var $bC2fB = parcelRequire("bC2fB");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $idwnU = parcelRequire("idwnU");

var $027Zr = parcelRequire("027Zr");

var $faqOn = parcelRequire("faqOn");
const $60913ca92852b4fe$export$4125f24632a72023 = ()=>{
    // be prepared for the worst code.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById('ghx-issue-fragment');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.AJS) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS.$(container).trigger('minimise-before-crossflow');
};
const $60913ca92852b4fe$export$2ccd5b8c0427dfe4 = ()=>{
    // be prepared for the worst code.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById('ghx-issue-fragment');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.AJS) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS.$(container).trigger('expand-after-crossflow');
};
const $60913ca92852b4fe$export$216944d0df4c048e = ({ onCloseEmptyStateDialog: onCloseEmptyStateDialog, onShowEmptyStateDialog: onShowEmptyStateDialog, isClassicProject: isClassicProject, isEmptyStateDialogShown: isEmptyStateDialogShown, onCompleteConnection: onCompleteConnection })=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const isModal = (0, $2gCtH.useIsModal)();
    const [, updateSelectedIssueQueryParam] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const closeEmptyState = ()=>{
        onCloseEmptyStateDialog();
    };
    const showEmptyState = ()=>{
        onShowEmptyStateDialog();
    };
    const closeModalIssue = ()=>{
        if (isModal) {
            if (isClassicProject) $60913ca92852b4fe$export$4125f24632a72023();
            updateSelectedIssueQueryParam();
        }
    };
    const showModalIssue = ()=>{
        if (isModal) {
            if (isClassicProject) $60913ca92852b4fe$export$2ccd5b8c0427dfe4();
            updateSelectedIssueQueryParam(issueKey);
        }
    };
    const onCrossFlowStart = ()=>{
        closeEmptyState();
        closeModalIssue();
    };
    const onCrossFlowEnd = (success)=>{
        showModalIssue();
        if (success) showEmptyState();
    };
    return isEmptyStateDialogShown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gal8o.AsyncDevPanelEmptyStateModal), {
        onCloseModal: closeEmptyState,
        onComplete: onCompleteConnection,
        onCrossFlowStart: onCrossFlowStart,
        onCrossFlowEnd: onCrossFlowEnd
    }) : null;
};
var $60913ca92852b4fe$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        isEmptyStateDialogShown: (0, $faqOn.isEmptyStateDialogShownSelector)(state),
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        isClassicProject: !(0, $idwnU.isSimplifiedProjectSelector)(state)
    }), (dispatch)=>({
        onCloseEmptyStateDialog: ()=>dispatch((0, $027Zr.closeEmptyStateDialog)()),
        onShowEmptyStateDialog: ()=>dispatch((0, $027Zr.showEmptyStateDialog)()),
        onCompleteConnection: ()=>{
            dispatch((0, $027Zr.fetchDevPanelRequest)());
        }
    }))($60913ca92852b4fe$export$216944d0df4c048e);

});
parcelRegister("gal8o", function(module, exports) {

$parcel$export(module.exports, "AsyncDevPanelEmptyStateModal", () => $6b4ed90a5e07b544$export$7e6c4aadb77b1832);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6b4ed90a5e07b544$var$LazyDevPanelEmptyStateModal = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7aUtY")), {
    ssr: false,
    moduleId: "./src/packages/development/empty-state-modal/src/main.tsx"
});
const $6b4ed90a5e07b544$export$7e6c4aadb77b1832 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dev-panel-empty-state-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b4ed90a5e07b544$var$LazyDevPanelEmptyStateModal, props));

});
parcelRegister("7aUtY", function(module, exports) {

let $539547d395beaaea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $539547d395beaaea$var$load("kno0B").then(()=>parcelRequire('8v3BF'));

});


parcelRegister("jQ7vZ", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $9fff0bf09ea99829$export$ae316f0eeb712a36);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $9fff0bf09ea99829$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $doZTA.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $5uXOq.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});


parcelRegister("3t0A0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f514bd163302cc1c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f514bd163302cc1c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonCta: {
        "id": "development-summary-development-field.empty-summary.button-cta",
        "defaultMessage": "Integrate source code"
    },
    notIntegrated: {
        "id": "development-summary-development-field.empty-summary.not-integrated",
        "defaultMessage": "Not Integrated"
    }
});

});

parcelRegister("cXjK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $547120ae680aa4eb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7i3ao = parcelRequire("7i3ao");
const $547120ae680aa4eb$var$SlideDownOnMount = ({ children: children })=>{
    const [show, setShow] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setShow(true);
    }, [
        setShow
    ]);
    const { ref: ref } = (0, $7i3ao.useResizingHeight)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($547120ae680aa4eb$var$HiddenOverflowContainer, {
        ref: ref
    }, show && children);
};
var $547120ae680aa4eb$export$2e2bcd8739ae039 = $547120ae680aa4eb$var$SlideDownOnMount;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $547120ae680aa4eb$var$HiddenOverflowContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _19pkmgjw _2hwxmgjw _otyrmgjw _18u0mgjw _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7i3ao", function(module, exports) {

$parcel$export(module.exports, "useResizingHeight", () => $5f7cf4464a63f574$export$da99457d6430d83);
$parcel$export(module.exports, "ResizingHeight", () => $5f7cf4464a63f574$export$204d7b6d1491a2d3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dWt6p = parcelRequire("dWt6p");


var $lObw7 = parcelRequire("lObw7");

var $bh8Xz = parcelRequire("bh8Xz");

var $3GP8X = parcelRequire("3GP8X");

var $fsENI = parcelRequire("fsENI");

var $5Otrq = parcelRequire("5Otrq");
const $5f7cf4464a63f574$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $lObw7.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $eba99f58997c09b3$export$c07234257a03d5e9) } = {})=>{
    const prevDimensions = (0, $5uXOq.useRef)();
    const [element, setElementRef] = (0, $3GP8X.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $bh8Xz.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $bh8Xz.useRequestAnimationFrame)();
    (0, $5Otrq.useSnapshotBeforeUpdate)(()=>{
        if ((0, $dWt6p.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $fsENI.useLayoutEffect)(()=>{
        if ((0, $dWt6p.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $5f7cf4464a63f574$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $5f7cf4464a63f574$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children(resizing)
    });
};

});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eba99f58997c09b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

parcelRegister("5Otrq", function(module, exports) {

$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $80940ec2167ac037$export$9e95200239cd148b);

var $5uXOq = parcelRequire("5uXOq");

var $fsENI = parcelRequire("fsENI");
const $80940ec2167ac037$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $5uXOq.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $fsENI.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});




parcelRegister("iowbr", function(module, exports) {

$parcel$export(module.exports, "default", () => $006037a96446781f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGvGJ = parcelRequire("dGvGJ");

var $fNobW = parcelRequire("fNobW");

var $aJ0X5 = parcelRequire("aJ0X5");

var $4UYm5 = parcelRequire("4UYm5");

var $fHrVj = parcelRequire("fHrVj");

var $4HJKb = parcelRequire("4HJKb");

var $2Eelh = parcelRequire("2Eelh");

var $9raOO = parcelRequire("9raOO");

var $aUqdk = parcelRequire("aUqdk");

var $c5h9X = parcelRequire("c5h9X");

var $5km34 = parcelRequire("5km34");

var $k9tz2 = parcelRequire("k9tz2");

var $8Wv52 = parcelRequire("8Wv52");

var $2SC5w = parcelRequire("2SC5w");

var $2HUDK = parcelRequire("2HUDK");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $93Yeu = parcelRequire("93Yeu");

var $bC2fB = parcelRequire("bC2fB");

var $l8ruj = parcelRequire("l8ruj");

var $6s1PB = parcelRequire("6s1PB");

var $7CMCs = parcelRequire("7CMCs");

var $eJGA0 = parcelRequire("eJGA0");

var $koeKL = parcelRequire("koeKL");

var $a4KlA = parcelRequire("a4KlA");

var $5yJb9 = parcelRequire("5yJb9");

var $90yGq = parcelRequire("90yGq");

var $cSD7y = parcelRequire("cSD7y");

var $6Saiz = parcelRequire("6Saiz");

var $cXjK2 = parcelRequire("cXjK2");

var $4QXBz = parcelRequire("4QXBz");

var $idwnU = parcelRequire("idwnU");

var $faqOn = parcelRequire("faqOn");

var $1gtls = parcelRequire("1gtls");

var $gya2S = parcelRequire("gya2S");

var $khxu3 = parcelRequire("khxu3");

var $3QzKK = parcelRequire("3QzKK");
const $006037a96446781f$var$NoWrapperComponent = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
const $006037a96446781f$var$ConditionalSlideDown = (0, $cSD7y.componentWithFG)('jiv-20508-remove-height-animation-dev-panel', $006037a96446781f$var$NoWrapperComponent, (0, $cXjK2.default));
const $006037a96446781f$var$useIsAutoDevEnabledOnIssueView = (projectKey)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const [isAutoDevEnabled, state] = (0, $a4KlA.useIsAutoDevEnabled)(atlassianAccountId, cloudId, (0, $5yJb9.default)(), !(0, $4R6GH.fg)('autodev-disable-rovo-check-in-issue-view'));
    return {
        isEntitlementsLoading: state !== (0, $a4KlA.Status).DETERMINED,
        userHasEntitlements: isAutoDevEnabled,
        legacyFeatureflagsEnabled: (0, $4R6GH.fg)('autodev-on-jira-issue') && // eslint-disable-next-line jira/ff/inline-expVal-params
        ((0, $6s1PB.expVal)('autodev-project-enabled', 'value', []).includes(projectKey) || (0, $4R6GH.fg)('autodev-enabled-by-user'))
    };
};
const $006037a96446781f$var$useIsCodePlannerEnabledOnIssueView = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const { hasRovoDevAgentsEntitlement: hasRovoDevAgentsEntitlement } = (0, $1gtls.useHasRovoDevAgentsEntitlement)(atlassianAccountId, cloudId, (0, $5yJb9.default)(), (0, $4R6GH.fg)('code-planner-agent-limited-beta') && !(0, $4R6GH.fg)('devai-code-planner-issue-view-panel'));
    return {
        isCodePlannerEnabledOnIssueView: !(0, $4R6GH.fg)('devai-code-planner-issue-view-panel') && // technical-planner-on-jira-issue is the internal dogfooding flag
        (hasRovoDevAgentsEntitlement || (0, $4R6GH.fg)('technical-planner-on-jira-issue'))
    };
};
const $006037a96446781f$export$46453a0401d6cd1a = ({ hasSummaryData: hasSummaryData, showSummarySectionMessage: showSummarySectionMessage, review: review, build: build, deployment: deployment, pullRequest: pullRequest, issueKey: issueKey, issueId: issueId, hasBranchCapabilities: hasBranchCapabilities, analyticsAttributes: analyticsAttributes, branch: branch, branchTargets: branchTargets, legacyDataSummary: legacyDataSummary, commit: commit, detailsHasInstanceErrors: detailsHasInstanceErrors, hasDevelopmentDataInProject: hasDevelopmentDataInProject })=>{
    const { showDevDetailDialog: showDevDetailDialog } = (0, $4HJKb.useDevOpsDetailsDialogLoaderActions)(`devInfoPanelApp${issueKey}`);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey) ?? '';
    const { userHasEntitlements: userHasEntitlements, legacyFeatureflagsEnabled: legacyFeatureflagsEnabled, isEntitlementsLoading: isEntitlementsLoading } = $006037a96446781f$var$useIsAutoDevEnabledOnIssueView(projectKey);
    const { isCodePlannerEnabledOnIssueView: isCodePlannerEnabledOnIssueView } = $006037a96446781f$var$useIsCodePlannerEnabledOnIssueView();
    const onShowDevDetailsDialog = (clickEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
    devInfoType)=>{
        clickEvent && clickEvent.preventDefault();
        const detailDialogAnalyticsAttributes = {
            ...analyticsAttributes,
            summaryType: devInfoType
        };
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'summaryItem'
        }), 'devpanelsummary', detailDialogAnalyticsAttributes);
        const panelItemType = (0, $k9tz2.toDetailDialogDataType)(devInfoType);
        if (devInfoType === (0, $5km34.SUMMARY_ITEM_REVIEW)) {
            const summaryItem = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'LegacyDevSummary'.
            legacyDataSummary && legacyDataSummary[panelItemType] ? legacyDataSummary[panelItemType] : undefined;
            showDevDetailDialog(// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
            panelItemType, summaryItem, issueKey, issueId);
        } else showDevDetailDialog(// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        panelItemType, undefined, issueKey, issueId);
    };
    const { count: branchesCount = 0 } = branch ?? {};
    return !hasSummaryData && !hasDevelopmentDataInProject && branchTargets.length === 0 && (0, $4R6GH.fg)('isotopes-devsummary-hide-development-no-connection') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !hasSummaryData && showSummarySectionMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3QzKK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Saiz.default), {
        afterHeadingNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khxu3.default), null),
        pinnable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($006037a96446781f$var$ConditionalSlideDown, null, isCodePlannerEnabledOnIssueView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "view-technical-planner-issue-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraTechnicalPlanner",
        teamName: "nova",
        id: "JiraTechnicalPlannerDevSummaryField",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eJGA0.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "autodev-enabled-hold",
        hold: isEntitlementsLoading
    }), (userHasEntitlements || legacyFeatureflagsEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "view-autodev-issue-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4UYm5.AutodevErrorBoundary), {
        id: "JiraAutodevDevSummaryField",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHrVj.AutodevIssueContextStoreContainer), {
        issueId: issueId,
        issueKey: issueKey,
        projectId: projectId,
        projectKey: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJ0X5.default), {
        issueId: issueId
    }))))), !hasSummaryData && !hasDevelopmentDataInProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eelh.AppConfigurationPromptSummary), {
        location: "DEVELOPMENT_PANEL",
        panelHasOtherPrompts: hasBranchCapabilities
    }), branchTargets.length > 0 && (0, $6s1PB.expVal)('jira-work-suggestions-open-in-ide-experiment', 'openButton', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gya2S.default), {
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9raOO.default), {
        branch: branch,
        branchTargets: branchTargets,
        hasBranchCapabilities: hasBranchCapabilities,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $5km34.SUMMARY_ITEM_BRANCH)),
        issueId: issueId,
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5h9X.default), {
        commit: commit,
        hasCommitCapabilities: hasBranchCapabilities,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $5km34.SUMMARY_ITEM_COMMIT)),
        issueId: issueId,
        issueKey: issueKey
    }), hasSummaryData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2SC5w.default), {
        branchesCount: branchesCount,
        hasErrors: detailsHasInstanceErrors,
        pullRequest: pullRequest,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $5km34.SUMMARY_ITEM_PULLREQUEST)),
        issueId: issueId,
        issueKey: issueKey
    }), hasSummaryData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HUDK.default), {
        review: review,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $5km34.SUMMARY_ITEM_REVIEW))
    }), hasSummaryData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUqdk.default), {
        build: build,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $5km34.SUMMARY_ITEM_BUILD))
    }), hasSummaryData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Wv52.default), {
        deployment: deployment,
        issueKey: issueKey,
        // @ts-expect-error - TS2322 - Type '(e: any) => void' is not assignable to type '() => void'. | TS7006 - Parameter 'e' implicitly has an 'any' type.
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $5km34.SUMMARY_ITEM_DEPLOYMENT))
    }))));
};
const $006037a96446781f$var$getAnalyticsIssueDataMemoized = ()=>(0, $dGvGJ.createSelector)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state)=>(0, $4QXBz.getAnalyticsIssueData)(state), (res)=>res);
const $006037a96446781f$var$mapStateToPropsFactory = ()=>{
    const getAnalyticsIssueDataInstance = $006037a96446781f$var$getAnalyticsIssueDataMemoized();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (state)=>({
            showSummarySectionMessage: (0, $faqOn.summarySectionMessageSelector)(state),
            // hasSummaryData includes errors
            hasSummaryData: (0, $faqOn.hasSummaryInformationSelector)(state),
            // hasSummaryItems does not include errors
            hasSummaryItems: (0, $faqOn.hasSummaryItemsSelector)(state),
            legacyDataSummary: (0, $faqOn.legacyDataInformationSelector)(state),
            analyticsAttributes: getAnalyticsIssueDataInstance(state),
            review: (0, $faqOn.reviewSummaryItemSelector)(state),
            build: (0, $faqOn.buildSummaryItemSelector)(state),
            commit: (0, $faqOn.commitSummaryItemSelector)(state),
            deployment: (0, $faqOn.deploymentSummaryItemSelector)(state),
            pullRequest: (0, $faqOn.pullRequestSummaryItemSelector)(state),
            issueKey: (0, $idwnU.issueKeySelector)(state),
            issueId: (0, $idwnU.issueIdSelector)(state),
            hasBranchCapabilities: (0, $faqOn.hasBranchCapabilitiesSelector)(state),
            branch: (0, $faqOn.branchSelector)(state),
            branchTargets: (0, $faqOn.createBranchTargetsSelector)(state) ?? [],
            detailsHasInstanceErrors: (0, $faqOn.detailsHasInstanceErrorsSelector)(state),
            hasDevelopmentDataInProject: (0, $faqOn.hasDevelopmentDataInProjectSelector)(state)
        });
};
var $006037a96446781f$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($006037a96446781f$var$mapStateToPropsFactory, {})($006037a96446781f$export$46453a0401d6cd1a);

});
parcelRegister("2Eelh", function(module, exports) {

$parcel$export(module.exports, "AppConfigurationPromptSummary", () => $cba21df8ff27903e$export$e7fc2879f890f36f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $kEVMo = parcelRequire("kEVMo");

var $k2tiP = parcelRequire("k2tiP");

var $aYAc3 = parcelRequire("aYAc3");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8nZfJ = parcelRequire("8nZfJ");

var $7rNJI = parcelRequire("7rNJI");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $8vRTB = parcelRequire("8vRTB");
const $cba21df8ff27903e$export$e7fc2879f890f36f = ({ location: location, panelHasOtherPrompts: panelHasOtherPrompts = false })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isJiraAdmin = (0, $itmJb.useIsAdmin)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $8nZfJ.appConfigurationPromptEntryPoint), {
        location: location,
        cloudId: cloudId
    });
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isSiteAdmin || isJiraAdmin) entryPointActions.load();
    }, [
        entryPointActions,
        isSiteAdmin,
        isJiraAdmin
    ]);
    if (!isSiteAdmin && !isJiraAdmin) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jswDevelopmentSummaryAppConfigPromptEntryPoint",
        packageName: "development-field",
        entryPointReferenceSubject: entryPointReferenceSubject,
        errorFallback: "flag",
        runtimeProps: {
            location: location,
            cloudId: cloudId,
            getDropdownTrigger: ({ ref: ref, onClick: onClick, appIcon: appIcon, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _2lx21bp4 _1bsb1osq _18u0idpf"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, location === 'DEVELOPMENT_PANEL' && formatMessage((0, $8vRTB.default).codeToolsPromptLabel), location === 'RELEASES_PANEL' && formatMessage((0, $8vRTB.default).deploymentToolsPromptLabel), location === 'SECURITY_PANEL' && formatMessage((0, $8vRTB.default).securityToolsPromptLabel)),
                    icon: appIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
                        spacing: "spacious",
                        label: "finish-tool-setup-icon"
                    }),
                    secondaryData: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                        spacing: "spacious",
                        label: "providers-dropdown",
                        size: "small"
                    }),
                    reference: ref,
                    ...props,
                    onClick: onClick,
                    linkFormatting: true,
                    "data-testid": "development-summary-app-config-prompt-field.ui.summary-item",
                    disableAnimationOnUpdates: true
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $cba21df8ff27903e$var$lozengeWrapperStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
                    appearance: "moved"
                }, formatMessage((0, $8vRTB.default).pendingLozenge))), panelHasOtherPrompts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                    className: (0, $bwpsq.default)([
                        "_2rko1l7b _n7zludwz _19pkutpp _otyrutpp _18u01lpd _t9ec1e99"
                    ])
                }))
        }
    });
};
const $cba21df8ff27903e$var$wrapperStyles = null;
const $cba21df8ff27903e$var$lozengeWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});
const $cba21df8ff27903e$var$separatorStyles = null;

});
parcelRegister("8nZfJ", function(module, exports) {

$parcel$export(module.exports, "appConfigurationPromptEntryPoint", () => $a3d30ba93a8996ee$export$9f3d34e7a5ba63ec);

var $59yA2 = parcelRequire("59yA2");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");
const $a3d30ba93a8996ee$var$locationToProviderTypes = (location)=>{
    switch(location){
        case 'DEVELOPMENT_PANEL':
            return [
                'DEVELOPMENT_INFO'
            ];
        case 'RELEASES_PANEL':
            return [
                'DEPLOYMENTS'
            ];
        case 'SECURITY_PANEL':
            return [
                'SECURITY'
            ];
        default:
            return [];
    }
};

const $a3d30ba93a8996ee$export$9f3d34e7a5ba63ec = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3CDST")), {
        moduleId: "873c3603",
        priority: "interaction"
    }),
    getPreloadProps: ({ location: location, cloudId: cloudId })=>({
            queries: {
                queryRef: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $59yA2.default,
                    variables: {
                        cloudId: cloudId,
                        providerTypes: $a3d30ba93a8996ee$var$locationToProviderTypes(location),
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        location: location
                    }
                }
            }
        })
});

});
parcelRegister("59yA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d07c1080a08c83$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03e7291518456d4895303607753b8334>>
 * @relayHash e0f1f2a58d6cdd8d7028571b28e491fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6b26f86bac3fdf64d54f307c65f97fec71607084cfed9ade7abcc3ccf4c0c13b
const $93d07c1080a08c83$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6b26f86bac3fdf64d54f307c65f97fec71607084cfed9ade7abcc3ccf4c0c13b",
        "metadata": {},
        "name": "uiAppConfigurationPromptQuery",
        "operationKind": "query",
        "text": null
    }
};
var $93d07c1080a08c83$export$2e2bcd8739ae039 = $93d07c1080a08c83$var$node;

});

parcelRegister("3CDST", function(module, exports) {

let $2a33dbef13c9032b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2a33dbef13c9032b$var$load("RdxYP").then(()=>parcelRequire('hgpue'));

});


parcelRegister("8vRTB", function(module, exports) {

$parcel$export(module.exports, "default", () => $916c14616c9abd92$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $916c14616c9abd92$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    codeToolsPromptLabel: {
        "id": "development-summary-app-config-prompt-field.code-tools-prompt-label",
        "defaultMessage": "Set up code tools"
    },
    deploymentToolsPromptLabel: {
        "id": "development-summary-app-config-prompt-field.deployment-tools-prompt-label",
        "defaultMessage": "Set up deployment tools"
    },
    securityToolsPromptLabel: {
        "id": "development-summary-app-config-prompt-field.security-tools-prompt-label",
        "defaultMessage": "Set up security tools"
    },
    pendingLozenge: {
        "id": "development-summary-app-config-prompt-field.pending-lozenge",
        "defaultMessage": "PENDING"
    }
});

});


parcelRegister("aUqdk", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc54f7970ddfb375$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c2i4s = parcelRequire("c2i4s");

var $kxFlx = parcelRequire("kxFlx");

var $7rNJI = parcelRequire("7rNJI");

var $ousew = parcelRequire("ousew");

var $aWse0 = parcelRequire("aWse0");

var $11lem = parcelRequire("11lem");
const $fc54f7970ddfb375$export$b141efd0b0fb9174 = (previousProps, nextProps)=>nextProps.build?.count === previousProps.build?.count && nextProps.build?.lastUpdated === previousProps.build?.lastUpdated && nextProps.build?.failedBuildCount === previousProps.build?.failedBuildCount && nextProps.build?.successfulBuildCount === previousProps.build?.successfulBuildCount && nextProps.build?.unknownBuildCount === previousProps.build?.unknownBuildCount && nextProps.build?.url === previousProps.build?.url;
const $fc54f7970ddfb375$export$77b5f1d340d6466b = /*#__PURE__*/ (0, $5uXOq.memo)(({ build: build, onClick: onClick })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { count: count = 0, failedBuildCount: failedBuildCount = 0, successfulBuildCount: successfulBuildCount = 0 } = build ?? {};
    const { title: title, secondaryData: secondaryData } = (0, $5uXOq.useMemo)(()=>{
        let titleComponent;
        let icon;
        if (failedBuildCount > 0) {
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kxFlx))), {
                spacing: "spacious",
                label: "dev-panel-failed-build-icon",
                color: "var(--ds-icon-danger, #C9372C)"
            });
            titleComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $11lem.default).failingBuildsTitle,
                values: {
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc54f7970ddfb375$var$BoldFont, null, chunks),
                    count: formatNumber(failedBuildCount)
                }
            });
        } else if (successfulBuildCount > 0) {
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
                spacing: "spacious",
                label: "dev-panel-successful-build-icon",
                color: "var(--ds-icon-success, #22A06B)"
            });
            titleComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $11lem.default).successfulBuildsTitle,
                values: {
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc54f7970ddfb375$var$BoldFont, null, chunks),
                    count: formatNumber(successfulBuildCount)
                }
            });
        } else {
            icon = null;
            titleComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $11lem.default).incompleteBuildsTitle,
                values: {
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc54f7970ddfb375$var$BoldFont, null, chunks),
                    count: formatNumber(count)
                }
            });
        }
        return {
            title: titleComponent,
            secondaryData: icon
        };
    }, [
        count,
        failedBuildCount,
        formatNumber,
        successfulBuildCount
    ]);
    const shownItemCount = (0, $5uXOq.useMemo)(()=>{
        let buildCountToBeShown;
        if (failedBuildCount > 0) buildCountToBeShown = failedBuildCount;
        else if (successfulBuildCount > 0) buildCountToBeShown = successfulBuildCount;
        else buildCountToBeShown = count;
        return buildCountToBeShown;
    }, [
        count,
        failedBuildCount,
        successfulBuildCount
    ]);
    if (build && count > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        title: title,
        secondaryData: secondaryData,
        href: undefined,
        onClick: onClick,
        itemType: "build",
        itemCount: shownItemCount,
        oneClickUrl: build.url,
        oneClickToolTipContent: formatMessage((0, $11lem.default).tooltip),
        "data-testid": "development-summary-build.ui.summary-item"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
}, $fc54f7970ddfb375$export$b141efd0b0fb9174);
var $fc54f7970ddfb375$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $fc54f7970ddfb375$export$77b5f1d340d6466b;
const $fc54f7970ddfb375$var$BoldFont = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("11lem", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe95d63b2ac2bbb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $afe95d63b2ac2bbb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    failingBuildsTitle: {
        "id": "development-summary-build.failingBuildsMessageTitle",
        "defaultMessage": "<bold>{count}</bold> {count, plural, one {build} other {builds}} failing"
    },
    successfulBuildsTitle: {
        "id": "development-summary-build.successfulBuildsMessageTitle",
        "defaultMessage": "<bold>{count}</bold> {count, plural, one {build} other {builds}}"
    },
    incompleteBuildsTitle: {
        "id": "development-summary-build.incompleteBuildsMessageTitle",
        "defaultMessage": "<bold>{count}</bold> {count, plural, one {build} other {builds}} incomplete"
    },
    tooltip: {
        "id": "development-summary-build.tooltip",
        "defaultMessage": "Open build"
    }
});

});


parcelRegister("k9tz2", function(module, exports) {

$parcel$export(module.exports, "toDetailDialogDataType", () => $1fee74d6cd0cca0d$export$c7936759ace5464a);

var $5km34 = parcelRequire("5km34");
const $1fee74d6cd0cca0d$export$c7936759ace5464a = (itemType)=>{
    const needsTransformation = ![
        (0, $5km34.SUMMARY_ITEM_BRANCH),
        (0, $5km34.SUMMARY_ITEM_BUILD),
        (0, $5km34.SUMMARY_ITEM_PULLREQUEST),
        (0, $5km34.SUMMARY_ITEM_REVIEW),
        (0, $5km34.SUMMARY_ITEM_FEATURE_FLAGS),
        (0, $5km34.SUMMARY_ITEM_REMOTE_LINKS)
    ].includes(itemType);
    if (!needsTransformation) return itemType;
    if (itemType === (0, $5km34.SUMMARY_ITEM_DEPLOYMENT) || itemType === 'deploymentEnvironments') return 'deployment-environment';
    if (itemType === (0, $5km34.SUMMARY_ITEM_COMMIT)) return 'repository';
    throw new Error(`Unknown item type ${itemType}`);
};

});

parcelRegister("8Wv52", function(module, exports) {

$parcel$export(module.exports, "default", () => $43112bbb2f51102d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");

var $7rNJI = parcelRequire("7rNJI");

var $koVbs = parcelRequire("koVbs");

var $903eE = parcelRequire("903eE");
const $43112bbb2f51102d$var$getHref = (issueKey)=>`/browse/${issueKey}?devStatusDetailDialog=deployment-environment`;
const $43112bbb2f51102d$export$b141efd0b0fb9174 = (previousProps, nextProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(nextProps.deployment?.environments, previousProps.deployment?.environments) && nextProps.deployment?.count === previousProps.deployment?.count;
const $43112bbb2f51102d$export$4c71438264bb2277 = /*#__PURE__*/ (0, $5uXOq.memo)(({ deployment: deployment, issueKey: issueKey, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { count: count = 0, environments: environments = [] } = deployment ?? {};
    const title = (0, $5uXOq.useMemo)(()=>{
        const displayedEnvironments = environments.join(', ');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            size: "UNSAFE_small",
            color: "color.text.subtle"
        }, formatMessage((0, $903eE.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: displayedEnvironments
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            maxLines: 1
        }, displayedEnvironments)));
    }, [
        environments,
        formatMessage
    ]);
    if (deployment && count > 0 && environments.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        title: title,
        href: $43112bbb2f51102d$var$getHref(issueKey),
        onClick: onClick,
        "data-testid": "development-summary-deployment-development-field.ui.summary-item"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
}, $43112bbb2f51102d$export$b141efd0b0fb9174);
var $43112bbb2f51102d$export$2e2bcd8739ae039 = $43112bbb2f51102d$export$4c71438264bb2277;

});
parcelRegister("903eE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe2c2bd539b76ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8fe2c2bd539b76ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "development-summary-deployment-development-field.title",
        "defaultMessage": "Deployed to"
    }
});

});


parcelRegister("2HUDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f107b33efe4ff530$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aYAc3 = parcelRequire("aYAc3");

var $7rNJI = parcelRequire("7rNJI");

var $8Q4sF = parcelRequire("8Q4sF");

var $aWse0 = parcelRequire("aWse0");

var $8LZtf = parcelRequire("8LZtf");
const $f107b33efe4ff530$var$statusCategoryToAppearenceMap = {
    REVIEW: 'inprogress',
    SUMMARIZE: 'inprogress',
    DRAFT: 'new',
    CLOSED: 'success',
    APPROVAL: 'inprogress',
    DEAD: 'removed',
    REJECTED: 'removed',
    UNKNOWN: 'default'
};
const $f107b33efe4ff530$export$b141efd0b0fb9174 = (previousProps, nextProps)=>nextProps.review?.count === previousProps.review?.count && nextProps.review?.lastUpdated === previousProps.review?.lastUpdated && nextProps.review?.stateCount === previousProps.review?.stateCount && nextProps.review?.state === previousProps.review?.state;
const $f107b33efe4ff530$export$4e3e332352c3d092 = /*#__PURE__*/ (0, $5uXOq.memo)(({ review: review, onClick: onClick })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { count: count = 0, stateCount: stateCount = 0, state: state } = review ?? {};
    const title = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
            componentsMapping: {
                bold: $f107b33efe4ff530$var$BoldFont
            },
            message: formatMessage((0, $8LZtf.default).title, {
                count: formatNumber(stateCount),
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }), [
        formatMessage,
        formatNumber,
        stateCount
    ]);
    const secondaryData = (0, $5uXOq.useMemo)(()=>{
        const safeState = state || 'UNKNOWN'; // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'ThemeAppearance | undefined'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
            appearance: $f107b33efe4ff530$var$statusCategoryToAppearenceMap[safeState]
        }, safeState);
    }, [
        state
    ]);
    if (review && count > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        title: title,
        href: null,
        onClick: onClick,
        itemType: "review",
        secondaryData: secondaryData,
        "data-testid": "development-summary-review.ui.summary-item"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
}, $f107b33efe4ff530$export$b141efd0b0fb9174);
var $f107b33efe4ff530$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f107b33efe4ff530$export$4e3e332352c3d092;
const $f107b33efe4ff530$var$BoldFont = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8LZtf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f5240d8cc36feeb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1f5240d8cc36feeb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "development-summary-review.title",
        "defaultMessage": "{boldStart}{count}{boldEnd} {count, plural, one {review} other {reviews}}"
    }
});

});


parcelRegister("eJGA0", function(module, exports) {

$parcel$export(module.exports, "default", () => $27c2ef8ba3abc75f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $27c2ef8ba3abc75f$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dv2oJ")), {
    moduleId: "./src/packages/autodev/jira-technical-planner/src/ui/index.tsx"
});
const $27c2ef8ba3abc75f$export$16fa2f45be04daa8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-technical-planner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($27c2ef8ba3abc75f$var$LazyComponent, null));
var $27c2ef8ba3abc75f$export$2e2bcd8739ae039 = $27c2ef8ba3abc75f$export$16fa2f45be04daa8;

});
parcelRegister("dv2oJ", function(module, exports) {

let $9d4007c55a697c95$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d4007c55a697c95$var$load("9jLjx").then(()=>parcelRequire('64AyK'));

});


parcelRegister("a4KlA", function(module, exports) {

$parcel$export(module.exports, "Status", () => $23b808c4c77a0f85$export$96e9906d6d93a972);
$parcel$export(module.exports, "useIsAutoDevEnabled", () => $23b808c4c77a0f85$export$4c4ab362d8a15770);

var $fFAIy = parcelRequire("fFAIy");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");

var $4R6GH = parcelRequire("4R6GH");
const $23b808c4c77a0f85$export$96e9906d6d93a972 = {
    NOT_DETERMINED: 0,
    PROCESSING: 1,
    DETERMINED: 2
};
const $23b808c4c77a0f85$export$4c4ab362d8a15770 = (atlassianAccountId, cloudId, relayEnv, isRovoRequired = true)=>{
    const [isAutoDevEnabled, setIsAutoDevEnabled] = (0, $5uXOq.useState)(false);
    const [isDetermined, setIsDetermined] = (0, $5uXOq.useState)($23b808c4c77a0f85$export$96e9906d6d93a972.NOT_DETERMINED);
    (0, $5uXOq.useEffect)(()=>{
        const determineDevAIEnabled = async ()=>{
            if (atlassianAccountId === null || atlassianAccountId.trim() === '') {
                setIsAutoDevEnabled(false);
                setIsDetermined($23b808c4c77a0f85$export$96e9906d6d93a972.DETERMINED);
            } else $23b808c4c77a0f85$export$dee0c91847f2a763({
                atlassianAccountId: atlassianAccountId,
                cloudId: cloudId,
                relayEnv: relayEnv
            }).then((response)=>{
                const hasProductAccess = response?.hasProductAccess ?? false;
                const rovoEnabled = response?.isRovoEnabled ?? false;
                setIsDetermined($23b808c4c77a0f85$export$96e9906d6d93a972.DETERMINED);
                setIsAutoDevEnabled(hasProductAccess && (isRovoRequired ? rovoEnabled : true));
            }).catch(()=>{
                setIsAutoDevEnabled(false);
                setIsDetermined($23b808c4c77a0f85$export$96e9906d6d93a972.DETERMINED);
            });
        };
        if (isDetermined === $23b808c4c77a0f85$export$96e9906d6d93a972.NOT_DETERMINED && atlassianAccountId !== '') {
            setIsDetermined($23b808c4c77a0f85$export$96e9906d6d93a972.PROCESSING);
            if ((0, $4R6GH.fg)('coding-agents-limited-beta')) determineDevAIEnabled();
            else {
                setIsDetermined($23b808c4c77a0f85$export$96e9906d6d93a972.DETERMINED);
                setIsAutoDevEnabled(false);
            }
        }
    }, [
        atlassianAccountId,
        isDetermined,
        cloudId,
        relayEnv,
        isRovoRequired
    ]);
    return [
        isAutoDevEnabled,
        isDetermined
    ];
};
const $23b808c4c77a0f85$export$dee0c91847f2a763 = async ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, relayEnv: relayEnv })=>{
    const result = await (0, $eiowN.fetchQuery)(relayEnv, (0, $fFAIy.default), {
        atlassianAccountId: atlassianAccountId,
        cloudId: cloudId,
        isAutodevBetaEnabled: (0, $4R6GH.fg)('coding-agents-limited-beta')
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((response)=>{
        return {
            hasProductAccess: response?.devai_rovoDevAgentsUser?.hasProductAccess ?? false,
            isAdmin: response?.devai_rovoDevAgentsUser?.isAdmin ?? false,
            isRovoEnabled: response?.jira?.isRovoEnabled ?? false
        };
    });
    return result;
};

});
parcelRegister("fFAIy", function(module, exports) {

$parcel$export(module.exports, "default", () => $61455f63387e5670$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<617855ec21de464b6fa2c4294ef59e04>>
 * @relayHash 835cf47f6749ab86fa6fd796e566b197
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e046b4c1327a28b7d4c765a0380da862200507908d5b6a7b0d1bf782e0a87057
const $61455f63387e5670$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "atlassianAccountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAutodevBetaEnabled"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "atlassianAccountId",
                "variableName": "atlassianAccountId"
            },
            v1 /*: any*/ 
        ],
        "concreteType": "DevAiUser",
        "kind": "LinkedField",
        "name": "devai_rovoDevAgentsUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasProductAccess"
            },
            {
                "kind": "ScalarField",
                "name": "isAdmin"
            }
        ]
    }, v3 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "condition": "isAutodevBetaEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            v1 /*: any*/ 
                        ],
                        "kind": "ScalarField",
                        "name": "isRovoEnabled"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsAutodevEnabledQuery",
            "selections": [
                {
                    "condition": "isAutodevBetaEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v2 /*: any*/ ,
                            "action": "THROW",
                            "path": "devai_rovoDevAgentsUser"
                        }
                    ]
                },
                v3 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsAutodevEnabledQuery",
            "selections": [
                {
                    "condition": "isAutodevBetaEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                v3 /*: any*/ 
            ]
        },
        "params": {
            "id": "e046b4c1327a28b7d4c765a0380da862200507908d5b6a7b0d1bf782e0a87057",
            "metadata": {},
            "name": "useIsAutodevEnabledQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$61455f63387e5670$var$node.hash = "35a2fac16cf075dfe6102fcdda3a7299";
var $61455f63387e5670$export$2e2bcd8739ae039 = $61455f63387e5670$var$node;

});


parcelRegister("1gtls", function(module, exports) {

$parcel$export(module.exports, "useHasRovoDevAgentsEntitlement", () => $1dd772fb882e0c69$export$f88ef27717fc01fc);

var $5uXOq = parcelRequire("5uXOq");

var $8Hlvs = parcelRequire("8Hlvs");
const $1dd772fb882e0c69$export$f88ef27717fc01fc = (atlassianAccountId, cloudId, relayEnv, shouldCheckEntitlement)=>{
    const [hasRovoDevAgentsEntitlement, setHasRovoDevAgentsEntitlement] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!atlassianAccountId || !shouldCheckEntitlement) return;
        (0, $8Hlvs.userHasRovoDevAgentsAccess)({
            atlassianAccountId: atlassianAccountId,
            cloudId: cloudId,
            relayEnv: relayEnv
        }).then((hasAccess)=>{
            setHasRovoDevAgentsEntitlement(hasAccess);
        });
    }, [
        atlassianAccountId,
        cloudId,
        relayEnv,
        shouldCheckEntitlement
    ]);
    return {
        hasRovoDevAgentsEntitlement: hasRovoDevAgentsEntitlement
    };
};

});
parcelRegister("8Hlvs", function(module, exports) {

$parcel$export(module.exports, "userHasRovoDevAgentsAccess", () => $b03fb3d42937618b$export$555786b5fe156a9d);

var $9jL5V = parcelRequire("9jL5V");

var $eiowN = parcelRequire("eiowN");
const $b03fb3d42937618b$export$555786b5fe156a9d = async ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, relayEnv: relayEnv })=>{
    const response = await (0, $eiowN.fetchQuery)(relayEnv, (0, $9jL5V.default), {
        atlassianAccountId: atlassianAccountId,
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    return response?.devai_rovoDevAgentsUser?.hasProductAccess ?? false;
};

});
parcelRegister("9jL5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8c16c4492f45182$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<723b3ac8a7b187c136c463dff552fed1>>
 * @relayHash 826e32a782d6c914902f0dd48681143e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6cc503e1004536c657beb712f31ebd0b4deb94e2a5cca8f7225c3cc502ece7d6
const $b8c16c4492f45182$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "atlassianAccountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "atlassianAccountId",
                "variableName": "atlassianAccountId"
            },
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ],
        "concreteType": "DevAiUser",
        "kind": "LinkedField",
        "name": "devai_rovoDevAgentsUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasProductAccess"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "userHasRovoDevAgentsAccessQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "devai_rovoDevAgentsUser"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "userHasRovoDevAgentsAccessQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "6cc503e1004536c657beb712f31ebd0b4deb94e2a5cca8f7225c3cc502ece7d6",
            "metadata": {},
            "name": "userHasRovoDevAgentsAccessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b8c16c4492f45182$var$node.hash = "2211f981812c18f10eb7045dcff65aae";
var $b8c16c4492f45182$export$2e2bcd8739ae039 = $b8c16c4492f45182$var$node;

});



parcelRegister("gya2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e23b816519ee0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9fIhE = parcelRequire("9fIhE");

var $aWse0 = parcelRequire("aWse0");

var $7rNJI = parcelRequire("7rNJI");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $kvEnS = parcelRequire("kvEnS");
const $28e23b816519ee0b$var$verticalAlignStyle = null;
const $28e23b816519ee0b$var$ScreenIcon = /*#__PURE__*/ $5uXOq.createElement("span", {
    "aria-hidden": true,
    className: (0, $bwpsq.default)([
        "_s7n4nkob"
    ])
}, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9fIhE))), {
    color: "var(--ds-link, #0C66E4)",
    label: ""
}));
const $28e23b816519ee0b$var$buildVsCodeUrl = (issueKey, host)=>{
    const issueKeyQs = encodeURIComponent(issueKey);
    const hostQs = encodeURIComponent(host);
    return `vscode://atlassian.atlascode/openJiraIssue?key=${issueKeyQs}&site=${hostQs}&source=jira`;
};
const $28e23b816519ee0b$var$OpenInVSCodeItem = ({ issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const title = formatMessage((0, $kvEnS.default).openWithMessage);
    const clickUrl = (0, $5uXOq.useMemo)(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    ()=>$28e23b816519ee0b$var$buildVsCodeUrl(issueKey, document.location.hostname), [
        issueKey
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "openInVSCodeButton",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ $5uXOq.createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ $5uXOq.createElement((0, $7rNJI.SummaryItem), {
        title: title,
        issueKey: issueKey,
        icon: $28e23b816519ee0b$var$ScreenIcon,
        linkFormatting: true,
        href: clickUrl,
        onClick: (_, analyticEvent)=>{
            return (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'openInVSCodeButton');
        },
        "data-testid": "development-summary-development-field.ui.summary.open-in-vscode.open-in-vscode-summary-item"
    }));
};
var $28e23b816519ee0b$export$2e2bcd8739ae039 = $28e23b816519ee0b$var$OpenInVSCodeItem;

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("kvEnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $843d8852529ffcbf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $843d8852529ffcbf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openWithMessage: {
        "id": "development-summary-development-field.summary.open-in-vscode.open-with-message",
        "defaultMessage": "Open with VS Code"
    }
});

});


parcelRegister("khxu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9da20fe7fc9cd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6yUsV = parcelRequire("6yUsV");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hjSnd = parcelRequire("hjSnd");

var $bC2fB = parcelRequire("bC2fB");

var $faqOn = parcelRequire("faqOn");

var $57tUJ = parcelRequire("57tUJ");

var $cvhPh = parcelRequire("cvhPh");
const $f7f9da20fe7fc9cd$export$b8e9cd941e8016ac = (props)=>{
    const { errors: errors, configErrors: configErrors } = props;
    if (!errors.length && !configErrors.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSnd.DevPanelIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yUsV.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f7f9da20fe7fc9cd$var$containerStyles
    }, errors && errors.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cvhPh.default), {
        errors: errors
    }) : null, configErrors && configErrors.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57tUJ.default), {
        configErrors: configErrors
    }) : null)));
};
var $f7f9da20fe7fc9cd$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        errors: (0, $faqOn.errorsSelector)(state) ?? [],
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        configErrors: (0, $faqOn.configErrorsSelector)(state) ?? []
    }), {})($f7f9da20fe7fc9cd$export$b8e9cd941e8016ac);
const $f7f9da20fe7fc9cd$var$containerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.negative.300'
});

});
parcelRegister("57tUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ce4c06905cc755c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $aWse0 = parcelRequire("aWse0");

var $hTFsN = parcelRequire("hTFsN");
const $5ce4c06905cc755c$var$getInstanceLink = (error)=>(0, $4R6GH.fg)('replace-anchor-with-link__nova') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: error.instanceUrl
    }, error.instanceName) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: error.instanceUrl
    }, error.instanceName);
const $5ce4c06905cc755c$export$74198bf8b0e4be91 = (props)=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const configErrorInstancesOneMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $hTFsN.default).oneConfigError,
            values: {
                instanceOne: $5ce4c06905cc755c$var$getInstanceLink(errors[0])
            }
        });
    const configErrorInstancesTwoMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $hTFsN.default).twoConfigError,
            values: {
                instanceOne: $5ce4c06905cc755c$var$getInstanceLink(errors[0]),
                instanceTwo: $5ce4c06905cc755c$var$getInstanceLink(errors[1])
            }
        });
    const configErrorInstancesThreeMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $hTFsN.default).threeConfigError,
            values: {
                instanceOne: $5ce4c06905cc755c$var$getInstanceLink(errors[0]),
                instanceTwo: $5ce4c06905cc755c$var$getInstanceLink(errors[1]),
                instanceThree: $5ce4c06905cc755c$var$getInstanceLink(errors[2])
            }
        });
    const configErrorInstancesMoreMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $hTFsN.default).moreConfigError,
            values: {
                instanceOne: $5ce4c06905cc755c$var$getInstanceLink(errors[0]),
                instanceTwo: $5ce4c06905cc755c$var$getInstanceLink(errors[1]),
                instanceThree: $5ce4c06905cc755c$var$getInstanceLink(errors[2]),
                count: errors.length - 3
            }
        });
    const configErrorLearnMore = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $hTFsN.default).configErrorAndLearnMoreIssueTermRefresh : (0, $hTFsN.default).configErrorAndLearnMore,
            values: {
                h: (chunks)=>(0, $4R6GH.fg)('replace-anchor-with-link__nova') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                        href: "https://confluence.atlassian.com/display/JIRAKB/JIRA+Application+Development+panel+displays+error+-+Couldn%27t+read+data"
                    }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                        href: "https://confluence.atlassian.com/display/JIRAKB/JIRA+Application+Development+panel+displays+error+-+Couldn%27t+read+data"
                    }, chunks),
                a: (chunks)=>(0, $4R6GH.fg)('replace-anchor-with-link__nova') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                        href: "/plugins/servlet/applinks/listApplicationLinks"
                    }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                        href: "/plugins/servlet/applinks/listApplicationLinks"
                    }, chunks)
            }
        });
    const renderConfigErrorDescription = (configErrors)=>{
        switch(configErrors.length){
            case 1:
                return configErrorInstancesOneMessage(configErrors);
            case 2:
                return configErrorInstancesTwoMessage(configErrors);
            case 3:
                return configErrorInstancesThreeMessage(configErrors);
            default:
                return configErrorInstancesMoreMessage(configErrors);
        }
    };
    const { configErrors: configErrors } = props;
    return configErrors && configErrors.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ce4c06905cc755c$var$Title, null, formatMessage((0, $hTFsN.default).configTitle)), renderConfigErrorDescription(configErrors), " ", configErrorLearnMore()) : null;
};
var $5ce4c06905cc755c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5ce4c06905cc755c$export$74198bf8b0e4be91;
const $5ce4c06905cc755c$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1ejb _2hwxidpf _otyru2gc _18u0idpf _k48p1wq8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5ce4c06905cc755c$export$7ed12d2a5241e393 = {
    Title: $5ce4c06905cc755c$var$Title
};

});
parcelRegister("hTFsN", function(module, exports) {

$parcel$export(module.exports, "default", () => $90917d09dbcd6fac$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $90917d09dbcd6fac$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    oneConfigError: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.one-config-error",
        "defaultMessage": "Couldn't read data from {instanceOne}."
    },
    twoConfigError: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.two-config-error",
        "defaultMessage": "Couldn't read data from {instanceOne} and {instanceTwo}."
    },
    threeConfigError: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.three-config-error",
        "defaultMessage": "Couldn't read data from {instanceOne}, {instanceTwo} and {instanceThree}."
    },
    moreConfigError: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.more-config-error",
        "defaultMessage": "Couldn't read data from {instanceOne}, {instanceTwo}, {instanceThree} and {count} other {count, plural, one {application} other {applications}}."
    },
    configErrorAndLearnMore: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.config-error-and-learn-more",
        "defaultMessage": "Learn <h>about this issue</h> or go to <a>application links</a> to fix it."
    },
    configTitle: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.config-title",
        "defaultMessage": "Configuration problem"
    },
    configErrorAndLearnMoreIssueTermRefresh: {
        "id": "development-summary-development-field.summary.error-tag.config-errors.config-error-and-learn-more-issue-term-refresh",
        "defaultMessage": "Find out <h>about this work item</h> or go to <a>application links</a> to fix it."
    }
});

});


parcelRegister("cvhPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ee214f496de35a8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $aWse0 = parcelRequire("aWse0");

var $k9tQG = parcelRequire("k9tQG");
const $3ee214f496de35a8$var$getInstanceLink = (error)=>(0, $4R6GH.fg)('replace-anchor-with-link__nova') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: error.instanceUrl
    }, error.instanceName) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: error.instanceUrl
    }, error.instanceName);
const $3ee214f496de35a8$export$9b99eb2c33ab1595 = (props)=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const errorInstancesOneMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $k9tQG.default).oneInstanceError,
            values: {
                instanceOne: $3ee214f496de35a8$var$getInstanceLink(errors[0])
            }
        });
    const errorInstancesTwoMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $k9tQG.default).twoInstanceError,
            values: {
                instanceOne: $3ee214f496de35a8$var$getInstanceLink(errors[0]),
                instanceTwo: $3ee214f496de35a8$var$getInstanceLink(errors[1])
            }
        });
    const errorInstancesThreeMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $k9tQG.default).threeInstanceError,
            values: {
                instanceOne: $3ee214f496de35a8$var$getInstanceLink(errors[0]),
                instanceTwo: $3ee214f496de35a8$var$getInstanceLink(errors[1]),
                instanceThree: $3ee214f496de35a8$var$getInstanceLink(errors[2])
            }
        });
    const errorInstancesMoreMessage = (errors)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $k9tQG.default).moreInstanceError,
            values: {
                instanceOne: $3ee214f496de35a8$var$getInstanceLink(errors[0]),
                instanceTwo: $3ee214f496de35a8$var$getInstanceLink(errors[1]),
                instanceThree: $3ee214f496de35a8$var$getInstanceLink(errors[2]),
                count: errors.length - 3
            }
        });
    const renderErrorDescription = (errors)=>{
        switch(errors.length){
            case 1:
                return errorInstancesOneMessage(errors);
            case 2:
                return errorInstancesTwoMessage(errors);
            case 3:
                return errorInstancesThreeMessage(errors);
            default:
                return errorInstancesMoreMessage(errors);
        }
    };
    const { errors: errors } = props;
    return errors && errors.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ee214f496de35a8$var$Title, null, formatMessage((0, $k9tQG.default).connectionTitle)), renderErrorDescription(errors)) : null;
};
var $3ee214f496de35a8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3ee214f496de35a8$export$9b99eb2c33ab1595;
const $3ee214f496de35a8$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1ejb _2hwxidpf _otyru2gc _18u0idpf _k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k9tQG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c93bd61866bf46c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c93bd61866bf46c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    oneInstanceError: {
        "id": "development-summary-development-field.summary.error-tag.instance-errors.one-instance-error",
        "defaultMessage": "Jira is having difficulty contacting {instanceOne}. If this condition persists, please contact your Jira administrators."
    },
    threeInstanceError: {
        "id": "development-summary-development-field.summary.error-tag.instance-errors.three-instance-error",
        "defaultMessage": "Jira is having difficulty contacting {instanceOne}, {instanceTwo} and {instanceThree}. If this condition persists, please contact your Jira administrators."
    },
    twoInstanceError: {
        "id": "development-summary-development-field.summary.error-tag.instance-errors.two-instance-error",
        "defaultMessage": "Jira is having difficulty contacting {instanceOne} and {instanceTwo}. If this condition persists, please contact your Jira administrators."
    },
    moreInstanceError: {
        "id": "development-summary-development-field.summary.error-tag.instance-errors.more-instance-error",
        "defaultMessage": "Jira is having difficulty contacting {instanceOne}, {instanceTwo}, {instanceThree} and {count} other {count, plural, one {application} other {applications}}. If this condition persists, please contact your Jira administrators."
    },
    connectionTitle: {
        "id": "development-summary-development-field.summary.error-tag.instance-errors.connection-title",
        "defaultMessage": "Connection problem"
    }
});

});



parcelRegister("3QzKK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd54bed844a554f$export$2e2bcd8739ae039);

var $e2RPk = parcelRequire("e2RPk");

var $5uXOq = parcelRequire("5uXOq");

var $h4EJ8 = parcelRequire("h4EJ8");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $4R6GH = parcelRequire("4R6GH");

var $467lJ = parcelRequire("467lJ");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");

var $bC2fB = parcelRequire("bC2fB");

var $01j5n = parcelRequire("01j5n");

var $3vXOY = parcelRequire("3vXOY");

var $idwnU = parcelRequire("idwnU");

var $027Zr = parcelRequire("027Zr");

var $faqOn = parcelRequire("faqOn");

var $2Zuvx = parcelRequire("2Zuvx");
const $1dd54bed844a554f$export$6125de7b8ba1e4ee = ({ issueAri: issueAri, setShowSummarySectionMessageState: setShowSummarySectionMessageState, hasCreateBranchTargets: hasCreateBranchTargets })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const fireCompleteAnalytics = (analyticsEvent, errors)=>{
        const statusCode = errors ? (0, $3vXOY.getStatusCodeFromGraphQLErrors)(errors) : 200;
        const isFailure = (0, $01j5n.isFailureStatusCode)(statusCode);
        // response contains graphql errors
        if (errors && errors.length > 0 && isFailure) {
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'optOutOfDevOpsIssuePanelBanner failed', {
                statusCode: statusCode,
                errorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($h4EJ8)))(errors[0].message, {
                    length: 140
                })
            });
            showFlag((0, $467lJ.default).genericError());
            return;
        }
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'optOutOfDevOpsIssuePanelBanner success', {
            statusCode: statusCode
        });
    };
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $e2RPk.default));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onDismiss = (_, analyticsEvent)=>{
        const bannerType = 'ISSUE_KEY_ONBOARDING';
        // optimistic update.
        setShowSummarySectionMessageState(false);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dismissDevOpsIssuePanelBanner');
        commitMutation({
            variables: {
                issueId: issueAri,
                bannerType: bannerType
            },
            onCompleted: (data, errors)=>{
                setShowSummarySectionMessageState(// @ts-expect-error(Suppressed for relay bump) - 'data.jira' is possibly 'null' or 'undefined'. | 'data.jira.devOps' is possibly 'null' or 'undefined'. | 'data.jira.devOps.dismissDevOpsIssuePanelBanner' is possibly 'null' or 'undefined'.
                data ? !data.jira.devOps.dismissDevOpsIssuePanelBanner.success : true);
                fireCompleteAnalytics(analyticsEvent, errors);
            },
            onError: ()=>{
                setShowSummarySectionMessageState(true);
                showFlag((0, $467lJ.default).genericError());
                (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'dismissDevOpsIssuePanelBanner failed', {
                    statusCode: 'unknown',
                    errorMessage: 'networkError'
                });
            }
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onLearnMoreLinkClick = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'devPannelOnboardingBannerLink');
    };
    const sectionTitle = formatMessage((0, $2Zuvx.default).sectionTitle);
    const learnMoreUrl = 'https://support.atlassian.com/jira-software-cloud/docs/reference-issues-in-your-development-work/';
    const sectionFirstAction = formatMessage((0, $2Zuvx.default).sectionFirstAction);
    const sectionSecondAction = formatMessage((0, $2Zuvx.default).sectionSecondAction);
    const sectionMessageCanCreate = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $2Zuvx.default).sectionMessageCanCreateIssueTermRefresh : (0, $2Zuvx.default).sectionMessageCanCreate);
    const sectionMessageCantCreate = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $2Zuvx.default).sectionMessageCantCreateIssueTermRefresh : (0, $2Zuvx.default).sectionMessageCantCreate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        eventName: "viewed devPanelOnboardingBanner"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        testId: "development-summary-development-field.ui.summary.onboarding-message.onboarding-section-message",
        title: sectionTitle,
        appearance: "discovery",
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                key: "dismiss",
                onClick: onDismiss
            }, sectionSecondAction)
        ]
    }, hasCreateBranchTargets ? sectionMessageCanCreate : sectionMessageCantCreate, "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        key: "learnMore",
        appearance: "link",
        spacing: "none",
        href: learnMoreUrl,
        target: "_blank",
        onClick: onLearnMoreLinkClick
    }, sectionFirstAction)));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1dd54bed844a554f$var$mapStateToProps = (state)=>({
        hasCreateBranchTargets: (0, $faqOn.hasCreateBranchTargetsSelector)(state),
        issueAri: (0, $idwnU.issueAriSelector)(state)
    });
const $1dd54bed844a554f$var$mapDispatchToProps = {
    setShowSummarySectionMessageState: (0, $027Zr.onClickDismissLink)
};
var $1dd54bed844a554f$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($1dd54bed844a554f$var$mapStateToProps, $1dd54bed844a554f$var$mapDispatchToProps)($1dd54bed844a554f$export$6125de7b8ba1e4ee);

});
parcelRegister("e2RPk", function(module, exports) {

$parcel$export(module.exports, "default", () => $158059845e08ac06$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a38e7252ca772f10ce6144e3c1cbf6cf>>
 * @relayHash 96bb2eca78918614ce294099276a0f50
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f9c9105d2e411f6df4cdf09defb95d3a63d1676d90c0f515e5eb728c283e1916
const $158059845e08ac06$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "bannerType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueId"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "bannerType",
                    "variableName": "bannerType"
                },
                {
                    "kind": "Variable",
                    "name": "issueId",
                    "variableName": "issueId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "GenericMutationErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsMutation",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraDismissDevOpsIssuePanelBannerPayload",
                                    "kind": "LinkedField",
                                    "name": "dismissDevOpsIssuePanelBanner",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsMutation",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraDismissDevOpsIssuePanelBannerPayload",
                                    "kind": "LinkedField",
                                    "name": "dismissDevOpsIssuePanelBanner",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ],
                                                            "type": "BulkMutationErrorExtension"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f9c9105d2e411f6df4cdf09defb95d3a63d1676d90c0f515e5eb728c283e1916",
            "metadata": {},
            "name": "onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$158059845e08ac06$var$node.hash = "b1f05d6abb35abced8feaf2ccc8a39be";
var $158059845e08ac06$export$2e2bcd8739ae039 = $158059845e08ac06$var$node;

});

parcelRegister("2Zuvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $26f7bab72b72fe94$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $26f7bab72b72fe94$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "development-summary-development-field.summary.onboarding-message.label",
        "defaultMessage": "Development"
    },
    sectionFirstAction: {
        "id": "development-summary-development-field.summary.onboarding-message.section-first-action",
        "defaultMessage": "Learn more"
    },
    sectionSecondAction: {
        "id": "development-summary-development-field.summary.onboarding-message.section-second-action",
        "defaultMessage": "Dismiss"
    },
    sectionMessageCanCreate: {
        "id": "development-summary-development-field.summary.onboarding-message.section-message-can-create",
        "defaultMessage": "Link this issue to your code by including issue keys when creating a branch, commit, or pull request below."
    },
    sectionMessageCantCreate: {
        "id": "development-summary-development-field.summary.onboarding-message.section-message-cant-create",
        "defaultMessage": "Link this issue to your code by including issue keys when creating a branch, commit, or pull request."
    },
    sectionTitle: {
        "id": "development-summary-development-field.summary.onboarding-message.section-title",
        "defaultMessage": "Quick start development"
    },
    sectionMessageCanCreateIssueTermRefresh: {
        "id": "development-summary-development-field.summary.onboarding-message.section-message-can-create-issue-term-refresh",
        "defaultMessage": "Link this work item to your code by including keys when creating a branch, commit, or pull request below."
    },
    sectionMessageCantCreateIssueTermRefresh: {
        "id": "development-summary-development-field.summary.onboarding-message.section-message-cant-create-issue-term-refresh",
        "defaultMessage": "Link this work item to your code by including keys when creating a branch, commit, or pull request."
    }
});

});





parcelRegister("ymYUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b142aa2a84400f28$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $bC2fB = parcelRequire("bC2fB");

var $dwUly = parcelRequire("dwUly");

var $hCOUn = parcelRequire("hCOUn");

var $c3QfV = parcelRequire("c3QfV");
const $b142aa2a84400f28$var$ReleasesFieldApp = (props)=>{
    const isInitialMount = (0, $5uXOq.useRef)(true);
    const { hasSoftwareAccess: hasSoftwareAccess, ...stateProps } = props;
    const [store] = (0, $5uXOq.useState)(()=>{
        const s = (0, $hCOUn.default)();
        s.dispatch((0, $dwUly.setContext)(stateProps));
        return s;
    });
    (0, $5uXOq.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else store.dispatch((0, $dwUly.setContext)(stateProps));
    }, [
        store,
        stateProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bC2fB.Provider), {
        store: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c3QfV.default), {
        hasSoftwareAccess: hasSoftwareAccess
    })));
};
var $b142aa2a84400f28$export$2e2bcd8739ae039 = $b142aa2a84400f28$var$ReleasesFieldApp;

});
parcelRegister("dwUly", function(module, exports) {

$parcel$export(module.exports, "SET_CONTEXT", () => $c87b26281c033a5b$export$4bc4e62e7d72b94b);
$parcel$export(module.exports, "setContext", () => $c87b26281c033a5b$export$2f04de43fe27971a);
const $c87b26281c033a5b$export$4bc4e62e7d72b94b = 'SET_RELEASES_CONTEXT';
const $c87b26281c033a5b$export$2f04de43fe27971a = (context)=>({
        type: $c87b26281c033a5b$export$4bc4e62e7d72b94b,
        payload: context
    });

});

parcelRegister("hCOUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $499636654bab1fd3$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $e1AU2 = parcelRequire("e1AU2");

var $F2Mxm = parcelRequire("F2Mxm");

var $aany1 = parcelRequire("aany1");

var $fNhre = parcelRequire("fNhre");

var $ecbp7 = parcelRequire("ecbp7");
const $499636654bab1fd3$export$a8a69c316169e623 = (0, $3f2cs.combineReducers)({
    releasesContext: (0, $aany1.contextReducer),
    releasesData: (0, $ecbp7.releasesDataReducer)
});
const $499636654bab1fd3$export$49b6a7dfc84f00c4 = (0, $e1AU2.combineEpics)((0, $fNhre.default));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$499636654bab1fd3$export$2e2bcd8739ae039 = ()=>(0, $F2Mxm.default)({
        appName: 'releases-glance',
        rootReducer: // @ts-expect-error - Type 'Reducer<CombinedState<{ releasesContext: Context; releasesData: ReleasesData | null; }>, { type: "RELEASES_DATA_FETCH_RESPONSE"; payload: Error | ReleasesData; error: boolean; } | SetContextAction>' is not assignable to type 'Reducer<State, AnyAction>'.
        $499636654bab1fd3$export$a8a69c316169e623,
        rootEpic: $499636654bab1fd3$export$49b6a7dfc84f00c4
    });

});
parcelRegister("aany1", function(module, exports) {

$parcel$export(module.exports, "contextReducer", () => $f0f149eda6e674bb$export$2803ff8111172487);

var $7uUwQ = parcelRequire("7uUwQ");

var $g5X3G = parcelRequire("g5X3G");

var $dwUly = parcelRequire("dwUly");
const $f0f149eda6e674bb$var$initialContext = (0, $7uUwQ.freeze)({
    issueContext: {
        issueId: 0,
        issueKey: (0, $g5X3G.toIssueKey)(''),
        issueStatusCategory: '',
        projectId: 0,
        projectAri: '',
        projectType: '',
        isSimplifiedProject: false
    },
    analyticsSource: '',
    summary: '',
    user: (0, $g5X3G.toAccountId)('abc123'),
    isJiraAdmin: false,
    isSiteAdmin: false,
    cloudAri: ''
});
const $f0f149eda6e674bb$export$2803ff8111172487 = (state = $f0f149eda6e674bb$var$initialContext, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $dwUly.SET_CONTEXT:
            return (0, $7uUwQ.freeze)(payload);
        default:
            return state;
    }
};

});

parcelRegister("fNhre", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b62ec5060a0a244$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("aSIuP");

var $it1wb = parcelRequire("it1wb");

var $gn1v9 = parcelRequire("gn1v9");

var $kVLXA = parcelRequire("kVLXA");

var $dRAiH = parcelRequire("dRAiH");

var $dXq4S = parcelRequire("dXq4S");

var $gd05V = parcelRequire("gd05V");

var $lsaAq = parcelRequire("lsaAq");

var $ddQHu = parcelRequire("ddQHu");

var $fMtTa = parcelRequire("fMtTa");
const $0b62ec5060a0a244$export$2cca46dea398dd67 = ()=>(0, $it1wb.default)((0, $gn1v9.default)(new Date(), {
        weeks: 6
    })).toISOString();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0b62ec5060a0a244$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $fMtTa.RELEASES_DATA_FETCH_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const context = (0, $ddQHu.contextSelector)(state);
        const { payload: payload } = action;
        const { projectAri: projectAri } = (0, $ddQHu.issueContextSelector)(state);
        const updatedFrom = $0b62ec5060a0a244$export$2cca46dea398dd67();
        return (0, $kVLXA.Observable).zip((0, $lsaAq.default)({
            issueId: context.issueContext.issueId,
            analyticsEvent: payload.meta.analyticsEvent
        }), (0, $gd05V.getDeploymentDataDetected)(projectAri, updatedFrom), (0, $gd05V.getShowAppConfigPrompt)(context.cloudAri, context.isSiteAdmin, context.isJiraAdmin), (0, $dRAiH.fetchDevSummaryData)((0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: (0, $dXq4S.getAriConfig)(projectAri).cloudId ?? '',
            resourceType: 'issue',
            resourceId: String(context.issueContext.issueId)
        })), (releasesData, hasDeploymentsInProject, shouldShowAppConfigContextPrompt, { panelState: panelState, summary: summary })=>(0, $fMtTa.releasesDataFetchResponse)({
                ...releasesData,
                shouldShowEmptyState: panelState === 'DEV_SUMMARY' && (summary.pullrequest?.count ?? 0) !== 0 && !hasDeploymentsInProject,
                hasDeploymentsInProject: hasDeploymentsInProject,
                shouldShowAppConfigContextPrompt: shouldShowAppConfigContextPrompt
            })).catch((ex)=>(0, $kVLXA.Observable).of((0, $fMtTa.releasesDataFetchResponse)(ex)));
    });

});
parcelRegister("gd05V", function(module, exports) {

$parcel$export(module.exports, "fetchReleasesData", () => $cfcea22af164bf6b$export$b6fa289f64b57d6);
$parcel$export(module.exports, "getDeploymentDataDetected", () => $cfcea22af164bf6b$export$ee660826ba4bb836);
$parcel$export(module.exports, "getShowAppConfigPrompt", () => $cfcea22af164bf6b$export$d76ed50d7edd1a17);

var $4yvu7 = parcelRequire("4yvu7");

var $fs07e = parcelRequire("fs07e");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $2YZCu = parcelRequire("2YZCu");

var $1QNzn = parcelRequire("1QNzn");

var $7f4tk = parcelRequire("7f4tk");

var $5yJb9 = parcelRequire("5yJb9");

var $fs07e = parcelRequire("fs07e");

var $4yvu7 = parcelRequire("4yvu7");
const $cfcea22af164bf6b$export$5db520940cf00715 = 'jswddFetchOperation';
const $cfcea22af164bf6b$var$remoteLinkInformationQuery = `remoteLinkInformation {
      providers {
        id
        name
        homeUrl
        logoUrl
        documentationUrl
        actions {
          id
          label {
            value
          }
          templateUrl
        }
      }
      remoteLinks {
        id
        providerId
        displayName
        url
        type
        description
        status {
          appearance
          label
        }
        actionIds
        attributeMap {
          key
          value
        }
      }
    }`;
const $cfcea22af164bf6b$var$createGraphqlQuery = (issueId)=>`query ${$cfcea22af164bf6b$export$5db520940cf00715} {
  dataDepotEntities (issueId:${issueId}) {
    deploymentInformation {
      providers {
        id
        name
        homeUrl
        logoUrl
        documentationUrl
        listDeploymentsTemplateUrl
      }
      deployments {
        providerId
        deploymentSequenceNumber
        updateSequenceNumber
        displayName
        url
        description
        lastUpdated
        state
        pipeline {
          id
          displayName
          url
        }
        environment {
          id
          type
          displayName
        }
      }
    }
    featureFlagInformation {
      providers {
        id,
        createFlagTemplateUrl,
        linkFlagTemplateUrl
      },
      featureFlags {
        id,
        key,
        displayName,
        providerId,
        summary {
          url,
          lastUpdated,
          status{
            enabled,
            defaultValue,
            rollout {
              text,
              percentage,
              rules
            }
          }
        }
      }
    }
    ${$cfcea22af164bf6b$var$remoteLinkInformationQuery}
  }
}`;
const $cfcea22af164bf6b$export$b6fa289f64b57d6 = (issueId)=>(0, $7f4tk.default)('/jsw2/graphql', {
        method: 'POST',
        body: JSON.stringify({
            operationName: $cfcea22af164bf6b$export$5db520940cf00715,
            query: $cfcea22af164bf6b$var$createGraphqlQuery(issueId)
        })
    });
const $cfcea22af164bf6b$export$ee660826ba4bb836 = (projectAri, updatedFrom)=>{
    const query = (0, $fs07e.default);
    const variables = {
        projectAri: projectAri,
        updatedFrom: updatedFrom
    };
    const request = (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), query, variables, {
        fetchPolicy: 'store-or-network'
    });
    /* fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
        data will remain saved in the Relay store at any point after the request completes. We need to
        explicitly retain the operation to ensure it doesn't get deleted. See https://relay.dev/docs/api-reference/fetch-query/#behavior */ (0, $5yJb9.default)().retain((0, $eiowN.createOperationDescriptor)((0, $fs07e.default), variables));
    return request.toPromise().then((result)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const data = result;
        return (data?.devOps?.ariGraph?.deploymentRelationships?.nodes ?? []).length > 0;
    });
};
const $cfcea22af164bf6b$export$d76ed50d7edd1a17 = (cloudAri, isJiraAdmin, isSiteAdmin)=>{
    if (!isJiraAdmin && !isSiteAdmin) return Promise.resolve(false);
    const query = (0, $4yvu7.default);
    const variables = {
        cloudAri: cloudAri
    };
    const request = (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), query, variables, {
        fetchPolicy: 'store-or-network'
    });
    /* fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
      data will remain saved in the Relay store at any point after the request completes. We need to
      explicitly retain the operation to ensure it doesn't get deleted. See https://relay.dev/docs/api-reference/fetch-query/#behavior */ (0, $5yJb9.default)().retain((0, $eiowN.createOperationDescriptor)((0, $4yvu7.default), variables));
    return request.toPromise().then((result)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const data = result;
        const isPromptDismissed = data.jira.devOps.isInContextConfigPromptDismissed || false;
        if (isPromptDismissed) return false;
        const appEdges = data.jira.devOps.configStates.edges || [];
        const unconfiguredDisplayableEdges = appEdges// Known apps filter
        .filter((edge)=>(0, $1QNzn.KNOWN_APPS).includes(edge.node.id))// UNCONFIGURED filter
        .filter((edge)=>edge.node.config.edges.map((configEdge)=>configEdge.node)// finding apps that have only workspaces whose states are either NOT_SET or NOT_CONFIGURED
            .find((node)=>node.status === 'CONFIGURED') === undefined)// BBC Permission filter
        .filter((edge)=>!(0, $1QNzn.isBitbucketApp)(edge.node.id) || isJiraAdmin)// BBC no workspace filter.
        .filter((edge)=>!(0, $1QNzn.isBitbucketApp)(edge.node.id) || edge.node.config.edges.length !== 0)// Site admin filter for non-BBC apps
        .filter((edge)=>(0, $1QNzn.isBitbucketApp)(edge.node.id) || isSiteAdmin).filter(Boolean);
        return unconfiguredDisplayableEdges.length > 0;
    }).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('packages.development.summary.releases-field.src.services.servicesGetShowAppConfigPromptQuery', error);
        return false;
    });
};

});
parcelRegister("4yvu7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0abc5b35297af86$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c34f2437bfc2f423bf32ced7881a8e3>>
 * @relayHash b236bb037f21efae8b3db9e134b79fab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2178ae09b612a2f0e42deb54ceb81da2ddc4fa6fe165bc1ebe48551e0d4fab69
const $a0abc5b35297af86$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudAri"
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "providerTypeFilter",
            "value": [
                "DEPLOYMENTS"
            ]
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "args": [
            v1 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "location",
                "value": "RELEASES_PANEL"
            }
        ],
        "kind": "ScalarField",
        "name": "isInContextConfigPromptDismissed"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesGetShowAppConfigPromptQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraDevOpsQuery",
                                    "kind": "LinkedField",
                                    "name": "devOps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v2 /*: any*/ ,
                                                "concreteType": "JiraAppConfigStateConnection",
                                                "kind": "LinkedField",
                                                "name": "configStates",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraAppConfigStateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraAppConfigState",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.devOps.configStates.edges.node.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "JiraConfigStateConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "config",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": {
                                                                                                "concreteType": "JiraConfigStateEdge",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "edges",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "RequiredField",
                                                                                                        "field": {
                                                                                                            "concreteType": "JiraConfigState",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "RequiredField",
                                                                                                                    "field": v4 /*: any*/ ,
                                                                                                                    "action": "THROW",
                                                                                                                    "path": "jira.devOps.configStates.edges.node.config.edges.node.status"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        "action": "THROW",
                                                                                                        "path": "jira.devOps.configStates.edges.node.config.edges.node"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            "action": "THROW",
                                                                                            "path": "jira.devOps.configStates.edges.node.config.edges"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "jira.devOps.configStates.edges.node.config"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.devOps.configStates.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.devOps.configStates.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.devOps.configStates"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.devOps.isInContextConfigPromptDismissed"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.devOps"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesGetShowAppConfigPromptQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraAppConfigStateConnection",
                                    "kind": "LinkedField",
                                    "name": "configStates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraAppConfigStateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraAppConfigState",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraConfigStateConnection",
                                                            "kind": "LinkedField",
                                                            "name": "config",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraConfigStateEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraConfigState",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2178ae09b612a2f0e42deb54ceb81da2ddc4fa6fe165bc1ebe48551e0d4fab69",
            "metadata": {},
            "name": "servicesGetShowAppConfigPromptQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a0abc5b35297af86$var$node.hash = "5a496058391c2f700c2a788b106615f3";
var $a0abc5b35297af86$export$2e2bcd8739ae039 = $a0abc5b35297af86$var$node;

});

parcelRegister("fs07e", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcb5aad601b22458$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<627fe55cd027a11ebd9af0ed29ba0e3c>>
 * @relayHash b0eb9873044d9ccba19314fe68e9bb1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8342e2ea0ff3cd037923d335fe38968b82cafad942e8e2eafb1a491ed32effc8
const $dcb5aad601b22458$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updatedFrom"
        }
    ], v1 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "concreteType": "AriGraph",
                "kind": "LinkedField",
                "name": "ariGraph",
                "plural": false,
                "selections": [
                    {
                        "alias": "deploymentRelationships",
                        "args": [
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "from",
                                        "variableName": "projectAri"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "project-associated-deployment"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "updatedFrom",
                                        "variableName": "updatedFrom"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "filter"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                            }
                        ],
                        "concreteType": "AriGraphRelationshipConnection",
                        "kind": "LinkedField",
                        "name": "relationships",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "AriGraphRelationship",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesDeploymentDataDetectedQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesDeploymentDataDetectedQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "8342e2ea0ff3cd037923d335fe38968b82cafad942e8e2eafb1a491ed32effc8",
            "metadata": {},
            "name": "servicesDeploymentDataDetectedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dcb5aad601b22458$var$node.hash = "4abf81733e9857e06456b12e09b78a9a";
var $dcb5aad601b22458$export$2e2bcd8739ae039 = $dcb5aad601b22458$var$node;

});

parcelRegister("1QNzn", function(module, exports) {

$parcel$export(module.exports, "getFallbackConfigurationUrl", () => $87cc94fcfbb67765$export$e4abb5a575872172);
$parcel$export(module.exports, "FULLY_SUPPORTED_APPS", () => $87cc94fcfbb67765$export$984829de7b959fa);
$parcel$export(module.exports, "SECURITY_KNOWN_APPS", () => $87cc94fcfbb67765$export$295a47a2b6f71e87);
$parcel$export(module.exports, "KNOWN_APPS", () => $87cc94fcfbb67765$export$ce50b0371c784bb4);
$parcel$export(module.exports, "isGitHubApp", () => $87cc94fcfbb67765$export$8692316b30955965);
$parcel$export(module.exports, "isBitbucketApp", () => $87cc94fcfbb67765$export$f727bb5c7a5da2e8);
const $87cc94fcfbb67765$export$e4abb5a575872172 = (providerId)=>`/plugins/servlet/upm#manage/${providerId}`;
const $87cc94fcfbb67765$export$849f8961c23a6717 = 'bitbucket';
const $87cc94fcfbb67765$var$AZURE_DEVOPS_FOR_JIRA_APP_ID = 'azure-devops-for-jira';
const $87cc94fcfbb67765$var$GITHUB_DEV_APP_ID = 'com.github.integration.development';
const $87cc94fcfbb67765$export$88a3a98061542c02 = 'com.github.integration.production';
const $87cc94fcfbb67765$var$GITHUB_STG_APP_ID = 'com.github.integration.staging';
const $87cc94fcfbb67765$export$7577c3ec4f9ea9b2 = 'gitlab-jira-connect-gitlab.com';
const $87cc94fcfbb67765$var$CIRCLE_CI_APP_ID = 'circleci.jira';
const $87cc94fcfbb67765$export$4d58d622f2bf10cd = 'com.xiplink.jira.git.jira_git_plugin';
const $87cc94fcfbb67765$var$HARNESS_CI_APP_ID = 'com.harness.ci.plugin.jira';
const $87cc94fcfbb67765$var$JENKINS_APP_ID = 'com.atlassian.jenkins-for-jira';
const $87cc94fcfbb67765$var$JFROG_APP_ID = 'jfrog-artifactory-saas-integration';
const $87cc94fcfbb67765$var$OCTOPUS_DEPLOY_APP_ID = 'com.octopus.jiraconnectapp.production';
const $87cc94fcfbb67765$var$STACK_HAWK_APP_ID = 'stackhawk-jira-connect-prod';
const $87cc94fcfbb67765$var$JSM_APP_ID = 'com.plugins4people.jsd.jsd-config-importer';
const $87cc94fcfbb67765$var$SNYK_APP_ID = 'snyk.in.jira';
const $87cc94fcfbb67765$var$SNYK_STG_APP_ID = 'jira-devops-security-app-stg';
const $87cc94fcfbb67765$var$STACKHAWK_APP_ID = 'stackhawk-jira-connect-prod';
const $87cc94fcfbb67765$var$MEND_APP_ID = 'WhiteSource-Jira-Cloud';
const $87cc94fcfbb67765$var$LACEWORK_APP_ID = 'lacework-vuln-jira-connect';
const $87cc94fcfbb67765$var$JFROG_SECURITY_APP_ID = 'jfrog.security.jiraSecurityInfoProvider';
const $87cc94fcfbb67765$var$SYSDIG_APP_ID = 'sysdigAppKey';
// Design
const $87cc94fcfbb67765$var$FIGMA_APP_ID = 'com.figma.jira-add-on-dev';
const $87cc94fcfbb67765$export$984829de7b959fa = [
    $87cc94fcfbb67765$export$849f8961c23a6717,
    $87cc94fcfbb67765$export$88a3a98061542c02,
    $87cc94fcfbb67765$var$GITHUB_STG_APP_ID,
    $87cc94fcfbb67765$var$SNYK_APP_ID,
    $87cc94fcfbb67765$var$SNYK_STG_APP_ID
];
const $87cc94fcfbb67765$export$295a47a2b6f71e87 = [
    $87cc94fcfbb67765$var$JFROG_APP_ID,
    $87cc94fcfbb67765$var$STACK_HAWK_APP_ID,
    $87cc94fcfbb67765$var$SNYK_APP_ID,
    $87cc94fcfbb67765$var$SNYK_STG_APP_ID,
    $87cc94fcfbb67765$var$STACKHAWK_APP_ID,
    $87cc94fcfbb67765$var$MEND_APP_ID,
    $87cc94fcfbb67765$var$LACEWORK_APP_ID,
    $87cc94fcfbb67765$var$JFROG_SECURITY_APP_ID,
    $87cc94fcfbb67765$var$SYSDIG_APP_ID
];
const $87cc94fcfbb67765$export$ce50b0371c784bb4 = [
    $87cc94fcfbb67765$export$849f8961c23a6717,
    $87cc94fcfbb67765$var$AZURE_DEVOPS_FOR_JIRA_APP_ID,
    $87cc94fcfbb67765$var$GITHUB_DEV_APP_ID,
    $87cc94fcfbb67765$export$88a3a98061542c02,
    $87cc94fcfbb67765$var$GITHUB_STG_APP_ID,
    $87cc94fcfbb67765$export$7577c3ec4f9ea9b2,
    $87cc94fcfbb67765$var$CIRCLE_CI_APP_ID,
    $87cc94fcfbb67765$export$4d58d622f2bf10cd,
    $87cc94fcfbb67765$var$HARNESS_CI_APP_ID,
    $87cc94fcfbb67765$var$JENKINS_APP_ID,
    $87cc94fcfbb67765$var$OCTOPUS_DEPLOY_APP_ID,
    $87cc94fcfbb67765$var$JSM_APP_ID,
    $87cc94fcfbb67765$var$FIGMA_APP_ID,
    ...$87cc94fcfbb67765$export$295a47a2b6f71e87
];
const $87cc94fcfbb67765$export$8692316b30955965 = (appId)=>[
        $87cc94fcfbb67765$var$GITHUB_DEV_APP_ID,
        $87cc94fcfbb67765$export$88a3a98061542c02,
        $87cc94fcfbb67765$var$GITHUB_STG_APP_ID
    ].includes(appId);
const $87cc94fcfbb67765$export$f727bb5c7a5da2e8 = (appId)=>appId === $87cc94fcfbb67765$export$849f8961c23a6717;

});


parcelRegister("lsaAq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a98c6dcb6ebe71f5$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $fn8B5 = parcelRequire("fn8B5");

var $80afZ = parcelRequire("80afZ");

var $8gGUD = parcelRequire("8gGUD");

var $2YZCu = parcelRequire("2YZCu");

var $hKyAu = parcelRequire("hKyAu");

var $g0VRf = parcelRequire("g0VRf");

var $8zOmE = parcelRequire("8zOmE");


var $gd05V = parcelRequire("gd05V");

var $aqDhU = parcelRequire("aqDhU");
const $a98c6dcb6ebe71f5$var$ENABLED = true;
const $a98c6dcb6ebe71f5$var$DISABLED = false;
const $a98c6dcb6ebe71f5$var$ENTITY_PERMISSION_ERROR_STATUS_CODE = 403; // User does not have view_issue permission or dev_tool_permission
const $a98c6dcb6ebe71f5$var$ENTITY_NOT_AVAILABLE_STATUS_CODE = 404; // jswdd entity is not available, e.g tenant is not active.
const $a98c6dcb6ebe71f5$var$EXPECTED_ERROR_STATUS_CODES = [
    $a98c6dcb6ebe71f5$var$ENTITY_PERMISSION_ERROR_STATUS_CODE,
    $a98c6dcb6ebe71f5$var$ENTITY_NOT_AVAILABLE_STATUS_CODE
];
const $a98c6dcb6ebe71f5$var$JSWDD_ENTITIES_FETCH_ERROR = 'jswdd.entities.fetch-error';
const $a98c6dcb6ebe71f5$var$byEnabledFilter = (enabledStatus)=>(flag)=>((0, $7uUwQ.getIn)(flag, [
            'summary',
            'status',
            'enabled'
        ]) || $a98c6dcb6ebe71f5$var$DISABLED) === enabledStatus;
const $a98c6dcb6ebe71f5$var$byUrlExistsFilter = (flag)=>!!(0, $7uUwQ.getIn)(flag, [
        'summary',
        'url'
    ]);
const $a98c6dcb6ebe71f5$var$extractFlagName = (flag)=>(0, $g0VRf.toFeatureFlagName)(flag.displayName || flag.key || flag.id || '');
const $a98c6dcb6ebe71f5$var$extractFeatureFlagNames = (response, enabledStatus)=>((0, $7uUwQ.getIn)(response, [
        'data',
        'featureFlagInformation',
        'featureFlags'
    ]) || []).filter($a98c6dcb6ebe71f5$var$byEnabledFilter(enabledStatus)).map($a98c6dcb6ebe71f5$var$extractFlagName);
const $a98c6dcb6ebe71f5$var$extractRolloutSummary = (response)=>(0, $7uUwQ.getIn)(response.data.featureFlagInformation.featureFlags[0], [
        'summary',
        'status',
        'rollout'
    ]) || {
        text: undefined,
        percentage: undefined,
        rules: undefined
    };
const $a98c6dcb6ebe71f5$var$extractDetailsLink = (response, enabledStatus)=>{
    const suitableFlagWithUrl = ((0, $7uUwQ.getIn)(response, [
        'data',
        'featureFlagInformation',
        'featureFlags'
    ]) || []).filter($a98c6dcb6ebe71f5$var$byEnabledFilter(enabledStatus)).filter($a98c6dcb6ebe71f5$var$byUrlExistsFilter)// @ts-expect-error - TS7006 - Parameter 'flag1' implicitly has an 'any' type. | TS7006 - Parameter 'flag2' implicitly has an 'any' type.
    .sort((flag1, flag2)=>$a98c6dcb6ebe71f5$var$extractFlagName(flag1) < $a98c6dcb6ebe71f5$var$extractFlagName(flag2) ? -1 : 1)[0];
    if (suitableFlagWithUrl) {
        // getIn return type is generic. Not specifying the type as string causes flow to infer getIn returns SanitizedUrl
        const summaryUrl = (0, $7uUwQ.getIn)(suitableFlagWithUrl, [
            'summary',
            'url'
        ]) || '';
        return (0, $g0VRf.toFeatureFlagDetailsLink)((0, $hKyAu.toSanitizedUrl)(summaryUrl));
    }
    return undefined;
};
const $a98c6dcb6ebe71f5$var$extractCreateFeatureFlagLinkTemplate = (response)=>((0, $7uUwQ.getIn)(response, [
        'data',
        'featureFlagInformation',
        'providers'
    ]) || [])// @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    .filter((provider)=>!!provider.createFlagTemplateUrl)// @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    .map((provider)=>({
            linkTemplate: (0, $hKyAu.toSanitizedUrl)(provider.createFlagTemplateUrl || ''),
            providerId: provider.id || (0, $1789cefc0ee00d21$export$44ed44629a994f5a)
        }))[0];
const $a98c6dcb6ebe71f5$var$extractConnectFeatureFlagLinkTemplate = (response)=>((0, $7uUwQ.getIn)(response, [
        'data',
        'featureFlagInformation',
        'providers'
    ]) || [])// @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    .filter((provider)=>!!provider.linkFlagTemplateUrl)// @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    .map((provider)=>({
            linkTemplate: (0, $hKyAu.toSanitizedUrl)(provider.linkFlagTemplateUrl || ''),
            providerId: provider.id || (0, $1789cefc0ee00d21$export$44ed44629a994f5a)
        }))[0];
const $a98c6dcb6ebe71f5$var$extractFeatureFlagsPerProvider = (response)=>{
    const featureFlagsPerProvider = {};
    // @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    ((0, $7uUwQ.getIn)(response, [
        'data',
        'featureFlagInformation',
        'providers'
    ]) || []).forEach((provider)=>{
        featureFlagsPerProvider[provider.id || (0, $1789cefc0ee00d21$export$44ed44629a994f5a)] = [];
    });
    // @ts-expect-error - TS7006 - Parameter 'flag' implicitly has an 'any' type.
    ((0, $7uUwQ.getIn)(response, [
        'data',
        'featureFlagInformation',
        'featureFlags'
    ]) || []).forEach((flag)=>{
        const providerId = flag.providerId || (0, $1789cefc0ee00d21$export$44ed44629a994f5a);
        featureFlagsPerProvider[providerId] = featureFlagsPerProvider[providerId] || [];
        featureFlagsPerProvider[providerId].push((0, $g0VRf.toFeatureFlagId)(flag.id || ''));
    });
    Object.keys(featureFlagsPerProvider).forEach((key)=>{
        featureFlagsPerProvider[key].sort();
    });
    return featureFlagsPerProvider;
};
const $a98c6dcb6ebe71f5$var$extractEnvironmentTypeWeight = (deployment)=>(0, $aqDhU.deploymentEnvironmentTypes)[deployment.environment.type];
const $a98c6dcb6ebe71f5$var$extractStateWeight = (deployment)=>(0, $aqDhU.deploymentStates)[deployment.state];
const $a98c6dcb6ebe71f5$export$10b995b311a339fd = (deployments)=>{
    const deploymentsByEnvironment = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(deployments, (deployment)=>{
        const { environment: environment } = deployment;
        return `${environment.type}_${environment.displayName}`;
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))(deploymentsByEnvironment, (deploymentsInEnv)=>(0, (/*@__PURE__*/$parcel$interopDefault($8gGUD)))(deploymentsInEnv, (deployment)=>new Date(deployment.lastUpdated)));
};
const $a98c6dcb6ebe71f5$export$c033b07930063f14 = (deployments)=>{
    let environmentTypeWeight = -1;
    let stateWeight = -1;
    if (!deployments) return null;
    // @ts-expect-error - TS2741 - Property 'environmentType' is missing in type 'Deployment' but required in type 'DeploymentSummary'. | TS2769 - No overload matches this call.
    return deployments.reduce((accumulator, deployment)=>{
        const newEnvironmentTypeWeight = $a98c6dcb6ebe71f5$var$extractEnvironmentTypeWeight(deployment);
        const newStateWeight = $a98c6dcb6ebe71f5$var$extractStateWeight(deployment);
        if (typeof newEnvironmentTypeWeight !== 'undefined' && (environmentTypeWeight < newEnvironmentTypeWeight || environmentTypeWeight === newEnvironmentTypeWeight && typeof newStateWeight !== 'undefined' && stateWeight < newStateWeight)) {
            environmentTypeWeight = newEnvironmentTypeWeight;
            stateWeight = typeof newStateWeight !== 'undefined' ? newStateWeight : -1; // Can't move undefined check to constant or flow doesn't pick it up
            return {
                environmentType: deployment.environment.type,
                state: deployment.state,
                providerId: deployment.providerId
            };
        }
        return accumulator;
    }, null);
};
const $a98c6dcb6ebe71f5$export$f5988b35e0aea011 = (deployments)=>{
    const latestDeploymentInEachEnvironment = $a98c6dcb6ebe71f5$export$10b995b311a339fd(deployments);
    return $a98c6dcb6ebe71f5$export$c033b07930063f14(latestDeploymentInEachEnvironment);
};
const $a98c6dcb6ebe71f5$var$extractDeploymentsDataForMultipleProviders = (response)=>{
    const providerInformation = response?.data?.deploymentInformation?.providers || [];
    const deploymentInformation = response?.data?.deploymentInformation?.deployments || [];
    // Organise by provider for future referencing
    const deploymentsByProvider = deploymentInformation.reduce((accumulator, deployment)=>{
        const { providerId: providerId } = deployment;
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        const newAccumulator = {
            ...accumulator
        };
        if (!Object.hasOwnProperty.call(newAccumulator, providerId)) newAccumulator[providerId] = [];
        newAccumulator[providerId].push(deployment);
        return newAccumulator;
    }, {});
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mapToDeploymentsByEnvironmentType = (deployments)=>// @ts-expect-error - TS7006 - Parameter 'accumulator' implicitly has an 'any' type. | TS7006 - Parameter 'deployment' implicitly has an 'any' type.
        deployments.reduce((accumulator, deployment)=>{
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            const newAccumulator = {
                ...accumulator
            };
            const { environment: { type: environmentType } } = deployment;
            if (!Object.hasOwnProperty.call(newAccumulator, environmentType)) newAccumulator[environmentType] = [];
            newAccumulator[environmentType].push({
                displayName: (0, $g0VRf.toDeploymentDisplayName)(deployment.displayName),
                lastUpdated: Date.parse(deployment.lastUpdated),
                environment: {
                    displayName: (0, $g0VRf.toEnvironmentDisplayName)(deployment.environment.displayName)
                },
                pipeline: {
                    displayName: (0, $g0VRf.toPipelineDisplayName)(deployment.pipeline.displayName),
                    url: (0, $hKyAu.toSanitizedUrl)(deployment.pipeline.url)
                },
                state: deployment.state,
                url: (0, $hKyAu.toSanitizedUrl)(deployment.url)
            });
            return newAccumulator;
        }, {});
    const providers = providerInformation.reduce((accumulator, provider)=>{
        const summary = $a98c6dcb6ebe71f5$export$f5988b35e0aea011(deploymentsByProvider[provider.id]);
        if (summary) // @ts-expect-error - TS2769 - No overload matches this call.
        return accumulator.concat({
            id: provider.id || (0, $1789cefc0ee00d21$export$44ed44629a994f5a),
            name: provider.name || '',
            state: summary.state,
            listDeploymentsLinkTemplateUrl: (0, $hKyAu.toSanitizedUrl)(provider.listDeploymentsTemplateUrl || ''),
            environments: mapToDeploymentsByEnvironmentType(deploymentsByProvider[provider.id])
        });
        return accumulator;
    }, []);
    const summary = $a98c6dcb6ebe71f5$export$f5988b35e0aea011(deploymentInformation);
    return summary ? {
        summary: summary,
        providers: providers
    } : {
        summary: null,
        providers: []
    };
};
const $a98c6dcb6ebe71f5$var$extractRemoteLinksForMultipleProviders = (response)=>{
    let providers = response?.data?.remoteLinkInformation?.providers || [];
    let remoteLinks = response?.data?.remoteLinkInformation?.remoteLinks || [];
    // check FF
    // @ts-expect-error - TS2339 - Property 'actions' does not exist on type 'RemoteLinkProvider'.
    providers = providers.map(({ logoUrl: logoUrl, homeUrl: homeUrl, documentationUrl: documentationUrl, actions: actions, ...rest })=>({
            ...rest,
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            logoUrl: (0, $hKyAu.toSanitizedUrl)(logoUrl),
            homeUrl: (0, $hKyAu.toSanitizedUrl)(homeUrl),
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            documentationUrl: (0, $hKyAu.toSanitizedUrl)(documentationUrl),
            actions: {
                ...actions,
                ...actions && {
                    templateUrl: (0, $hKyAu.toSanitizedUrl)(actions.templateUrl)
                }
            }
        }));
    remoteLinks = remoteLinks.map(({ url: url, ...rest })=>({
            ...rest,
            url: (0, $hKyAu.toSanitizedUrl)(url)
        }));
    return providers.length ? {
        providers: providers,
        remoteLinks: remoteLinks
    } : {
        providers: [],
        remoteLinks: []
    };
};
const $a98c6dcb6ebe71f5$var$logErrors = (response)=>{
    if (response.errors && response.errors.length > 0) (0, $2YZCu.default).safeErrorWithoutCustomerData('development.releases-glance.data-provider.errors', `Releases information from SWAG contains errors: ${JSON.stringify(response.errors)}`);
};
const $a98c6dcb6ebe71f5$var$transformResponse = (response)=>{
    $a98c6dcb6ebe71f5$var$logErrors(response);
    const enabledFlagNames = $a98c6dcb6ebe71f5$var$extractFeatureFlagNames(response, $a98c6dcb6ebe71f5$var$ENABLED).sort();
    const disabledFlagNames = $a98c6dcb6ebe71f5$var$extractFeatureFlagNames(response, $a98c6dcb6ebe71f5$var$DISABLED).sort();
    return {
        featureFlags: {
            enabledFlagNames: enabledFlagNames,
            disabledFlagNames: disabledFlagNames,
            // This is a temp solution: the details will be replaced by a sliding panel after MVP
            detailsLink: $a98c6dcb6ebe71f5$var$extractDetailsLink(response, $a98c6dcb6ebe71f5$var$ENABLED) || $a98c6dcb6ebe71f5$var$extractDetailsLink(response, $a98c6dcb6ebe71f5$var$DISABLED),
            rolloutSummary: enabledFlagNames.length === 1 && disabledFlagNames.length === 0 ? $a98c6dcb6ebe71f5$var$extractRolloutSummary(response) : undefined,
            createFlagLinkTemplate: $a98c6dcb6ebe71f5$var$extractCreateFeatureFlagLinkTemplate(response),
            connectFlagLinkTemplate: $a98c6dcb6ebe71f5$var$extractConnectFeatureFlagLinkTemplate(response),
            flagsPerProvider: $a98c6dcb6ebe71f5$var$extractFeatureFlagsPerProvider(response)
        },
        deployments: $a98c6dcb6ebe71f5$var$extractDeploymentsDataForMultipleProviders(response),
        remoteLinks: $a98c6dcb6ebe71f5$var$extractRemoteLinksForMultipleProviders(response),
        shouldShowEmptyState: undefined,
        hasDeploymentsInProject: undefined,
        shouldShowAppConfigContextPrompt: undefined
    };
};
const $a98c6dcb6ebe71f5$var$eventName = 'releasesData fetched';
const $a98c6dcb6ebe71f5$export$9bfdf944b8987eac = (error)=>{
    if (error.extensions) {
        const { statusCode: statusCode, errorType: errorType } = error.extensions;
        (0, $2YZCu.default).safeErrorWithoutCustomerData('development.releases-glance.data-provider.errors', `Releases information SWAG errors statusCode: ${statusCode}, errorType: ${errorType}`);
        if (// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $a98c6dcb6ebe71f5$var$EXPECTED_ERROR_STATUS_CODES.includes(statusCode) && errorType === $a98c6dcb6ebe71f5$var$JSWDD_ENTITIES_FETCH_ERROR) return true;
    }
    return false;
};
const $a98c6dcb6ebe71f5$var$fireFetchedEvent = (issueId, analyticsEvent, restResponse, releasesData, startTime)=>{
    const hasErrors = !!(restResponse && restResponse.errors && restResponse.errors.length > 0);
    const isExpectedBackendError = hasErrors && restResponse.errors && restResponse.errors.length > 0 ? $a98c6dcb6ebe71f5$export$9bfdf944b8987eac(restResponse.errors[0]) : false;
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, $a98c6dcb6ebe71f5$var$eventName, {
        issueId: issueId,
        hasFeatureFlags: (0, $g0VRf.hasFeatureFlags)(releasesData),
        hasDeployments: (0, $g0VRf.hasDeployments)(releasesData),
        hasRemoteLinks: (0, $g0VRf.hasRemoteLinks)(releasesData),
        hasErrors: hasErrors,
        elapsed: Date.now() - startTime,
        isExpectedBackendError: isExpectedBackendError
    });
};
const $a98c6dcb6ebe71f5$var$fireFetchedErrorEvent = (issueId, analyticsEvent, error, startTime)=>{
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, $a98c6dcb6ebe71f5$var$eventName, {
        issueId: issueId,
        globalError: true,
        error: error,
        elapsed: Date.now() - startTime
    });
};
const $a98c6dcb6ebe71f5$var$flattenEntities = (response)=>({
        data: response.data.dataDepotEntities,
        errors: response.errors
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a98c6dcb6ebe71f5$export$2e2bcd8739ae039 = ({ issueId: issueId, analyticsEvent: analyticsEvent })=>{
    const startTime = Date.now();
    return (0, $gd05V.fetchReleasesData)(issueId).then($a98c6dcb6ebe71f5$var$flattenEntities).then((restResponse)=>{
        const releasesData = $a98c6dcb6ebe71f5$var$transformResponse(restResponse);
        $a98c6dcb6ebe71f5$var$fireFetchedEvent(issueId, analyticsEvent, restResponse, releasesData, startTime);
        return releasesData;
    }).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('development.releases-glance.data-provider.exception', 'Failed to fetch releases information via SWAG', error);
        $a98c6dcb6ebe71f5$var$fireFetchedErrorEvent(issueId, analyticsEvent, error, startTime);
        throw error;
    });
};

});
parcelRegister("fn8B5", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $b30fac385487af61$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b30fac385487af61$var$hasOwnProperty = $b30fac385487af61$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b30fac385487af61$var$groupBy = $4CZTG(function(result, value, key) {
    if ($b30fac385487af61$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $1m3dq(result, key, [
        value
    ]);
});
module.exports = $b30fac385487af61$var$groupBy;

});

parcelRegister("8gGUD", function(module, exports) {

var $la2vn = parcelRequire("la2vn");

var $5JMmU = parcelRequire("5JMmU");

var $bxDef = parcelRequire("bxDef");
/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function $60511ae2dc52baf1$var$maxBy(array, iteratee) {
    return array && array.length ? $la2vn(array, $bxDef(iteratee, 2), $5JMmU) : undefined;
}
module.exports = $60511ae2dc52baf1$var$maxBy;

});

parcelRegister("g0VRf", function(module, exports) {

$parcel$export(module.exports, "toFeatureFlagId", () => $5eafb6b68302b071$export$8e66ad0b633b415f);
$parcel$export(module.exports, "toFeatureFlagName", () => $5eafb6b68302b071$export$665dc250cb388c02);
$parcel$export(module.exports, "toFeatureFlagDetailsLink", () => $5eafb6b68302b071$export$57fd4590ae62089e);
$parcel$export(module.exports, "toPipelineDisplayName", () => $5eafb6b68302b071$export$fd91eb7369da4a69);
$parcel$export(module.exports, "toEnvironmentDisplayName", () => $5eafb6b68302b071$export$d1c32f7be115aa97);
$parcel$export(module.exports, "toDeploymentDisplayName", () => $5eafb6b68302b071$export$ec390a449fea39b3);
$parcel$export(module.exports, "fromRemoteLinkProviderId", () => $5eafb6b68302b071$export$50d16d2f55ca2376);
$parcel$export(module.exports, "fromRemoteLinkType", () => $5eafb6b68302b071$export$70e3985bd51b81e);
$parcel$export(module.exports, "deploymentStates", () => $5eafb6b68302b071$export$1b225d9a00ae61b0);
$parcel$export(module.exports, "deploymentEnvironmentTypes", () => $5eafb6b68302b071$export$891e2ef97b236dc0);
$parcel$export(module.exports, "hasFeatureFlags", () => $5eafb6b68302b071$export$89e863511b5e821a);
$parcel$export(module.exports, "hasDeployments", () => $5eafb6b68302b071$export$feabb47efebd957);
$parcel$export(module.exports, "hasRemoteLinks", () => $5eafb6b68302b071$export$29f28c1ba5d28d3c);
const $5eafb6b68302b071$export$8e66ad0b633b415f = (str)=>str;
const $5eafb6b68302b071$export$665dc250cb388c02 = (str)=>str;
const $5eafb6b68302b071$export$57fd4590ae62089e = (str)=>str;
const $5eafb6b68302b071$export$32e9107523e9d25e = (str)=>str;
const $5eafb6b68302b071$export$fd91eb7369da4a69 = (str)=>str;
const $5eafb6b68302b071$export$d1c32f7be115aa97 = (str)=>str;
const $5eafb6b68302b071$export$ec390a449fea39b3 = (str)=>str;
const $5eafb6b68302b071$export$50d16d2f55ca2376 = (remoteLinkProviderId)=>remoteLinkProviderId;
const $5eafb6b68302b071$export$70e3985bd51b81e = (remoteLinkType)=>remoteLinkType;
const $5eafb6b68302b071$export$c7ab90603432f2be = (str)=>str;
const $5eafb6b68302b071$export$339c9f5f886e20c2 = (str)=>str;
const $5eafb6b68302b071$export$d751c2a45ba0c98e = (str)=>str;
const $5eafb6b68302b071$export$25aad62b43bfd30a = (str)=>str;
const $5eafb6b68302b071$export$9b78d14d979e43d2 = (str)=>str;
const $5eafb6b68302b071$export$3c6531bfd08bfa25 = (str)=>str;
const $5eafb6b68302b071$export$a8290d7b04222021 = (str)=>str;
const $5eafb6b68302b071$export$1b225d9a00ae61b0 = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESSFUL: 'SUCCESSFUL',
    FAILED: 'FAILED',
    ROLLED_BACK: 'ROLLED_BACK',
    CANCELLED: 'CANCELLED',
    UNKNOWN: 'UNKNOWN'
};
const $5eafb6b68302b071$export$891e2ef97b236dc0 = {
    PRODUCTION: 'PRODUCTION',
    STAGING: 'STAGING',
    TESTING: 'TESTING',
    DEVELOPMENT: 'DEVELOPMENT',
    UNMAPPED: 'UNMAPPED'
};
const $5eafb6b68302b071$export$d029bea844ee98c1 = [
    'PRODUCTION',
    'STAGING',
    'TESTING',
    'DEVELOPMENT',
    'UNMAPPED'
];
const $5eafb6b68302b071$export$89e863511b5e821a = (data)=>!!(data && data.featureFlags && (data.featureFlags.enabledFlagNames && data.featureFlags.enabledFlagNames.length > 0 || data.featureFlags.disabledFlagNames && data.featureFlags.disabledFlagNames.length > 0));
const $5eafb6b68302b071$export$feabb47efebd957 = (data)=>!!(data && data.deployments && data.deployments.summary);
const $5eafb6b68302b071$export$29f28c1ba5d28d3c = (data)=>!!(data && data.remoteLinks && data.remoteLinks.remoteLinks);

});

const $1789cefc0ee00d21$export$44ed44629a994f5a = '<unknown>';
const $1789cefc0ee00d21$export$e68cad5334cc5b = 'vyhOd8hgbSa4rzgnTvyaZNSUqUViKIOc';
const $1789cefc0ee00d21$export$a42a1a2fb6310bc7 = 'oAPCjkrphiFxmqbTLkv9r2jBFTvfOI8x';

parcelRegister("aqDhU", function(module, exports) {

$parcel$export(module.exports, "deploymentStates", () => $eb38a11513af127d$export$1b225d9a00ae61b0);
$parcel$export(module.exports, "deploymentEnvironmentTypes", () => $eb38a11513af127d$export$891e2ef97b236dc0);
const $eb38a11513af127d$export$1b225d9a00ae61b0 = {
    PENDING: 5,
    IN_PROGRESS: 4,
    SUCCESSFUL: 3,
    FAILED: 6,
    ROLLED_BACK: 2,
    CANCELLED: 1,
    UNKNOWN: 0
};
const $eb38a11513af127d$export$891e2ef97b236dc0 = {
    PRODUCTION: 4,
    STAGING: 3,
    TESTING: 2,
    DEVELOPMENT: 1,
    UNMAPPED: 0
};

});


parcelRegister("ddQHu", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $b605a5e8521cba86$export$c420c9f40402ab6d);
$parcel$export(module.exports, "issueContextSelector", () => $b605a5e8521cba86$export$415e6aac9a9554d9);
$parcel$export(module.exports, "userSelector", () => $b605a5e8521cba86$export$210c0a88ec4709b);
$parcel$export(module.exports, "isAnonymousSelector", () => $b605a5e8521cba86$export$a165ec261432d0b8);

var $dGvGJ = parcelRequire("dGvGJ");
const $b605a5e8521cba86$export$c420c9f40402ab6d = (state)=>state.releasesContext;
const $b605a5e8521cba86$export$415e6aac9a9554d9 = (0, $dGvGJ.createSelector)($b605a5e8521cba86$export$c420c9f40402ab6d, (context)=>context.issueContext);
const $b605a5e8521cba86$export$210c0a88ec4709b = (0, $dGvGJ.createSelector)($b605a5e8521cba86$export$c420c9f40402ab6d, (context)=>context.user);
const $b605a5e8521cba86$export$a165ec261432d0b8 = (0, $dGvGJ.createSelector)($b605a5e8521cba86$export$210c0a88ec4709b, (user)=>user === null);

});

parcelRegister("fMtTa", function(module, exports) {

$parcel$export(module.exports, "RELEASES_DATA_FETCH_REQUEST", () => $4a1bf8e68df2de2a$export$61d84ae40be9d55);
$parcel$export(module.exports, "RELEASES_DATA_FETCH_RESPONSE", () => $4a1bf8e68df2de2a$export$5599495e69db04b2);
$parcel$export(module.exports, "releasesDataFetchRequest", () => $4a1bf8e68df2de2a$export$328ad4a3fe812d60);
$parcel$export(module.exports, "releasesDataFetchResponse", () => $4a1bf8e68df2de2a$export$97fc21bca7692f58);
const $4a1bf8e68df2de2a$export$61d84ae40be9d55 = 'RELEASES_DATA_FETCH_REQUEST';
const $4a1bf8e68df2de2a$export$5599495e69db04b2 = 'RELEASES_DATA_FETCH_RESPONSE';
const $4a1bf8e68df2de2a$export$328ad4a3fe812d60 = (analyticsEvent)=>({
        type: $4a1bf8e68df2de2a$export$61d84ae40be9d55,
        payload: {
            meta: {
                analyticsEvent: analyticsEvent
            }
        }
    });
const $4a1bf8e68df2de2a$export$97fc21bca7692f58 = (payload)=>({
        type: $4a1bf8e68df2de2a$export$5599495e69db04b2,
        payload: payload,
        error: payload instanceof Error
    });

});


parcelRegister("ecbp7", function(module, exports) {

$parcel$export(module.exports, "releasesDataReducer", () => $2e62163491d8b2b8$export$c9a345f0b294927c);

var $7uUwQ = parcelRequire("7uUwQ");

var $jcw0u = parcelRequire("jcw0u");

var $fMtTa = parcelRequire("fMtTa");
const $2e62163491d8b2b8$export$c9a345f0b294927c = (state = null, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $fMtTa.RELEASES_DATA_FETCH_RESPONSE:
            if (payload instanceof Error) {
                // TODO: show a error flag
                (0, $jcw0u.default)({
                    meta: {
                        id: 'releasesField',
                        packageName: 'jiraDevelopmentSummaryReleasesField'
                    },
                    attributes: {
                        errorType: 'serverError'
                    }
                });
                return null;
            }
            return (0, $7uUwQ.freeze)(payload);
        default:
            return state;
    }
};

});


parcelRegister("c3QfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $272a4a117639d0a2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGvGJ = parcelRequire("dGvGJ");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $bC2fB = parcelRequire("bC2fB");

var $ddQHu = parcelRequire("ddQHu");

var $fMtTa = parcelRequire("fMtTa");

var $5zJwe = parcelRequire("5zJwe");

var $786Ad = parcelRequire("786Ad");

var $3yDKs = parcelRequire("3yDKs");
const $272a4a117639d0a2$export$fc88f4c7d9964b37 = (props)=>{
    const { isAnonymous: isAnonymous, onIssueChange: onIssueChange, hasProviders: hasProviders, hasSoftwareAccess: hasSoftwareAccess, flagsPerProvider: flagsPerProvider, providers: providers, remoteLinksData: remoteLinksData } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isAnonymous && props.issueContext.issueId) onIssueChange(createAnalyticsEvent({
            action: 'mounted'
        }));
    }, [
        props.issueContext.issueId,
        createAnalyticsEvent,
        onIssueChange,
        isAnonymous
    ]);
    const fireOnMountAnalytics = (0, $3yDKs.useOnMountedAnalytics)({
        actionSubject: 'panel',
        actionSubjectId: 'releasepanelsummary',
        flagsPerProvider: flagsPerProvider,
        providers: providers,
        remoteLinksData: remoteLinksData
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!isAnonymous && hasProviders) fireOnMountAnalytics();
    }, [
        fireOnMountAnalytics,
        hasProviders,
        isAnonymous
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "releasesField",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "releasesField",
        packageName: "jiraDevelopmentSummaryReleasesField"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            isAnonymous: isAnonymous
        }
    }), hasSoftwareAccess && !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $786Ad.ReleasesFieldSummary), props)));
};
const $272a4a117639d0a2$var$disabledFeatureFlagsSelectorMemoized = ()=>(0, $dGvGJ.createSelector)((0, $5zJwe.disabledFeatureFlagsSelector), (res)=>res);
const $272a4a117639d0a2$var$enabledFeatureFlagsSelectorMemoized = ()=>(0, $dGvGJ.createSelector)((0, $5zJwe.enabledFeatureFlagsSelector), (res)=>res);
const $272a4a117639d0a2$var$providersSelectorMemoized = ()=>(0, $dGvGJ.createSelector)((0, $5zJwe.providersSelector), (res)=>res);
const $272a4a117639d0a2$var$flagsPerProviderSelectorMemoized = ()=>(0, $dGvGJ.createSelector)((0, $5zJwe.flagsPerProviderSelector), (res)=>res);
const $272a4a117639d0a2$var$mapStateToPropsFactory = ()=>{
    const disabledFeatureFlagsSelectorInstance = $272a4a117639d0a2$var$disabledFeatureFlagsSelectorMemoized();
    const enabledFeatureFlagsSelectorInstance = $272a4a117639d0a2$var$enabledFeatureFlagsSelectorMemoized();
    const providersSelectorInstance = $272a4a117639d0a2$var$providersSelectorMemoized();
    const flagsPerProviderSelectorInstance = $272a4a117639d0a2$var$flagsPerProviderSelectorMemoized();
    return (state)=>({
            hasProviders: (0, $5zJwe.panelHasValidProvidersOrDataSelector)(state),
            hasFeatureFlagsProviders: (0, $5zJwe.panelHasFeatureFlagsProvidersSelector)(state),
            hasFeatureFlags: (0, $5zJwe.panelHasFeatureFlagsSelector)(state),
            hasDeployments: Boolean((0, $5zJwe.deploymentSummarySelector)(state)),
            isAnonymous: (0, $ddQHu.isAnonymousSelector)(state),
            user: (0, $ddQHu.userSelector)(state),
            deploymentSummary: (0, $5zJwe.deploymentSummarySelector)(state),
            shouldShowEmptyState: (0, $5zJwe.shouldShowEmptyStateSelector)(state),
            shouldShowAppConfigContextPrompt: (0, $5zJwe.shouldShowAppConfigContextPromptSelector)(state),
            providers: providersSelectorInstance(state),
            remoteLinksCount: (0, $5zJwe.remoteLinksCountSelector)(state),
            issueContext: (0, $ddQHu.issueContextSelector)(state),
            totalFeatureFlags: (0, $5zJwe.totalFeatureFlagSelector)(state),
            createFlagLink: (0, $5zJwe.createFlagLinkSelector)(state),
            connectFlagLink: (0, $5zJwe.connectFlagLinkSelector)(state),
            enabledFeatureFlags: enabledFeatureFlagsSelectorInstance(state),
            disabledFeatureFlags: disabledFeatureFlagsSelectorInstance(state),
            detailsLink: (0, $5zJwe.detailsLinkSelector)(state),
            enabledFeatureFlagsCnt: (0, $5zJwe.enabledFeatureFlagsCntSelector)(state),
            disabledFeatureFlagsCnt: (0, $5zJwe.disabledFeatureFlagsCntSelector)(state),
            rolloutSummary: (0, $5zJwe.rolloutSummarySelector)(state),
            flagsPerProvider: flagsPerProviderSelectorInstance(state),
            remoteLinksData: (0, $5zJwe.remoteLinksDataSelector)(state)
        });
};
var $272a4a117639d0a2$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($272a4a117639d0a2$var$mapStateToPropsFactory, (dispatch)=>({
        onIssueChange: (analyticsEvent)=>{
            dispatch((0, $fMtTa.releasesDataFetchRequest)(analyticsEvent));
        }
    }))($272a4a117639d0a2$export$fc88f4c7d9964b37);

});
parcelRegister("5zJwe", function(module, exports) {

$parcel$export(module.exports, "panelHasFeatureFlagsProvidersSelector", () => $9a1395f3f61267e3$export$e6b0ec1826afb24b);
$parcel$export(module.exports, "enabledFeatureFlagsSelector", () => $9a1395f3f61267e3$export$fa33ff9734ca0a71);
$parcel$export(module.exports, "enabledFeatureFlagsCntSelector", () => $9a1395f3f61267e3$export$e07e282ffa13c546);
$parcel$export(module.exports, "disabledFeatureFlagsSelector", () => $9a1395f3f61267e3$export$b00ef6e2f355faf6);
$parcel$export(module.exports, "detailsLinkSelector", () => $9a1395f3f61267e3$export$29cb6940623d77ea);
$parcel$export(module.exports, "flagsPerProviderSelector", () => $9a1395f3f61267e3$export$a6e9d1620bb2932);
$parcel$export(module.exports, "createFlagLinkSelector", () => $9a1395f3f61267e3$export$12338aa1263469a8);
$parcel$export(module.exports, "connectFlagLinkSelector", () => $9a1395f3f61267e3$export$ab240ab572c876f2);
$parcel$export(module.exports, "disabledFeatureFlagsCntSelector", () => $9a1395f3f61267e3$export$36435b68d5fc9a62);
$parcel$export(module.exports, "totalFeatureFlagSelector", () => $9a1395f3f61267e3$export$38ad2089440807a6);
$parcel$export(module.exports, "panelHasFeatureFlagsSelector", () => $9a1395f3f61267e3$export$749121da3f993a0a);
$parcel$export(module.exports, "rolloutSummarySelector", () => $9a1395f3f61267e3$export$8fb4bf9916714a47);
$parcel$export(module.exports, "deploymentSummarySelector", () => $9a1395f3f61267e3$export$8ccd5e71c4425c2e);
$parcel$export(module.exports, "shouldShowEmptyStateSelector", () => $9a1395f3f61267e3$export$83452d57f100d2e1);
$parcel$export(module.exports, "shouldShowAppConfigContextPromptSelector", () => $9a1395f3f61267e3$export$4b34f3b91ade27f);
$parcel$export(module.exports, "remoteLinksDataSelector", () => $9a1395f3f61267e3$export$e2eec4c83cc21e45);
$parcel$export(module.exports, "remoteLinksCountSelector", () => $9a1395f3f61267e3$export$5b94b4c138de532d);
$parcel$export(module.exports, "panelHasValidProvidersOrDataSelector", () => $9a1395f3f61267e3$export$f1eb9bbb58c6a45e);
$parcel$export(module.exports, "providersSelector", () => $9a1395f3f61267e3$export$572c57f4fbd7354d);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");

var $ddQHu = parcelRequire("ddQHu");

var $hsf34 = parcelRequire("hsf34");
const $9a1395f3f61267e3$export$e6b0ec1826afb24b = (state)=>!!state.releasesData && Object.keys(state.releasesData.featureFlags.flagsPerProvider).length > 0;
const $9a1395f3f61267e3$export$fa33ff9734ca0a71 = (state)=>state.releasesData ? state.releasesData.featureFlags.enabledFlagNames : [];
const $9a1395f3f61267e3$export$e07e282ffa13c546 = (state)=>$9a1395f3f61267e3$export$fa33ff9734ca0a71(state).length;
const $9a1395f3f61267e3$export$b00ef6e2f355faf6 = (state)=>state.releasesData ? state.releasesData.featureFlags.disabledFlagNames : [];
const $9a1395f3f61267e3$export$29cb6940623d77ea = (state)=>state.releasesData ? state.releasesData.featureFlags.detailsLink : undefined;
const $9a1395f3f61267e3$export$a6e9d1620bb2932 = (state)=>state.releasesData ? state.releasesData.featureFlags.flagsPerProvider : {};
const $9a1395f3f61267e3$var$injectContextParams = (state, urlTemplate)=>{
    if (!urlTemplate) return undefined;
    const contextValues = {
        'issue.key': (0, $ddQHu.contextSelector)(state).issueContext.issueKey || '',
        'issue.flags': ($9a1395f3f61267e3$export$a6e9d1620bb2932(state)[urlTemplate.providerId] || []).join(','),
        'issue.summary': ((0, $ddQHu.contextSelector)(state).summary || '').substr(0, 255)
    };
    return Object.keys(contextValues).reduce((previousValue, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ 'issue.key': string; 'issue.flags': string; 'issue.summary': string; }'.
        previousValue.split(`{${key}}`).join(encodeURIComponent(contextValues[key])), urlTemplate.linkTemplate);
};
const $9a1395f3f61267e3$export$12338aa1263469a8 = (state)=>state.releasesData ? $9a1395f3f61267e3$var$injectContextParams(state, state.releasesData.featureFlags.createFlagLinkTemplate) : undefined;
const $9a1395f3f61267e3$export$ab240ab572c876f2 = (state)=>state.releasesData ? $9a1395f3f61267e3$var$injectContextParams(state, state.releasesData.featureFlags.connectFlagLinkTemplate) : undefined;
const $9a1395f3f61267e3$export$1c2601b8f2c0e608 = (0, $dGvGJ.createSelector)($9a1395f3f61267e3$export$e6b0ec1826afb24b, $9a1395f3f61267e3$export$12338aa1263469a8, $9a1395f3f61267e3$export$ab240ab572c876f2, (hasFeatureFlagsProviders, createFlagLink, connectFlagLink)=>hasFeatureFlagsProviders && (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(createFlagLink) || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(connectFlagLink)));
const $9a1395f3f61267e3$export$36435b68d5fc9a62 = (state)=>$9a1395f3f61267e3$export$b00ef6e2f355faf6(state).length;
const $9a1395f3f61267e3$export$38ad2089440807a6 = (state)=>$9a1395f3f61267e3$export$e07e282ffa13c546(state) + $9a1395f3f61267e3$export$36435b68d5fc9a62(state);
const $9a1395f3f61267e3$export$749121da3f993a0a = (state)=>$9a1395f3f61267e3$export$e07e282ffa13c546(state) + $9a1395f3f61267e3$export$36435b68d5fc9a62(state) > 0;
const $9a1395f3f61267e3$export$8fb4bf9916714a47 = (state)=>state.releasesData ? state.releasesData.featureFlags.rolloutSummary : undefined;
const $9a1395f3f61267e3$export$8ccd5e71c4425c2e = (state)=>state.releasesData && state.releasesData.deployments && state.releasesData.deployments.summary || undefined;
const $9a1395f3f61267e3$export$83452d57f100d2e1 = (state)=>state.releasesData?.shouldShowEmptyState ?? false;
const $9a1395f3f61267e3$export$4b34f3b91ade27f = (state)=>!$9a1395f3f61267e3$export$8ccd5e71c4425c2e(state) && !$9a1395f3f61267e3$export$10e5ce2c721175a2(state) && state.releasesData?.shouldShowAppConfigContextPrompt || false;
const $9a1395f3f61267e3$export$10e5ce2c721175a2 = (state)=>state.releasesData?.hasDeploymentsInProject ?? true;
const $9a1395f3f61267e3$export$b0c2f2aacbcd25e4 = (state)=>state.releasesData;
const $9a1395f3f61267e3$export$e2eec4c83cc21e45 = (0, $dGvGJ.createSelector)($9a1395f3f61267e3$export$b0c2f2aacbcd25e4, (releasesData)=>releasesData && releasesData.remoteLinks);
const $9a1395f3f61267e3$export$ecbe7938e86d42ce = (0, $dGvGJ.createSelector)($9a1395f3f61267e3$export$e2eec4c83cc21e45, (remoteLinksData)=>remoteLinksData && remoteLinksData.providers ? remoteLinksData.providers.filter((provider)=>!(0, $hsf34.isVersionRelatedLinksProvider)(provider.id)) : []);
const $9a1395f3f61267e3$export$d05d3d930a0084b6 = (0, $dGvGJ.createSelector)($9a1395f3f61267e3$export$e2eec4c83cc21e45, (remoteLinksData)=>remoteLinksData && remoteLinksData.remoteLinks ? remoteLinksData.remoteLinks.filter((link)=>!(0, $hsf34.isVersionRelatedLinksProvider)(link.providerId)) : []);
const $9a1395f3f61267e3$export$3a27e788a34d118a = (state)=>$9a1395f3f61267e3$export$ecbe7938e86d42ce(state).length;
const $9a1395f3f61267e3$export$5b94b4c138de532d = (state)=>$9a1395f3f61267e3$export$d05d3d930a0084b6(state).length;
const $9a1395f3f61267e3$export$a9e5760c0f6e9e80 = (0, $dGvGJ.createSelector)($9a1395f3f61267e3$export$e6b0ec1826afb24b, $9a1395f3f61267e3$export$8ccd5e71c4425c2e, $9a1395f3f61267e3$export$3a27e788a34d118a, $9a1395f3f61267e3$export$5b94b4c138de532d, (hasFeatureFlagsProviders, deploymentSummary, remoteLinksProvidersCount, remoteLinksCount)=>hasFeatureFlagsProviders || !!deploymentSummary || remoteLinksProvidersCount > 0 && remoteLinksCount > 0);
const $9a1395f3f61267e3$export$f1eb9bbb58c6a45e = (0, $dGvGJ.createSelector)($9a1395f3f61267e3$export$1c2601b8f2c0e608, $9a1395f3f61267e3$export$749121da3f993a0a, $9a1395f3f61267e3$export$8ccd5e71c4425c2e, $9a1395f3f61267e3$export$3a27e788a34d118a, $9a1395f3f61267e3$export$5b94b4c138de532d, $9a1395f3f61267e3$export$10e5ce2c721175a2, (panelHasValidFeatureFlagsProviders, panelHasFeatureFlags, deploymentSummary, remoteLinksProvidersCount, remoteLinksCount, hasDeploymentsInProject)=>panelHasValidFeatureFlagsProviders || panelHasFeatureFlags || !!deploymentSummary || !hasDeploymentsInProject || remoteLinksProvidersCount > 0 && remoteLinksCount > 0);
const $9a1395f3f61267e3$export$572c57f4fbd7354d = (state)=>state.releasesData && state.releasesData.deployments && state.releasesData.deployments.providers || [];

});
parcelRegister("hsf34", function(module, exports) {

$parcel$export(module.exports, "isVersionRelatedLinksProvider", () => $41a5d237cf4cfe89$export$d85eb3fb354ab222);

const $41a5d237cf4cfe89$export$d85eb3fb354ab222 = (id)=>id === (0, $1789cefc0ee00d21$export$a42a1a2fb6310bc7) || id === (0, $1789cefc0ee00d21$export$e68cad5334cc5b);

});


parcelRegister("786Ad", function(module, exports) {

$parcel$export(module.exports, "ReleasesFieldSummary", () => $c9c086d3d5264e38$export$c6b9afe7bf3faba6);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4HJKb = parcelRequire("4HJKb");

var $5km34 = parcelRequire("5km34");

var $k9tz2 = parcelRequire("k9tz2");

var $8rVVB = parcelRequire("8rVVB");

var $3Qghf = parcelRequire("3Qghf");

var $ixcTX = parcelRequire("ixcTX");

var $isBjD = parcelRequire("isBjD");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $k1L82 = parcelRequire("k1L82");

var $hjSnd = parcelRequire("hjSnd");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSD7y = parcelRequire("cSD7y");

var $j5LD3 = parcelRequire("j5LD3");
const $c9c086d3d5264e38$export$c6b9afe7bf3faba6 = (props)=>{
    const { hasDeployments: hasDeployments, hasFeatureFlagsProviders: hasFeatureFlagsProviders, createFlagLink: createFlagLink, connectFlagLink: connectFlagLink, hasFeatureFlags: hasFeatureFlags, issueContext: issueContext, deploymentSummary: deploymentSummary, remoteLinksCount: remoteLinksCount, disabledFeatureFlags: disabledFeatureFlags, disabledFeatureFlagsCnt: disabledFeatureFlagsCnt, enabledFeatureFlags: enabledFeatureFlags, enabledFeatureFlagsCnt: enabledFeatureFlagsCnt, detailsLink: detailsLink, rolloutSummary: rolloutSummary, totalFeatureFlags: totalFeatureFlags, shouldShowAppConfigContextPrompt: shouldShowAppConfigContextPrompt } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showDevDetailDialog: showDevDetailDialog } = (0, $4HJKb.useDevOpsDetailsDialogLoaderActions)(`devInfoPanelApp${issueContext.issueKey}`);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsAttributes = {
        issueStatusCategory: issueContext.issueStatusCategory,
        projectType: issueContext.projectType,
        projectId: issueContext.projectId,
        isSimplifiedProject: issueContext.isSimplifiedProject
    };
    const onShowDevDetailsDialog = (clickEvent, devInfoType)=>{
        clickEvent && clickEvent.preventDefault();
        const detailDialogAnalyticsAttributes = {
            ...analyticsAttributes,
            summaryType: devInfoType
        };
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'summaryItem'
        }), 'devpanelsummary', detailDialogAnalyticsAttributes);
        const panelItemType = (0, $k9tz2.toDetailDialogDataType)(devInfoType);
        showDevDetailDialog(// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        panelItemType, undefined, issueContext.issueKey, String(issueContext.issueId));
    };
    if (!deploymentSummary && !hasFeatureFlags && connectFlagLink == null && createFlagLink == null && remoteLinksCount === 0 && !shouldShowAppConfigContextPrompt) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSnd.FieldWrapper), {
        "data-testid": "development-summary-releases-field.ui.summary.actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9c086d3d5264e38$var$ReleasesGlanceFieldHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSnd.FieldHeadingTitle), null, formatMessage((0, $j5LD3.default).label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSnd.SideBySideField), null, (deploymentSummary || shouldShowAppConfigContextPrompt) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8rVVB.default), {
        issueContext: issueContext,
        summary: deploymentSummary,
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $5km34.SUMMARY_ITEM_DEPLOYMENT)),
        shouldShowAppConfigContextPrompt: shouldShowAppConfigContextPrompt,
        fieldHasOtherActions: createFlagLink != null || connectFlagLink != null || remoteLinksCount > 0
    }), hasFeatureFlags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ixcTX.default), {
        issueContext: issueContext,
        hasFeatureFlagsProviders: hasFeatureFlagsProviders,
        connectFeatureFlagTarget: connectFlagLink,
        createFeatureFlagTarget: createFlagLink,
        hasFeatureFlags: hasFeatureFlags,
        enabledFeatureFlags: enabledFeatureFlags,
        enabledFeatureFlagsCnt: enabledFeatureFlagsCnt,
        disabledFeatureFlags: disabledFeatureFlags,
        disabledFeatureFlagsCnt: disabledFeatureFlagsCnt,
        detailsLink: detailsLink,
        rolloutSummary: rolloutSummary,
        totalFeatureFlags: totalFeatureFlags,
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $5km34.SUMMARY_ITEM_FEATURE_FLAGS))
    }), remoteLinksCount !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isBjD.default), {
        issueContext: issueContext,
        remoteLinksCount: remoteLinksCount,
        onClick: (e)=>onShowDevDetailsDialog(e, (0, $5km34.SUMMARY_ITEM_REMOTE_LINKS))
    }), !hasFeatureFlags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ixcTX.default), {
        issueContext: issueContext,
        hasFeatureFlagsProviders: hasFeatureFlagsProviders,
        connectFeatureFlagTarget: connectFlagLink,
        createFeatureFlagTarget: createFlagLink,
        hasFeatureFlags: hasFeatureFlags,
        enabledFeatureFlags: enabledFeatureFlags,
        enabledFeatureFlagsCnt: enabledFeatureFlagsCnt,
        disabledFeatureFlags: disabledFeatureFlags,
        disabledFeatureFlagsCnt: disabledFeatureFlagsCnt,
        detailsLink: detailsLink,
        rolloutSummary: rolloutSummary,
        totalFeatureFlags: totalFeatureFlags,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClick: ()=>{}
    }), hasDeployments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "releasesGlanceDeploymentsLink",
        packageName: "jiraDevelopmentReleasesGlance",
        teamName: "nova"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Qghf.DeploymentsViewLink), null))));
};
const $c9c086d3d5264e38$var$labelColumnWidthForGrouping = 40.0;
const $c9c086d3d5264e38$var$fieldHeadingSideBySideCssStylesOld = null;
const $c9c086d3d5264e38$var$ReleasesGlanceFieldHeadingNew = ({ children: children })=>{
    const { userPreferredLayout: userPreferredLayout } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    const isWideViewLayout = userPreferredLayout === 'WIDE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $c9c086d3d5264e38$var$fieldHeadingSideBySideCssStylesNew,
            isWideViewLayout && $c9c086d3d5264e38$var$wideLayoutStyles
        ]
    }, children);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9c086d3d5264e38$var$ReleasesGlanceFieldHeadingOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _16jlkb7n _vchhusvi _1ul968cl _1bsbhwvj _ca0qu2gc _1e0c1txw _u5f3pxbi",
            !__cmplp.isCompact && "_p12f7l9q",
            __cmplp.className
        ])
    });
});
const $c9c086d3d5264e38$var$ReleasesGlanceFieldHeading = (0, $cSD7y.componentWithFG)('issue_view_field_config_edit', $c9c086d3d5264e38$var$ReleasesGlanceFieldHeadingNew, $c9c086d3d5264e38$var$ReleasesGlanceFieldHeadingOld);
const $c9c086d3d5264e38$var$fieldHeadingSideBySideCssStylesNew = (0, $8CUq3.xcss)({
    position: 'relative',
    boxSizing: 'border-box',
    minWidth: '120px',
    width: `${$c9c086d3d5264e38$var$labelColumnWidthForGrouping}%`,
    paddingTop: 'space.100',
    flex: '1 0 0%',
    display: 'flex',
    paddingRight: 'space.200'
});
const $c9c086d3d5264e38$var$wideLayoutStyles = (0, $8CUq3.xcss)({
    maxWidth: '148px',
    paddingRight: 'space.0'
});

});
parcelRegister("8rVVB", function(module, exports) {

$parcel$export(module.exports, "default", () => $86a92df4f8bfc4bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hPcwl = parcelRequire("hPcwl");

var $gwIPs = parcelRequire("gwIPs");


var $8YTUU = parcelRequire("8YTUU");

var $Iny5X = parcelRequire("Iny5X");

var $2Eelh = parcelRequire("2Eelh");

var $7rNJI = parcelRequire("7rNJI");

var $aWse0 = parcelRequire("aWse0");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $9j59B = parcelRequire("9j59B");

var $21aXC = parcelRequire("21aXC");
const $86a92df4f8bfc4bd$var$envTypeMessageKeys = {
    PRODUCTION: 'production',
    STAGING: 'staging',
    TESTING: 'testing',
    DEVELOPMENT: 'development',
    UNMAPPED: 'unmapped'
};
const $86a92df4f8bfc4bd$var$envTypeMessage = (key)=>// @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
    (0, $9j59B.default)[$86a92df4f8bfc4bd$var$envTypeMessageKeys[key] || $86a92df4f8bfc4bd$var$envTypeMessageKeys.UNMAPPED];
const $86a92df4f8bfc4bd$var$DeploymentsInner = ({ issueContext: issueContext, summary: summary, onClick: onClick, fieldHasOtherActions: fieldHasOtherActions = false, shouldShowAppConfigContextPrompt: shouldShowAppConfigContextPrompt = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (shouldShowAppConfigContextPrompt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eelh.AppConfigurationPromptSummary), {
        location: "RELEASES_PANEL",
        panelHasOtherPrompts: fieldHasOtherActions
    });
    if (!summary || !summary.state || !summary.environmentType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    const { state: state, environmentType: environmentType } = summary;
    const { issueStatusCategory: issueStatusCategory, projectType: projectType, projectId: projectId, issueKey: issueKey, issueId: issueId, isSimplifiedProject: isSimplifiedProject } = issueContext;
    const analyticsAttributes = {
        environmentType: environmentType,
        deploymentState: state,
        issueStatusCategory: issueStatusCategory,
        projectType: projectType,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject
    };
    const onSummaryItemClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'summaryItem'
        }), 'deploymentSummaryLink', analyticsAttributes);
        onClick();
    };
    const summaryItemComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        title: formatMessage($86a92df4f8bfc4bd$var$envTypeMessage(environmentType)),
        issueKey: issueKey,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hPcwl))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        }),
        onClick: onSummaryItemClick,
        secondaryData: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $21aXC.default), {
            state: state,
            environmentType: environmentType
        }),
        forceVisibleSecondary: true,
        showIconInPlainLink: true,
        "data-testid": "development-summary-deployment-releases-field.summary-item"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        sourceName: "deploymentSummary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Iny5X.default), {
        devInfoType: (0, $8YTUU.DevInfoTypes).DEPLOYMENT,
        issueId: issueId,
        customTrigger: summaryItemComponent,
        scopeId: `devInfoPanelApp${issueKey}`,
        placement: "bottom-end",
        offset: [
            -8,
            8
        ],
        zIndex: (0, $gwIPs.layers).modal,
        location: (0, $4ebd35f903e92a1a$export$76a449e52fa0e1e8)
    }));
};
const $86a92df4f8bfc4bd$var$Deployments = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "development-summary-deployment"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86a92df4f8bfc4bd$var$DeploymentsInner, props));
var $86a92df4f8bfc4bd$export$2e2bcd8739ae039 = $86a92df4f8bfc4bd$var$Deployments;

});
parcelRegister("hPcwl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da6815f1e303f26a4e473874c26eef5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfa0e970215956ee$var$_react = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cfa0e970215956ee$var$_cloudArrowUp = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("ePJ5X")));

var $cfa0e970215956ee$var$_upload = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("aPRJS")));
function $cfa0e970215956ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfa0e970215956ee$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $cfa0e970215956ee$var$_react.default.createElement($cfa0e970215956ee$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $cfa0e970215956ee$var$_upload.default
    }, props));
$cfa0e970215956ee$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $cfa0e970215956ee$var$_default = module.exports.default = $cfa0e970215956ee$var$CloudArrowUpIcon;

});
parcelRegister("ePJ5X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc8cf07db1d2dba$var$_react = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $acc8cf07db1d2dba$var$_baseNew = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $acc8cf07db1d2dba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc8cf07db1d2dba$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $acc8cf07db1d2dba$var$_react.default.createElement($acc8cf07db1d2dba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$acc8cf07db1d2dba$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $acc8cf07db1d2dba$var$_default = module.exports.default = $acc8cf07db1d2dba$var$CloudArrowUpIcon;

});

parcelRegister("aPRJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e385a40dadea6dc$var$_react = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7e385a40dadea6dc$var$_cloudArrowUp = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("ePJ5X")));
function $7e385a40dadea6dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7e385a40dadea6dc$var$UploadIcon = (props)=>/*#__PURE__*/ $7e385a40dadea6dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $7e385a40dadea6dc$var$_cloudArrowUp.default
    }));
$7e385a40dadea6dc$var$UploadIcon.displayName = 'UploadIcon';
var $7e385a40dadea6dc$var$_default = module.exports.default = $7e385a40dadea6dc$var$UploadIcon;

});


parcelRegister("9j59B", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4c5b39c4bc6454b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c4c5b39c4bc6454b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    production: {
        "id": "development-summary-deployment-releases-field.env-type.production",
        "defaultMessage": "Production"
    },
    staging: {
        "id": "development-summary-deployment-releases-field.env-type.staging",
        "defaultMessage": "Staging"
    },
    testing: {
        "id": "development-summary-deployment-releases-field.env-type.testing",
        "defaultMessage": "Testing"
    },
    development: {
        "id": "development-summary-deployment-releases-field.env-type.development",
        "defaultMessage": "Development"
    },
    unmapped: {
        "id": "development-summary-deployment-releases-field.env-type.unmapped",
        "defaultMessage": "Undefined environment"
    }
});

});

parcelRegister("21aXC", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdfe23f8bb6ed39d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $g0VRf = parcelRequire("g0VRf");

var $aWse0 = parcelRequire("aWse0");

var $gYpv9 = parcelRequire("gYpv9");

var $5gD09 = parcelRequire("5gD09");

var $bbwCu = parcelRequire("bbwCu");
const $cdfe23f8bb6ed39d$var$deploymentStates = {
    PENDING: {
        messageKey: 'pending'
    },
    IN_PROGRESS: {
        messageKey: 'inProgress'
    },
    SUCCESSFUL: {
        messageKey: 'successful'
    },
    FAILED: {
        messageKey: 'failed'
    },
    ROLLED_BACK: {
        messageKey: 'rolledBack'
    },
    CANCELLED: {
        messageKey: 'cancelled'
    },
    UNKNOWN: {
        messageKey: 'unknown'
    }
};
const $cdfe23f8bb6ed39d$var$stateMessage = (key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ unknown: MessageDescriptorV2; cancelled: MessageDescriptorV2; rolledBack: MessageDescriptorV2; failed: MessageDescriptorV2; successful: MessageDescriptorV2; inProgress: MessageDescriptorV2; pending: MessageDescriptorV2; }'. | TS2532 - Object is possibly 'undefined'.
    (0, $bbwCu.default)[($cdfe23f8bb6ed39d$var$deploymentStates[key] || $cdfe23f8bb6ed39d$var$deploymentStates.UNKNOWN).messageKey];
const $cdfe23f8bb6ed39d$var$getDeploymentIconState = (state, environmentType)=>{
    switch(state){
        case (0, $g0VRf.deploymentStates).SUCCESSFUL:
            return environmentType === (0, $g0VRf.deploymentEnvironmentTypes).PRODUCTION ? (0, $5gD09.DeploymentStateOptions).SUCCESSFUL : (0, $5gD09.DeploymentStateOptions).SUCCESSFULNONPRODUCTION;
        default:
            return state;
    }
};
const $cdfe23f8bb6ed39d$var$getDeploymentIcon = (state, environmentType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYpv9.DeploymentIcons), {
        deploymentState: $cdfe23f8bb6ed39d$var$getDeploymentIconState(state, environmentType),
        size: "medium"
    });
const $cdfe23f8bb6ed39d$var$Status = ({ state: state, environmentType: environmentType })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    if (!state) return null;
    const StatusIcon = $cdfe23f8bb6ed39d$var$getDeploymentIcon(state, environmentType ?? (0, $g0VRf.deploymentEnvironmentTypes).UNMAPPED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage($cdfe23f8bb6ed39d$var$stateMessage(state))
    }, StatusIcon);
};
var $cdfe23f8bb6ed39d$export$2e2bcd8739ae039 = $cdfe23f8bb6ed39d$var$Status;

});
parcelRegister("bbwCu", function(module, exports) {

$parcel$export(module.exports, "default", () => $059514e980d4abf6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $059514e980d4abf6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pending: {
        "id": "development-summary-deployment-releases-field.status.pending",
        "defaultMessage": "Pending"
    },
    inProgress: {
        "id": "development-summary-deployment-releases-field.status.in-progress",
        "defaultMessage": "In progress"
    },
    successful: {
        "id": "development-summary-deployment-releases-field.status.successful",
        "defaultMessage": "Successful"
    },
    failed: {
        "id": "development-summary-deployment-releases-field.status.failed",
        "defaultMessage": "Failed"
    },
    rolledBack: {
        "id": "development-summary-deployment-releases-field.status.rolled-back",
        "defaultMessage": "Rolled back"
    },
    cancelled: {
        "id": "development-summary-deployment-releases-field.status.cancelled",
        "defaultMessage": "Canceled"
    },
    unknown: {
        "id": "development-summary-deployment-releases-field.status.unknown",
        "defaultMessage": "Unknown"
    }
});

});



parcelRegister("3Qghf", function(module, exports) {

$parcel$export(module.exports, "DeploymentsViewLink", () => $c3d6a31f7b91479a$export$ecea6a623b55b991);

var $5uXOq = parcelRequire("5uXOq");

var $9Xmvg = parcelRequire("9Xmvg");

var $7rNJI = parcelRequire("7rNJI");

var $koVbs = parcelRequire("koVbs");

var $43qGj = parcelRequire("43qGj");

var $ezRTW = parcelRequire("ezRTW");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dAfqg = parcelRequire("dAfqg");

var $doZTA = parcelRequire("doZTA");

var $dX3Lk = parcelRequire("dX3Lk");
const $c3d6a31f7b91479a$var$DeploymentsViewLinkSummaryItem = ({ href: href, routerLinkConfig: routerLinkConfig })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // Memoizing to prevent SummaryItem animations firing on hover caused by react-resource-router prefetch triggering a re-render
    const secondaryData = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        title: formatMessage((0, $dX3Lk.default).deploymentsLink),
        linkFormatting: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Xmvg))), {
            spacing: "spacious",
            label: ""
        }),
        href: href,
        routerLinkConfig: routerLinkConfig,
        secondaryData: secondaryData,
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'releasesGlanceDeploymentsViewLink');
        },
        "data-testid": "development-summary-deployments-view-link.summary-item"
    });
};
const $c3d6a31f7b91479a$var$ClassicDeploymentsViewLink = ({ projectKey: projectKey })=>{
    const route = (0, $6jY6G.useRouteByName)('software-deployments-classic');
    // check if deployments jira feature is enabled in CMP
    const { data: data, loading: loading } = (0, $ezRTW.useFeatures)();
    if (loading || !data?.hasDeployments) return null;
    return route !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3d6a31f7b91479a$var$DeploymentsViewLinkSummaryItem, {
        routerLinkConfig: {
            route: route,
            prefetch: 'hover',
            params: {
                projectKey: projectKey
            }
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3d6a31f7b91479a$var$DeploymentsViewLinkSummaryItem, {
        href: `/jira/software/c/projects/${projectKey}/deployments`
    });
};
const $c3d6a31f7b91479a$var$NextGenDeploymentsViewLink = ({ projectKey: projectKey })=>{
    const route = (0, $6jY6G.useRouteByName)('software-deployments');
    // check if deployments jira feature is enabled in TMP
    const { data: data, loading: loading } = (0, $43qGj.useFeatures)();
    if (loading || !data?.hasDeployments) return null;
    return route !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3d6a31f7b91479a$var$DeploymentsViewLinkSummaryItem, {
        routerLinkConfig: {
            route: route,
            prefetch: 'hover',
            params: {
                projectKey: projectKey
            }
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3d6a31f7b91479a$var$DeploymentsViewLinkSummaryItem, {
        href: `/jira/software/projects/${projectKey}/deployments`
    });
};
const $c3d6a31f7b91479a$export$ecea6a623b55b991 = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    // Check if user is currently already on the Deployment page, hence button display not required
    const [{ route: route }] = (0, $doZTA.useRouter)();
    const routeName = route.name;
    const isOnDeploymentsPage = routeName === 'software-deployments' || routeName === 'software-deployments-classic';
    if (isOnDeploymentsPage || project == null) return null;
    return project.simplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3d6a31f7b91479a$var$NextGenDeploymentsViewLink, {
        projectKey: project.projectKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3d6a31f7b91479a$var$ClassicDeploymentsViewLink, {
        projectKey: project.projectKey
    });
};

});
parcelRegister("9Xmvg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2acc08ab6395d499b2798249d78c49fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73fb14674561f421$var$_react = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $73fb14674561f421$var$_arrowUpRight = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("3sGLB")));

var $73fb14674561f421$var$_open = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("1FouZ")));
function $73fb14674561f421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpRightIcon.
 * This component is ArrowUpRightIcon, with `UNSAFE_fallbackIcon` set to "OpenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73fb14674561f421$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $73fb14674561f421$var$_react.default.createElement($73fb14674561f421$var$_arrowUpRight.default, Object.assign({
        LEGACY_fallbackIcon: $73fb14674561f421$var$_open.default
    }, props));
$73fb14674561f421$var$ArrowUpRightIcon.Name = 'ArrowUpRightIconMigration';
var $73fb14674561f421$var$_default = module.exports.default = $73fb14674561f421$var$ArrowUpRightIcon;

});
parcelRegister("3sGLB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2855293259c2814d$var$_react = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2855293259c2814d$var$_baseNew = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2855293259c2814d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2855293259c2814d$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $2855293259c2814d$var$_react.default.createElement($2855293259c2814d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$2855293259c2814d$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $2855293259c2814d$var$_default = module.exports.default = $2855293259c2814d$var$ArrowUpRightIcon;

});

parcelRegister("1FouZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $136c9fbd1122fba5$var$_react = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $136c9fbd1122fba5$var$_arrowUpRight = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("3sGLB")));
function $136c9fbd1122fba5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $136c9fbd1122fba5$var$OpenIcon = (props)=>/*#__PURE__*/ $136c9fbd1122fba5$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props, {
        newIcon: $136c9fbd1122fba5$var$_arrowUpRight.default
    }));
$136c9fbd1122fba5$var$OpenIcon.displayName = 'OpenIcon';
var $136c9fbd1122fba5$var$_default = module.exports.default = $136c9fbd1122fba5$var$OpenIcon;

});


parcelRegister("43qGj", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $64d4caaed133b77d$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $4bPSV = parcelRequire("4bPSV");

var $hDSPU = parcelRequire("hDSPU");

var $iHqA4 = parcelRequire("iHqA4");

var $j8sa8 = parcelRequire("j8sa8");
const $64d4caaed133b77d$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $hDSPU.useSidebarFeatureToggled)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $4bPSV.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $5uXOq.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $iHqA4.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("4bPSV", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4795c1c4367ea315$export$9df5fa0a366163d2);

var $6s1PB = parcelRequire("6s1PB");
const $4795c1c4367ea315$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, aiInfo: aiInfo, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasList: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasForms: (0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasSummaryPage: hasSummaryPage,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
    };
};

});

parcelRegister("hDSPU", function(module, exports) {

$parcel$export(module.exports, "useFeature", () => $605ea180d8f833cc$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $605ea180d8f833cc$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $605ea180d8f833cc$export$9eef668f94562feb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6wyfe = parcelRequire("6wyfe");
const $605ea180d8f833cc$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $605ea180d8f833cc$var$store = (0, $iXqE5.createStore)({
    name: 'feature-toggle',
    initialState: $605ea180d8f833cc$var$initialState,
    actions: $6wyfe.actions
});
const $605ea180d8f833cc$export$fc97652867e5867e = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store);
const $605ea180d8f833cc$export$207b461610a7fca6 = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $605ea180d8f833cc$export$e7699ed698eeb9ec = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $605ea180d8f833cc$export$9eef668f94562feb = (0, $3sQ5x.createHook)($605ea180d8f833cc$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("6wyfe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $158a47dbcbb0832b$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");

var $3Jf4N = parcelRequire("3Jf4N");

var $czzsL = parcelRequire("czzsL");

var $iZZTd = parcelRequire("iZZTd");

var $ke207 = parcelRequire("ke207");
const $158a47dbcbb0832b$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $158a47dbcbb0832b$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $iZZTd.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $czzsL.filterAndSort)(data);
                (0, $czzsL.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $158a47dbcbb0832b$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const featureMap = (0, $3Jf4N.getFeatureMap)({
            isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
        });
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $158a47dbcbb0832b$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $3Jf4N.getFeatureMap)();
        if ((0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $3Jf4N.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $czzsL.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $ke207.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $158a47dbcbb0832b$export$e324594224ef24da = {
    fetchFeatures: $158a47dbcbb0832b$var$fetchFeatures,
    updateFeature: $158a47dbcbb0832b$var$updateFeature,
    syncFeatures: $158a47dbcbb0832b$var$syncFeatures,
    clearSiderbarFeatureToggled: $158a47dbcbb0832b$var$clearSiderbarFeatureToggled
};

});
parcelRegister("3Jf4N", function(module, exports) {

$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $d07f845012e39eac$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $d07f845012e39eac$export$143e1d685830adbe);
$parcel$export(module.exports, "listFeature", () => $d07f845012e39eac$export$4ddfd7a9f5527982);
$parcel$export(module.exports, "getFeatureMap", () => $d07f845012e39eac$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $d07f845012e39eac$export$f5e4c120ac01b615);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8QpSo = parcelRequire("8QpSo");

var $QasRB = parcelRequire("QasRB");

var $dME4E = parcelRequire("dME4E");

var $aZ5rg = parcelRequire("aZ5rg");

var $lfDf7 = parcelRequire("lfDf7");

var $eQfWH = parcelRequire("eQfWH");

var $k2Gga = parcelRequire("k2Gga");
const $d07f845012e39eac$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $d07f845012e39eac$export$143e1d685830adbe = 'manage-feature-menu-item';
const $d07f845012e39eac$export$4ddfd7a9f5527982 = {
    'jsw.agility.list_view': {
        descriptionKey: 'listDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ5rg))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasList',
        order: 35,
        redirectOn: [
            'software-list'
        ]
    }
};
const $d07f845012e39eac$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2Gga))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            'software-timeline',
            'software-roadmap'
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QasRB))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            'software-backlog'
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            'software-issue-navigator',
            'issue'
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $d07f845012e39eac$export$6ac50cf33852adb5 = (0, $8QpSo.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled, isListViewEnabled: isListViewEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2Gga))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                'software-timeline',
                'software-roadmap'
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QasRB))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                'software-backlog'
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
                    spacing: "spacious",
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    'software-issue-navigator',
                    'issue'
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                'project-pages'
            ]
        },
        ...isListViewEnabled && $d07f845012e39eac$export$4ddfd7a9f5527982
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $d07f845012e39eac$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});

parcelRegister("czzsL", function(module, exports) {

$parcel$export(module.exports, "filterAndSort", () => $0a04151ee5a00965$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $0a04151ee5a00965$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $0a04151ee5a00965$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $0a04151ee5a00965$export$5da1e8c5ba5c0dc2);

var $hqTkp = parcelRequire("hqTkp");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $3Jf4N = parcelRequire("3Jf4N");
const $0a04151ee5a00965$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $0a04151ee5a00965$export$d0e0de50c701304c = (features)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $0a04151ee5a00965$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $0a04151ee5a00965$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $0a04151ee5a00965$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    if (filteredFeatures.length < Object.keys(featureMap).length) {
        const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
        (0, $jcw0u.default)({
            error: new Error("Some feature keys don't match . Please check API response"),
            meta: {
                ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                id: 'unmatchFeatureKey'
            },
            attributes: {
                unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
            }
        });
    }
};

});

parcelRegister("iZZTd", function(module, exports) {

$parcel$export(module.exports, "getBoardFeatures", () => $140b4a0769fd2090$export$c20100b185d41ab0);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $140b4a0769fd2090$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $eusud.performGetRequest)((0, $8djOx.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("8djOx", function(module, exports) {

$parcel$export(module.exports, "getBoardFeaturesUrl", () => $45a3789113fa4e8b$export$3f9939d302766b52);
const $45a3789113fa4e8b$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("ke207", function(module, exports) {

$parcel$export(module.exports, "updateBoardFeature", () => $1ce9149bd154bcf9$export$61f6bbb745b3a3);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $1ce9149bd154bcf9$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $eusud.performPutRequest)((0, $8djOx.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("iHqA4", function(module, exports) {

$parcel$export(module.exports, "useClearSidebarToggled", () => $b80f211a69d994c6$export$2946f555c6f48127);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $1J3t1 = parcelRequire("1J3t1");

var $1XJ20 = parcelRequire("1XJ20");

var $hDSPU = parcelRequire("hDSPU");

var $j8sa8 = parcelRequire("j8sa8");
const $b80f211a69d994c6$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $hDSPU.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $5uXOq.useRef)(false);
    const previousData = (0, $1XJ20.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $5uXOq.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $5uXOq.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("j8sa8", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $d568e02a383436d9$export$7deca16ba2d9eb74);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $dkqym = parcelRequire("dkqym");
const $d568e02a383436d9$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    return isJSW && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("dkqym", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $61794ef454831b86$export$9df3a539e50a284b);

var $9OXo1 = parcelRequire("9OXo1");
const $61794ef454831b86$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});




parcelRegister("ezRTW", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $0396841ba6adfb11$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $hRzej = parcelRequire("hRzej");
const $0396841ba6adfb11$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $hRzej.extractData)(data), [
        data
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("hRzej", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $ec1c13e67ecdf44f$export$9df5fa0a366163d2);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $ec1c13e67ecdf44f$export$9df5fa0a366163d2 = (data)=>{
    const { aiInfo: aiInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCalendar: hasCalendar, hasCode: hasCode, hasComponents: hasComponents, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasForms: hasForms, hasGoals: hasGoals, hasIncidents: hasIncidents, hasIssues: hasIssues, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasReports: hasReports, hasRequests: hasRequests, hasRoadmap: hasRoadmap, hasSecurity: hasSecurity, hasSummaryPage: hasSummaryPage, permissionInfo: permissionInfo, hasArchivedIssues: hasArchivedIssues = false } = data;
    const isProjectOrSiteAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const hasEditWorkflowPermissions = permissionInfo.projectPermissionsQueried.EDIT_WORKFLOW === true;
    const hasEditIssueLayoutPermissions = permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    const hasManageVersionsPermissions = permissionInfo.projectPermissionsQueried.MANAGE_VERSIONS === true;
    const hasSettings = (0, $4R6GH.fg)('vmc-11-manage-versions-permission') ? isProjectOrSiteAdmin || hasEditWorkflowPermissions || hasEditIssueLayoutPermissions || hasManageVersionsPermissions : isProjectOrSiteAdmin || hasEditWorkflowPermissions || hasEditIssueLayoutPermissions;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasCalendar: hasCalendar,
        hasCode: hasCode,
        hasComponents: hasComponents,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasForms: (0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasGoals: hasGoals,
        hasIncidents: hasIncidents,
        hasIssues: hasIssues,
        hasList: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasOpsgenieSchedule: hasOpsgenieSchedule,
        hasPages: hasPages,
        hasReleases: hasReleases,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasRoadmap: hasRoadmap,
        hasSecurity: hasSecurity,
        hasSettings: hasSettings,
        hasShortcutsAdd: isProjectOrSiteAdmin,
        hasSummaryPage: hasSummaryPage
    };
};

});


parcelRegister("dX3Lk", function(module, exports) {

$parcel$export(module.exports, "default", () => $57c3d94ff049da36$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $57c3d94ff049da36$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deploymentsLink: {
        "id": "development-summary-deployments-view-link.deployments-link",
        "defaultMessage": "See all deployments"
    }
});

});


parcelRegister("ixcTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0bbf4ee34b939bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lboNj = parcelRequire("lboNj");

var $afSA5 = parcelRequire("afSA5");
const $a0bbf4ee34b939bf$var$FeatureFlags = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { hasFeatureFlagsProviders: hasFeatureFlagsProviders, hasFeatureFlags: hasFeatureFlags, onClick: onClick, detailsLink: detailsLink, disabledFeatureFlags: disabledFeatureFlags, disabledFeatureFlagsCnt: disabledFeatureFlagsCnt, enabledFeatureFlags: enabledFeatureFlags, enabledFeatureFlagsCnt: enabledFeatureFlagsCnt, issueContext: issueContext, rolloutSummary: rolloutSummary, connectFeatureFlagTarget: connectFeatureFlagTarget, createFeatureFlagTarget: createFeatureFlagTarget, totalFeatureFlags: totalFeatureFlags } = props;
    const onLinkClicked = (0, $5uXOq.useCallback)((attributes, onClickAction)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'clickFeatureFlagsSummaryLink', attributes);
        if (onClickAction) onClickAction();
    }, [
        createAnalyticsEvent
    ]);
    const { issueStatusCategory: issueStatusCategory, projectType: projectType, projectId: projectId, isSimplifiedProject: isSimplifiedProject } = issueContext;
    const analyticsAttributes = {
        issueStatusCategory: issueStatusCategory,
        projectType: projectType,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject,
        totalFeatureFlags: totalFeatureFlags
    };
    if (hasFeatureFlagsProviders) {
        if (hasFeatureFlags) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
            sourceName: "viewFeatureFlagSummary"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $afSA5.default), {
            onClick: ()=>onLinkClicked(analyticsAttributes, onClick),
            connectFeatureFlagTarget: connectFeatureFlagTarget,
            createFeatureFlagTarget: createFeatureFlagTarget,
            detailsLink: detailsLink,
            disabledFeatureFlags: disabledFeatureFlags,
            disabledFeatureFlagsCnt: disabledFeatureFlagsCnt,
            enabledFeatureFlags: enabledFeatureFlags,
            enabledFeatureFlagsCnt: enabledFeatureFlagsCnt,
            rolloutSummary: rolloutSummary,
            totalFeatureFlags: totalFeatureFlags
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lboNj.default), {
            connectFeatureFlagTarget: connectFeatureFlagTarget,
            createFeatureFlagTarget: createFeatureFlagTarget
        });
    }
    return null;
};
$a0bbf4ee34b939bf$var$FeatureFlags.defaultProps = {
    hasFeatureFlagsProviders: false,
    hasFeatureFlags: false
};
var $a0bbf4ee34b939bf$export$2e2bcd8739ae039 = $a0bbf4ee34b939bf$var$FeatureFlags;

});
parcelRegister("lboNj", function(module, exports) {

$parcel$export(module.exports, "default", () => $570ae9070fae410c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kEVMo = parcelRequire("kEVMo");

var $2X3CJ = parcelRequire("2X3CJ");

var $7rNJI = parcelRequire("7rNJI");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");


var $lTyHa = parcelRequire("lTyHa");

var $7TFz3 = parcelRequire("7TFz3");
const $570ae9070fae410c$export$939aea659a72e70b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2X3CJ))), {
        spacing: "spacious",
        label: "Flag Icon"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        icon: icon,
        disabled: true,
        title: formatMessage((0, $7TFz3.default).emptyState),
        "data-testid": (0, $e612416f854aa8b0$export$1b3d3e6f99fd9330)
    });
};


const $570ae9070fae410c$var$ConditionalFeatureFlagActionDropdown = (parcelRequire("htcLP")).default;
const $570ae9070fae410c$var$AddFeatureFlagSummaryItem = ({ connectFeatureFlagTarget: connectFeatureFlagTarget, createFeatureFlagTarget: createFeatureFlagTarget })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const downChevron = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
            testId: "development-summary-feature-flag.ui.empty.chevron-down-icon",
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $7TFz3.default).featureFlagActionDropdownIconLabel),
            size: "small"
        }), [
        formatMessage
    ]);
    const commonSummaryItemProps = {
        title: formatMessage((0, $7TFz3.default).addFeatureFlagTitle),
        linkFormatting: true,
        icon: (0, $lTyHa.AddFeatureFlagIcon)
    };
    return connectFeatureFlagTarget != null && connectFeatureFlagTarget !== undefined || createFeatureFlagTarget != null && createFeatureFlagTarget !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        key: "viewed button createDevAction",
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "createDevAction",
        attributes: {
            inline: false,
            summaryItemType: 'commit'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($570ae9070fae410c$var$ConditionalFeatureFlagActionDropdown, {
        getDropdownTrigger: ({ ref: ref, onClick: onClick, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
                secondaryData: downChevron,
                reference: ref,
                ...commonSummaryItemProps,
                ...props,
                onClick: ()=>{
                    onClick();
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createDevAction', {
                        inline: false,
                        summaryItemType: 'commit'
                    });
                },
                "data-testid": (0, $e612416f854aa8b0$export$1b3d3e6f99fd9330)
            }),
        connectFeatureFlagTarget: connectFeatureFlagTarget,
        createFeatureFlagTarget: createFeatureFlagTarget
    })) : null;
};
var $570ae9070fae410c$export$2e2bcd8739ae039 = $570ae9070fae410c$var$AddFeatureFlagSummaryItem;

});
const $e612416f854aa8b0$export$1b3d3e6f99fd9330 = 'development-summary-feature-flag.ui.summary-item';

parcelRegister("lTyHa", function(module, exports) {

$parcel$export(module.exports, "AddFeatureFlagIcon", () => $40df57db2b34ab79$export$c3b91b420ace5d12);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $faod6 = parcelRequire("faod6");

var $2X3CJ = parcelRequire("2X3CJ");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40df57db2b34ab79$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_s7n4nkob",
            __cmplp.className
        ])
    });
});
const $40df57db2b34ab79$export$ade1044df21e8c42 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40df57db2b34ab79$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2X3CJ))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));
const $40df57db2b34ab79$export$c3b91b420ace5d12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40df57db2b34ab79$var$IconWrapper, {
    "aria-hidden": true
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
}));

});

parcelRegister("7TFz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9917d69baf5fc44$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b9917d69baf5fc44$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyState: {
        "id": "development-summary-feature-flag.empty.empty-state",
        "defaultMessage": "Feature Flag"
    },
    addFeatureFlagTitle: {
        "id": "development-summary-feature-flag.empty.add-feature-flag-title",
        "defaultMessage": "Add feature flag"
    },
    featureFlagActionDropdownIconLabel: {
        "id": "development-summary-feature-flag.empty.feature-flag-action-dropdown-icon-label",
        "defaultMessage": "Open feature flag action dropdown"
    },
    tooltip: {
        "id": "development-summary-feature-flag.empty.tooltip",
        "defaultMessage": "Open feature flag"
    }
});

});

parcelRegister("htcLP", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
    return parcelRequire('bUXkY');
}, function() {
    return parcelRequire('2FMc9');
});

});


parcelRegister("afSA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a7d3cff7f425e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2X3CJ = parcelRequire("2X3CJ");

var $7rNJI = parcelRequire("7rNJI");

var $koVbs = parcelRequire("koVbs");

var $3FMMO = parcelRequire("3FMMO");

var $725Jr = parcelRequire("725Jr");

var $2g4Po = parcelRequire("2g4Po");

var $7ggOq = parcelRequire("7ggOq");
const $80a7d3cff7f425e0$var$FEATURE_FLAG_SUMMARY_ITEM_TEST_ID = 'development-summary-feature-flag.ui.summary-item';


const $80a7d3cff7f425e0$var$ConditionalFeatureFlagActionDropdown = (parcelRequire("htcLP")).default;
const $80a7d3cff7f425e0$export$b141efd0b0fb9174 = (previousProps, nextProps)=>nextProps.enabledFeatureFlagsCnt === previousProps.enabledFeatureFlagsCnt && nextProps.disabledFeatureFlagsCnt === previousProps.disabledFeatureFlagsCnt && nextProps.detailsLink === previousProps.detailsLink;
const $80a7d3cff7f425e0$var$FeatureFlagSummaryItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ connectFeatureFlagTarget: connectFeatureFlagTarget, createFeatureFlagTarget: createFeatureFlagTarget, detailsLink: detailsLink, disabledFeatureFlags: disabledFeatureFlags, disabledFeatureFlagsCnt: disabledFeatureFlagsCnt, enabledFeatureFlags: enabledFeatureFlags, enabledFeatureFlagsCnt: enabledFeatureFlagsCnt, onClick: onClick, rolloutSummary: rolloutSummary, totalFeatureFlags: totalFeatureFlags })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [shouldForceVisibleSecondary, setShouldForceVisibleSecondary] = (0, $5uXOq.useState)(false);
    const title = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $725Jr.default), {
            enabledFeatureFlags: enabledFeatureFlags,
            disabledFeatureFlags: disabledFeatureFlags
        }), [
        enabledFeatureFlags,
        disabledFeatureFlags
    ]);
    const secondaryData = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ggOq.default), {
            hasFeatureFlags: disabledFeatureFlagsCnt + enabledFeatureFlagsCnt > 0,
            disabledFeatureFlagsCnt: disabledFeatureFlagsCnt,
            enabledFeatureFlagsCnt: enabledFeatureFlagsCnt,
            rolloutSummary: rolloutSummary
        }), [
        disabledFeatureFlagsCnt,
        enabledFeatureFlagsCnt,
        rolloutSummary
    ]);
    return(// TODO - Apply the same solution as the one being designed for relative date in commits
    // to prevent the secondaryData overlapping the title onHover.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        title: title,
        secondaryData: secondaryData,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2X3CJ))), {
            label: "Flag Icon",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        showIconInPlainLink: true,
        itemType: "featureFlag",
        itemCount: totalFeatureFlags,
        oneClickUrl: detailsLink,
        oneClickToolTipContent: formatMessage((0, $2g4Po.default).tooltip),
        secondaryHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80a7d3cff7f425e0$var$ConditionalFeatureFlagActionDropdown, {
            connectFeatureFlagTarget: connectFeatureFlagTarget,
            createFeatureFlagTarget: createFeatureFlagTarget,
            getDropdownTrigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FMMO.default), props),
            onOpenDropdown: ({ isOpen: isOpen })=>{
                setShouldForceVisibleSecondary(isOpen);
            }
        }),
        forceVisibleSecondary: shouldForceVisibleSecondary,
        "data-testid": $80a7d3cff7f425e0$var$FEATURE_FLAG_SUMMARY_ITEM_TEST_ID
    }));
}, $80a7d3cff7f425e0$export$b141efd0b0fb9174);
var $80a7d3cff7f425e0$export$2e2bcd8739ae039 = $80a7d3cff7f425e0$var$FeatureFlagSummaryItem;

});
parcelRegister("3FMMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a93eb2a74605011$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $99M5v = parcelRequire("99M5v");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");

var $bnmCZ = parcelRequire("bnmCZ");
const $8a93eb2a74605011$var$FeatureFlagActionIconButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClickProp, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = formatMessage((0, $bnmCZ.default).tooltipContent);
    const onClick = (e, analyticsEvent)=>{
        onClickProp && onClickProp();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createDevAction', {
            inline: true,
            summaryItemType: 'feature-flag'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "createDevAction",
        attributes: {
            inline: true,
            summaryItemType: 'feature-flag'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: ref,
        ...props,
        appearance: "subtle",
        testId: "development-summary-feature-flag.ui.summary.feature-flag-action-icon-button.button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            LEGACY_size: "small",
            label: tooltipContent
        }),
        onClick: onClick
    }));
});
var $8a93eb2a74605011$export$2e2bcd8739ae039 = $8a93eb2a74605011$var$FeatureFlagActionIconButton;

});
parcelRegister("bnmCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5956febd07bea83$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f5956febd07bea83$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltipContent: {
        "id": "development-summary-feature-flag.summary.feature-flag-action-icon-button.tooltip-content",
        "defaultMessage": "Create/Connect Feature Flag"
    }
});

});


parcelRegister("725Jr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a053bfcedea339eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $9zvqX = parcelRequire("9zvqX");

var $vQ9FL = parcelRequire("vQ9FL");
const $a053bfcedea339eb$var$FlagsDescription = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { enabledFeatureFlags: enabledFeatureFlags, disabledFeatureFlags: disabledFeatureFlags } = props;
    const hasFlags = ()=>enabledFeatureFlags.length + disabledFeatureFlags.length > 0;
    const Description = (0, $5uXOq.useMemo)(()=>{
        let labelText;
        const flagsCnt = enabledFeatureFlags.length + disabledFeatureFlags.length;
        if (flagsCnt === 1) labelText = enabledFeatureFlags.length === 1 ? enabledFeatureFlags[0] : disabledFeatureFlags[0];
        else labelText = formatMessage((0, $9zvqX.default).many, {
            flagsCnt: flagsCnt
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, labelText);
    }, [
        disabledFeatureFlags,
        enabledFeatureFlags,
        formatMessage
    ]);
    if (!hasFlags()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vQ9FL.default), {
        enabledFeatureFlags: enabledFeatureFlags,
        disabledFeatureFlags: disabledFeatureFlags
    }, Description);
};
var $a053bfcedea339eb$export$2e2bcd8739ae039 = $a053bfcedea339eb$var$FlagsDescription;

});
parcelRegister("9zvqX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac9ee56b207f4e35$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ac9ee56b207f4e35$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    many: {
        "id": "development-summary-feature-flag.summary.flags-description.many",
        "defaultMessage": "{flagsCnt} feature flags"
    }
});

});

parcelRegister("vQ9FL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd3922117b1baf34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $gB1mI = parcelRequire("gB1mI");
class $bd3922117b1baf34$var$ContentLineKeyGenerator {
    next() {
        this.cnt += 1;
        return `rp-cnt-tt-${this.cnt}`;
    }
    constructor(){
        this.cnt = 0;
    }
}
const $bd3922117b1baf34$var$ContentTooltip = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const TooltipContentHeader = (0, $5uXOq.useMemo)(()=>{
        const { enabledFeatureFlags: enabledFeatureFlags, disabledFeatureFlags: disabledFeatureFlags } = props;
        const keyGenerator = new $bd3922117b1baf34$var$ContentLineKeyGenerator();
        const contentLines = enabledFeatureFlags.concat(disabledFeatureFlags).sort().slice(0, 3).map((featureFlagName)=>featureFlagName);
        return contentLines.map((contentLine)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                key: keyGenerator.next()
            }, contentLine));
    }, [
        props
    ]);
    const TooltipFooter = (0, $5uXOq.useMemo)(()=>{
        const { enabledFeatureFlags: enabledFeatureFlags, disabledFeatureFlags: disabledFeatureFlags } = props;
        const remainingFeatureFlags = enabledFeatureFlags.length + disabledFeatureFlags.length - 3;
        if (remainingFeatureFlags > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $gB1mI.default).moreFeatureFlags, {
            featureFlagsCnt: remainingFeatureFlags
        }));
        if (remainingFeatureFlags === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $gB1mI.default).oneMoreFeatureFlag));
        return null;
    }, [
        formatMessage,
        props
    ]);
    const TooltipContent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, TooltipContentHeader, TooltipFooter), [
        TooltipContentHeader,
        TooltipFooter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: TooltipContent,
        tag: "span"
    }, props.children);
};
var $bd3922117b1baf34$export$2e2bcd8739ae039 = $bd3922117b1baf34$var$ContentTooltip;

});
parcelRegister("gB1mI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2a9c1fb48686504$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f2a9c1fb48686504$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    oneMoreFeatureFlag: {
        "id": "development-summary-feature-flag.summary.flags-description.tooltip.one-more-feature-flag",
        "defaultMessage": "(+1 more flag)"
    },
    moreFeatureFlags: {
        "id": "development-summary-feature-flag.summary.flags-description.tooltip.more-feature-flags",
        "defaultMessage": "(+{featureFlagsCnt} more flag)"
    }
});

});



parcelRegister("2g4Po", function(module, exports) {

$parcel$export(module.exports, "default", () => $13fd6387e233e0cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $13fd6387e233e0cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyState: {
        "id": "development-summary-feature-flag.summary.empty-state",
        "defaultMessage": "Feature Flag"
    },
    addFeatureFlagTitle: {
        "id": "development-summary-feature-flag.summary.add-feature-flag-title",
        "defaultMessage": "Add feature flag"
    },
    featureFlagActionDropdownIconLabel: {
        "id": "development-summary-feature-flag.summary.feature-flag-action-dropdown-icon-label",
        "defaultMessage": "Open feature flag action dropdown"
    },
    tooltip: {
        "id": "development-summary-feature-flag.summary.tooltip",
        "defaultMessage": "Open feature flag"
    }
});

});

parcelRegister("7ggOq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a3f58c223b7e902$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $iME2P = parcelRequire("iME2P");
const $3a3f58c223b7e902$var$lozengeAppearance = (isOn)=>isOn ? 'success' : 'default';
const $3a3f58c223b7e902$var$lozengeValue = (isOn)=>isOn ? 'on' : 'off';
function $3a3f58c223b7e902$export$2e2bcd8739ae039(props) {
    const { disabledFeatureFlagsCnt: disabledFeatureFlagsCnt, enabledFeatureFlagsCnt: enabledFeatureFlagsCnt, hasFeatureFlags: hasFeatureFlags, rolloutSummary: rolloutSummary } = props;
    const isOn = enabledFeatureFlagsCnt > 0;
    return hasFeatureFlags ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iME2P.default), {
        disabledFeatureFlagsCnt: disabledFeatureFlagsCnt,
        enabledFeatureFlagsCnt: enabledFeatureFlagsCnt,
        rolloutSummary: rolloutSummary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: $3a3f58c223b7e902$var$lozengeAppearance(isOn)
    }, $3a3f58c223b7e902$var$lozengeValue(isOn))) : null;
}

});
parcelRegister("iME2P", function(module, exports) {

$parcel$export(module.exports, "default", () => $b61c2aad7a7fbebf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hxIg9 = parcelRequire("hxIg9");
/**
 * @returns a tootlip message for indicating the current state of a single enabled flag
 */ const $b61c2aad7a7fbebf$var$SingleFlagIsOnTooltip = (rolloutSummary)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (rolloutSummary) {
        if (rolloutSummary.text !== null || rolloutSummary.text !== undefined) return formatMessage((0, $hxIg9.default).rolloutText, {
            text: rolloutSummary.text
        });
        if (rolloutSummary.percentage != null && rolloutSummary.percentage > 0) return formatMessage((0, $hxIg9.default).rolloutPercentage, {
            percentage: rolloutSummary.percentage
        });
        if (rolloutSummary.rules != null && rolloutSummary.rules > 1) return formatMessage((0, $hxIg9.default).rolloutMultipleRules, {
            rulesCnt: rolloutSummary.rules
        });
        return formatMessage((0, $hxIg9.default).rolloutSingleRule);
    }
    return '';
};
/**
 * @returns a tooltip message when only a single flag is associated
 */ const $b61c2aad7a7fbebf$var$SingleFlagTooptip = (enabledFeatureFlagsCnt, rolloutSummary)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (enabledFeatureFlagsCnt > 0) return $b61c2aad7a7fbebf$var$SingleFlagIsOnTooltip(rolloutSummary);
    /**
   * @returns a tooltip message indicating the flag is off
   */ return formatMessage((0, $hxIg9.default).singleFeatureFlagOff);
};
/**
 * @returns a tooltip message for multiple flags
 */ const $b61c2aad7a7fbebf$var$MultipleFlagsTooltip = (enabledFeatureFlagsCnt, disabledFeatureFlagsCnt)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (enabledFeatureFlagsCnt === 0) return formatMessage((0, $hxIg9.default).multipleFeatureFlagsAllOff);
    if (disabledFeatureFlagsCnt === 0) return formatMessage((0, $hxIg9.default).multipleFeatureFlagsAllOn);
    return formatMessage((0, $hxIg9.default).multipleFeatureFlagsSomeOn, {
        onCnt: enabledFeatureFlagsCnt,
        offCnt: enabledFeatureFlagsCnt + disabledFeatureFlagsCnt
    });
};
/**
 * @returns a tootlip message for indicating the current state based on the rollout summary
 */ const $b61c2aad7a7fbebf$var$RolloutSummaryTooltip = (rolloutSummary)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (rolloutSummary.text !== null && rolloutSummary.text !== undefined) return formatMessage((0, $hxIg9.default).rolloutText, {
        text: rolloutSummary.text
    });
    if (rolloutSummary.percentage != null && rolloutSummary.percentage > 0) return formatMessage((0, $hxIg9.default).rolloutPercentage, {
        percentage: rolloutSummary.percentage
    });
    if (rolloutSummary.rules != null && rolloutSummary.rules > 1) return formatMessage((0, $hxIg9.default).rolloutMultipleRules, {
        rulesCnt: rolloutSummary.rules
    });
    return formatMessage((0, $hxIg9.default).rolloutSingleRule);
};
const $b61c2aad7a7fbebf$var$StatusTooltip = (props)=>{
    const { enabledFeatureFlagsCnt: enabledFeatureFlagsCnt, disabledFeatureFlagsCnt: disabledFeatureFlagsCnt, rolloutSummary: rolloutSummary } = props;
    let tooltipContent;
    if (rolloutSummary) tooltipContent = $b61c2aad7a7fbebf$var$RolloutSummaryTooltip(rolloutSummary);
    else if (enabledFeatureFlagsCnt + disabledFeatureFlagsCnt === 1) tooltipContent = $b61c2aad7a7fbebf$var$SingleFlagTooptip(enabledFeatureFlagsCnt, rolloutSummary);
    else tooltipContent = $b61c2aad7a7fbebf$var$MultipleFlagsTooltip(enabledFeatureFlagsCnt, disabledFeatureFlagsCnt);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent
    }, props.children);
};
var $b61c2aad7a7fbebf$export$2e2bcd8739ae039 = $b61c2aad7a7fbebf$var$StatusTooltip;

});
parcelRegister("hxIg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $dace6086040e12e9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dace6086040e12e9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    rolloutText: {
        "id": "development-summary-feature-flag.summary.status.tooltip.rollout-text",
        "defaultMessage": "{text}"
    },
    rolloutPercentage: {
        "id": "development-summary-feature-flag.summary.status.tooltip.rollout-percentage",
        "defaultMessage": "{percentage}%"
    },
    rolloutSingleRule: {
        "id": "development-summary-feature-flag.summary.status.tooltip.rollout-single-rule",
        "defaultMessage": "1 Rule"
    },
    rolloutMultipleRules: {
        "id": "development-summary-feature-flag.summary.status.tooltip.rollout-multiple-rules",
        "defaultMessage": "{rulesCnt} Rules"
    },
    singleFeatureFlagOff: {
        "id": "development-summary-feature-flag.summary.status.tooltip.single-feature-flag-off",
        "defaultMessage": "Feature flag off"
    },
    multipleFeatureFlagsAllOn: {
        "id": "development-summary-feature-flag.summary.status.tooltip.multiple-feature-flags-all-on",
        "defaultMessage": "All feature flags on"
    },
    multipleFeatureFlagsSomeOn: {
        "id": "development-summary-feature-flag.summary.status.tooltip.multiple-feature-flags-some-on",
        "defaultMessage": "{onCnt} of {offCnt} feature flags on"
    },
    multipleFeatureFlagsAllOff: {
        "id": "development-summary-feature-flag.summary.status.tooltip.multiple-feature-flags-all-off",
        "defaultMessage": "All feature flags off"
    }
});

});





parcelRegister("isBjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a2e135d1a3de516$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jOyH3 = parcelRequire("jOyH3");

var $7rNJI = parcelRequire("7rNJI");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3zJTk = parcelRequire("3zJTk");
const $7a2e135d1a3de516$var$Description = ({ description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, description);
const $7a2e135d1a3de516$export$cd0ba36797648943 = ({ remoteLinksCount: remoteLinksCount, issueContext: issueContext, onClick: onClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onLinkClicked = (0, $5uXOq.useCallback)((attributes, onClickAction)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'clickRemoteLinksSummaryLink', attributes);
        if (onClickAction) onClickAction();
    }, [
        createAnalyticsEvent
    ]);
    const summaryItemLabel = formatMessage((0, $3zJTk.default).summaryItemLabel, {
        remoteLinksCount: remoteLinksCount
    });
    const { issueStatusCategory: issueStatusCategory, projectType: projectType, projectId: projectId, isSimplifiedProject: isSimplifiedProject } = issueContext;
    const analyticsAttributes = {
        issueStatusCategory: issueStatusCategory,
        projectType: projectType,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject,
        remoteLinksCount: remoteLinksCount
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5),
        sourceName: "viewRemoteLinksSummary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a2e135d1a3de516$var$Description, {
            description: summaryItemLabel
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            label: formatMessage((0, $3zJTk.default).linkIconLabel),
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: ()=>{
            onLinkClicked(analyticsAttributes, onClick);
        },
        showIconInPlainLink: true,
        itemType: "remote-links",
        itemCount: remoteLinksCount,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "development-summary-remote-links.ui.summary-item"
    }));
};
var $7a2e135d1a3de516$export$2e2bcd8739ae039 = $7a2e135d1a3de516$export$cd0ba36797648943;

});
parcelRegister("3zJTk", function(module, exports) {

$parcel$export(module.exports, "default", () => $384f1f5b9596e2cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $384f1f5b9596e2cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    summaryItemLabel: {
        "id": "development-summary-remote-links.summary-item-label",
        "defaultMessage": "{remoteLinksCount} other {remoteLinksCount, plural, one {link} other {links}}"
    },
    linkIconLabel: {
        "id": "development-summary-remote-links.link-icon-label",
        "defaultMessage": "Link icon"
    }
});

});


parcelRegister("j5LD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fad390a451448aa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9fad390a451448aa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "development-summary-releases-field.summary.label",
        "defaultMessage": "Releases"
    }
});

});


parcelRegister("3yDKs", function(module, exports) {

$parcel$export(module.exports, "useOnMountedAnalytics", () => $a7c8d35299a7a1b6$export$92d629d31f712073);

var $5uXOq = parcelRequire("5uXOq");

var $183uB = parcelRequire("183uB");

var $basmW = parcelRequire("basmW");

var $cb25w = parcelRequire("cb25w");

var $g0VRf = parcelRequire("g0VRf");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bC2fB = parcelRequire("bC2fB");

var $5zJwe = parcelRequire("5zJwe");

var $iZPl5 = parcelRequire("iZPl5");
var $a7c8d35299a7a1b6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $cb25w.default)(), (0, $bC2fB.connect)((state)=>({
        flagsPerProvider: (0, $5zJwe.flagsPerProviderSelector)(state),
        providers: (0, $5zJwe.providersSelector)(state),
        remoteLinksData: (0, $5zJwe.remoteLinksDataSelector)(state)
    }), {}))((0, $iZPl5.default));
const $a7c8d35299a7a1b6$export$f504f1e1350b92c4 = (flagsPerProvider)=>{
    const flagsPerProviderCnt = {};
    Object.keys(flagsPerProvider).forEach((key)=>{
        flagsPerProviderCnt[key] = flagsPerProvider[key].length;
    });
    return flagsPerProviderCnt;
};
const $a7c8d35299a7a1b6$export$cdf9861d920ad813 = (providers)=>{
    const deploymentsPerProviderCnt = {};
    (providers ?? []).forEach((provider)=>{
        const deployments = (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(Object.values(provider.environments));
        deploymentsPerProviderCnt[provider.id] = deployments.length;
    });
    return deploymentsPerProviderCnt;
};
const $a7c8d35299a7a1b6$export$b83c10dcc81ac546 = (providers)=>{
    const environmentsPerProviderCnt = {};
    (providers ?? []).forEach((provider)=>{
        const { environments: environments } = provider;
        Object.keys(environments).forEach((environmentType)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"STAGING" | "PRODUCTION" | "DEVELOPMENT" | "TESTING" | "UNMAPPED", DeploymentData[]>>'.
            const deployments = environments[environmentType];
            environmentsPerProviderCnt[environmentType] = (environmentsPerProviderCnt[environmentType] || 0) + deployments.length;
        });
    });
    return environmentsPerProviderCnt;
};
const $a7c8d35299a7a1b6$export$6666f03614fb8b5f = (remoteLinksData)=>{
    const remoteLinksPerProviderCnt = {};
    (remoteLinksData?.remoteLinks ?? []).forEach((link)=>{
        remoteLinksPerProviderCnt[(0, $g0VRf.fromRemoteLinkProviderId)(link.providerId)] = (remoteLinksPerProviderCnt[(0, $g0VRf.fromRemoteLinkProviderId)(link.providerId)] || 0) + 1;
    });
    return remoteLinksPerProviderCnt;
};
const $a7c8d35299a7a1b6$export$10aafcd0e0ff7f4f = (remoteLinksData)=>{
    const remoteLinksPerTypeCnt = {};
    (remoteLinksData?.remoteLinks ?? []).forEach((link)=>{
        remoteLinksPerTypeCnt[(0, $g0VRf.fromRemoteLinkType)(link.type)] = (remoteLinksPerTypeCnt[(0, $g0VRf.fromRemoteLinkType)(link.type)] || 0) + 1;
    });
    return remoteLinksPerTypeCnt;
};
const $a7c8d35299a7a1b6$export$92d629d31f712073 = ({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, flagsPerProvider: flagsPerProvider, providers: providers, remoteLinksData: remoteLinksData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const hasFired = (0, $5uXOq.useRef)(false);
    return ()=>{
        if (hasFired.current === true) return;
        hasFired.current = true;
        const flagsPerProviderStat = $a7c8d35299a7a1b6$export$f504f1e1350b92c4(flagsPerProvider);
        const totalNumFlags = Object.keys(flagsPerProviderStat).reduce((acc, key)=>acc + flagsPerProviderStat[key], 0);
        const totalNumFeatureFlagProviders = Object.keys(flagsPerProviderStat).length;
        const deploymentsPerProviderStat = $a7c8d35299a7a1b6$export$cdf9861d920ad813(providers);
        const totalNumDeployments = Object.keys(deploymentsPerProviderStat).reduce((acc, key)=>acc + deploymentsPerProviderStat[key], 0);
        const deploymentsPerEnvironmentStat = $a7c8d35299a7a1b6$export$b83c10dcc81ac546(providers);
        const totalNumDeploymentProviders = Object.keys(deploymentsPerProviderStat).length;
        const totalNumRemoteLinks = remoteLinksData ? remoteLinksData.remoteLinks.length : 0;
        const totalNumRemoteLinkProviders = remoteLinksData ? remoteLinksData.providers.length : 0;
        const remoteLinksPerProviderStat = $a7c8d35299a7a1b6$export$6666f03614fb8b5f(remoteLinksData);
        const remoteLinksPerTypeStat = $a7c8d35299a7a1b6$export$10aafcd0e0ff7f4f(remoteLinksData);
        const flagsPerProviderJson = JSON.stringify(flagsPerProviderStat);
        const deploymentsPerProviderJson = JSON.stringify(deploymentsPerProviderStat);
        const environmentsPerProviderJson = JSON.stringify(deploymentsPerEnvironmentStat);
        const remoteLinksPerProviderJson = JSON.stringify(remoteLinksPerProviderStat);
        const remoteLinksPerTypeJson = JSON.stringify(remoteLinksPerTypeStat);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'rendered',
            actionSubject: actionSubject
        }), actionSubjectId, {
            totalNumFlags: totalNumFlags,
            totalNumFeatureFlagProviders: totalNumFeatureFlagProviders,
            flagsPerProvider: flagsPerProviderJson,
            totalNumDeployments: totalNumDeployments,
            totalNumDeploymentProviders: totalNumDeploymentProviders,
            totalNumRemoteLinks: totalNumRemoteLinks,
            totalNumRemoteLinkProviders: totalNumRemoteLinkProviders,
            remoteLinksPerProviderStat: remoteLinksPerProviderJson,
            remoteLinksPerTypeStat: remoteLinksPerTypeJson,
            deploymentsPerProviderStat: deploymentsPerProviderJson,
            environmentsPerProviderStat: environmentsPerProviderJson
        });
    };
};

});
parcelRegister("iZPl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $85be21827bf40759$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $183uB = parcelRequire("183uB");

var $g0VRf = parcelRequire("g0VRf");

var $8zOmE = parcelRequire("8zOmE");
class $85be21827bf40759$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const flagsPerProviderStat = this.calculateFlagsPerProviderStat();
        const totalNumFlags = Object.keys(flagsPerProviderStat).reduce((acc, key)=>acc + flagsPerProviderStat[key], 0);
        const totalNumFeatureFlagProviders = Object.keys(flagsPerProviderStat).length;
        const deploymentsPerProviderStat = this.calculateDeploymentsPerProviderStat();
        const totalNumDeployments = Object.keys(deploymentsPerProviderStat).reduce((acc, key)=>acc + deploymentsPerProviderStat[key], 0);
        const deploymentsPerEnvironmentStat = this.calculateDeploymentsPerEnvironmentStat();
        const totalNumDeploymentProviders = Object.keys(deploymentsPerProviderStat).length;
        const { remoteLinksData: remoteLinksData } = this.props;
        const totalNumRemoteLinks = remoteLinksData.remoteLinks.length;
        const totalNumRemoteLinkProviders = remoteLinksData.providers.length;
        const remoteLinksPerProviderStat = this.calculateRemoteLinksPerProviderStat();
        const remoteLinksPerTypeStat = this.calculateRemoteLinksPerTypeStat();
        if (this.props.createAnalyticsEvent) {
            const flagsPerProviderJson = JSON.stringify(flagsPerProviderStat);
            const deploymentsPerProviderJson = JSON.stringify(deploymentsPerProviderStat);
            const environmentsPerProviderJson = JSON.stringify(deploymentsPerEnvironmentStat);
            const remoteLinksPerProviderJson = JSON.stringify(remoteLinksPerProviderStat);
            const remoteLinksPerTypeJson = JSON.stringify(remoteLinksPerTypeStat);
            (0, $8zOmE.fireUIAnalytics)(this.props.createAnalyticsEvent({
                action: 'rendered',
                actionSubject: this.props.actionSubject
            }), this.props.actionSubjectId, {
                totalNumFlags: totalNumFlags,
                totalNumFeatureFlagProviders: totalNumFeatureFlagProviders,
                flagsPerProvider: flagsPerProviderJson,
                totalNumDeployments: totalNumDeployments,
                totalNumDeploymentProviders: totalNumDeploymentProviders,
                totalNumRemoteLinks: totalNumRemoteLinks,
                totalNumRemoteLinkProviders: totalNumRemoteLinkProviders,
                remoteLinksPerProviderStat: remoteLinksPerProviderJson,
                remoteLinksPerTypeStat: remoteLinksPerTypeJson,
                deploymentsPerProviderStat: deploymentsPerProviderJson,
                environmentsPerProviderStat: environmentsPerProviderJson
            });
        }
    }
    calculateFlagsPerProviderStat() {
        const { flagsPerProvider: flagsPerProvider } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const flagsPerProviderCnt = {};
        Object.keys(flagsPerProvider).forEach((key)=>{
            flagsPerProviderCnt[key] = flagsPerProvider[key].length;
        });
        return flagsPerProviderCnt;
    }
    calculateDeploymentsPerProviderStat() {
        const { providers: providers } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deploymentsPerProviderCnt = {};
        providers.forEach((provider)=>{
            const deployments = (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(Object.values(provider.environments));
            deploymentsPerProviderCnt[provider.id] = deployments.length;
        });
        return deploymentsPerProviderCnt;
    }
    calculateDeploymentsPerEnvironmentStat() {
        const { providers: providers } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const environmentsPerProviderCnt = {};
        providers.forEach((provider)=>{
            const { environments: environments } = provider;
            Object.keys(environments).forEach((environmentType)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"STAGING" | "PRODUCTION" | "DEVELOPMENT" | "TESTING" | "UNMAPPED", DeploymentData[]>>'.
                const deployments = environments[environmentType];
                environmentsPerProviderCnt[environmentType] = (environmentsPerProviderCnt[environmentType] || 0) + deployments.length;
            });
        });
        return environmentsPerProviderCnt;
    }
    calculateRemoteLinksPerProviderStat() {
        const { remoteLinksData: remoteLinksData } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const remoteLinksPerProviderCnt = {};
        remoteLinksData.remoteLinks.forEach((link)=>{
            remoteLinksPerProviderCnt[(0, $g0VRf.fromRemoteLinkProviderId)(link.providerId)] = (remoteLinksPerProviderCnt[(0, $g0VRf.fromRemoteLinkProviderId)(link.providerId)] || 0) + 1;
        });
        return remoteLinksPerProviderCnt;
    }
    calculateRemoteLinksPerTypeStat() {
        const { remoteLinksData: remoteLinksData } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const remoteLinksPerTypeCnt = {};
        remoteLinksData.remoteLinks.forEach((link)=>{
            remoteLinksPerTypeCnt[(0, $g0VRf.fromRemoteLinkType)(link.type)] = (remoteLinksPerTypeCnt[(0, $g0VRf.fromRemoteLinkType)(link.type)] || 0) + 1;
        });
        return remoteLinksPerTypeCnt;
    }
    render() {
        return null;
    }
}

});




parcelRegister("doVrv", function(module, exports) {

$parcel$export(module.exports, "default", () => $744f1b5ae7b7ff28$export$2e2bcd8739ae039);

var $i6bQW = parcelRequire("i6bQW");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dGrdR = parcelRequire("dGrdR");

var $geEab = parcelRequire("geEab");

var $1QNzn = parcelRequire("1QNzn");

var $2Eelh = parcelRequire("2Eelh");

var $5TogZ = parcelRequire("5TogZ");

var $2hrDy = parcelRequire("2hrDy");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $hjSnd = parcelRequire("hjSnd");

var $l8ruj = parcelRequire("l8ruj");

var $5oFIy = parcelRequire("5oFIy");

var $i6bQW = parcelRequire("i6bQW");

var $koeKL = parcelRequire("koeKL");

var $cNd4s = parcelRequire("cNd4s");

var $7hSN4 = parcelRequire("7hSN4");

var $dlUyv = parcelRequire("dlUyv");

var $1URgc = parcelRequire("1URgc");
const $744f1b5ae7b7ff28$var$getExperienceTrackerSamplingRate = ()=>50;
const $744f1b5ae7b7ff28$var$securityFieldTimeToLoad = (0, $dGrdR.metrics).interaction({
    key: 'security-field',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '300_1000_2500_4000_7000_10000'
    }
});
function $744f1b5ae7b7ff28$var$SecurityFieldContents({ queryRef: queryRef }) {
    (0, $5uXOq.useEffect)(()=>{
        $744f1b5ae7b7ff28$var$securityFieldTimeToLoad.stop();
    }, []);
    const data = (0, $8Uumt.usePreloadedQuery)((0, $i6bQW.default), queryRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const appEdges = data.jira?.devOps?.configStates?.edges ?? [];
    const isInContextConfigPromptDismissed = data.jira?.devOps?.isInContextConfigPromptDismissed || false;
    const unconfiguredDisplayableEdges = isInContextConfigPromptDismissed ? [] : appEdges // Known apps filter
    .filter((edge)=>(0, $1QNzn.SECURITY_KNOWN_APPS).includes(edge.node?.id ?? '')) // UNCONFIGURED filter
    .filter((edge)=>(edge.node?.config?.edges ?? []).map((configEdge)=>configEdge.node) // finding apps that have only workspaces whose states are either NOT_SET, NOT_CONFIGURED or PROVIDER_ACTION_CONFIGURED
        .find((node)=>node?.status === 'CONFIGURED' || node?.status === 'PROVIDER_ACTION_CONFIGURED') === undefined).filter(Boolean);
    const vulnRelationshipList = data.devOps?.ariGraph?.relationships?.nodes ?? [];
    const vulnDataList = vulnRelationshipList.flatMap((vuln)=>vuln?.from.data ? [
            vuln.from.data
        ] : []) ?? [];
    const shouldDisplayInContextPrompt = data.devOps?.ariGraph?.hasRelationship === false && unconfiguredDisplayableEdges.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (vulnDataList.length > 0 || shouldDisplayInContextPrompt) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "securityFieldInIssueView"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSnd.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($744f1b5ae7b7ff28$var$SecurityFieldHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSnd.FieldHeadingTitle), null, formatMessage((0, $dlUyv.default).securityFieldHeadingTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSnd.SideBySideField), null, shouldDisplayInContextPrompt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eelh.AppConfigurationPromptSummary), {
        location: "SECURITY_PANEL"
    }), vulnDataList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2hrDy.Vulnerability), {
        vulnerabilityData: vulnDataList
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5TogZ.ViewSecurityFieldInTheIssueViewSuccessTracker), {
        experienceName: (0, $5TogZ.VIEW_SECURITY_FIELD_IN_THE_ISSUE_VIEW),
        hasVulnerabilities: vulnRelationshipList.length !== 0
    }));
}
function $744f1b5ae7b7ff28$export$7f58deb68d49d652({ issueAri: issueAri }) {
    const cloudId = (0, $koeKL.useCloudId)();
    const projectAri = (0, $1URgc.useProjectAri)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $i6bQW.default));
    (0, $5uXOq.useEffect)(()=>{
        $744f1b5ae7b7ff28$var$securityFieldTimeToLoad.start();
        loadQuery({
            issueAri: issueAri,
            cloudId: cloudId,
            projectAri: projectAri,
            isNotSiteAdmin: !isSiteAdmin
        });
    }, [
        issueAri,
        cloudId,
        loadQuery,
        projectAri,
        isSiteAdmin
    ]); // As the security field is rendered on the issue view,
    // we will sample this at a 1 in (ff value) rate to minimise the number of experiences.
    const [isInSample] = (0, $5uXOq.useState)((0, $geEab.default)($744f1b5ae7b7ff28$var$getExperienceTrackerSamplingRate()));
    const securityFieldInTheIssueViewExperiencesFailed = (0, $5TogZ.useSecurityFieldInTheIssueViewExperiencesFailed)({
        experienceName: (0, $5TogZ.VIEW_SECURITY_FIELD_IN_THE_ISSUE_VIEW)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "development-summary-security-field"
    }, isInSample && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5TogZ.ViewSecurityFieldInTheIssueViewExperienceStart), {
        experienceName: (0, $5TogZ.VIEW_SECURITY_FIELD_IN_THE_ISSUE_VIEW),
        experienceId: `${(0, $5TogZ.VIEW_SECURITY_FIELD_IN_THE_ISSUE_VIEW)}-${Date.now()}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        teamName: "fusion-isotopes",
        packageName: "jiraDevelopmentSummaryVulnerability",
        id: "jiraDevelopmentSummaryVulnerability",
        sendToPrivacyUnsafeSplunk: true,
        onError: securityFieldInTheIssueViewExperiencesFailed,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, queryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($744f1b5ae7b7ff28$var$SecurityFieldContents, {
        queryRef: queryRef
    }))));
} // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $744f1b5ae7b7ff28$var$SecurityFieldHeading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSnd.FieldHeadingSideBySide), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _u5f3idpf",
            __cmplp.className
        ])
    });
});
var $744f1b5ae7b7ff28$export$2e2bcd8739ae039 = $744f1b5ae7b7ff28$export$7f58deb68d49d652;

});
parcelRegister("i6bQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $65707029f49e4d29$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfcfe52a9edf6997504349921936c634>>
 * @relayHash 4c2afb7df283a884f5684306f620460d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b1784d3ba607bc6fac4984f378c78361631eb752c80c2623170ca97b9970d25c

var $3Dxah = parcelRequire("3Dxah");
const $65707029f49e4d29$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNotSiteAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        },
        {
            "kind": "Variable",
            "name": "to",
            "variableName": "issueAri"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "vulnerability-associated-issue"
        }
    ], v5 = {
        "condition": "isNotSiteAdmin",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "from",
                        "variableName": "projectAri"
                    },
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "project-associated-vulnerability"
                    }
                ],
                "kind": "ScalarField",
                "name": "hasRelationship"
            }
        ]
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "status"
    }, v9 = {
        "args": [
            v6 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "providerTypeFilter",
                "value": [
                    "SECURITY"
                ]
            }
        ],
        "concreteType": "JiraAppConfigStateConnection",
        "kind": "LinkedField",
        "name": "configStates",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraAppConfigStateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraAppConfigState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v7 /*: any*/ ,
                            {
                                "concreteType": "JiraConfigStateConnection",
                                "kind": "LinkedField",
                                "name": "config",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfigStateEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraConfigState",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v8 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v10 = {
        "args": [
            v6 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "location",
                "value": "SECURITY_PANEL"
            }
        ],
        "kind": "ScalarField",
        "name": "isInContextConfigPromptDismissed"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "title"
        }
    ], v12 = [
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainDevelopmentSummarySecurityFieldQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationship",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipNode",
                                                    "kind": "LinkedField",
                                                    "name": "from",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "LinkedField",
                                                                "name": "data",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "kind": "FragmentSpread",
                                                                                "name": "main_developmentSummaryVulnerability_Vulnerability"
                                                                            }
                                                                        ],
                                                                        "type": "DevOpsSecurityVulnerabilityDetails"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "devOps.ariGraph.relationships.nodes.from.data"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isNotSiteAdmin",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDevOpsQuery",
                                    "kind": "LinkedField",
                                    "name": "devOps",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.devOps.isInContextConfigPromptDismissed"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcvulnerabilitydropdownivllcdevpanelrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "mainDevelopmentSummarySecurityFieldQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationship",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipNode",
                                                    "kind": "LinkedField",
                                                    "name": "from",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        },
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcvulnerabilitydropdownivllcdevpanelrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": v11 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcvulnerabilitydropdownivllcdevpanelrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v11 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "DevOpsSecurityVulnerabilityDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "DevOpsFeatureFlag"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "DevOpsOperationsComponentDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "DevOpsOperationsIncidentDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "DevOpsPullRequestDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "DevOpsRepository"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "JiraAutodevJob"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "JiraConfluenceRemoteIssueLink"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "JiraCustomRemoteIssueLink"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "JiraIssueRemoteIssueLink"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v12 /*: any*/ ,
                                                                    "type": "JiraWebRemoteIssueLink"
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isNotSiteAdmin",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDevOpsQuery",
                                    "kind": "LinkedField",
                                    "name": "devOps",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b1784d3ba607bc6fac4984f378c78361631eb752c80c2623170ca97b9970d25c",
            "metadata": {},
            "name": "mainDevelopmentSummarySecurityFieldQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcvulnerabilitydropdownivllcdevpanelrelayprovider": (0, $3Dxah.default)
            }
        }
    };
}();
$65707029f49e4d29$var$node.hash = "d81da7370785ec9d986e8ac15dcb40e4";
var $65707029f49e4d29$export$2e2bcd8739ae039 = $65707029f49e4d29$var$node;

});
parcelRegister("3Dxah", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5715cdb1f12e49c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $e5715cdb1f12e49c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('vulnerability-dropdown-iv-llc-dev-panel');
    }
};

});


parcelRegister("geEab", function(module, exports) {

$parcel$export(module.exports, "default", () => $6215685fdbd215fb$export$2e2bcd8739ae039);

var $cplCs = parcelRequire("cplCs");
function $6215685fdbd215fb$export$2e2bcd8739ae039(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return (0, $cplCs.default)() * rate <= 1;
}

});
parcelRegister("cplCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93bae87fe11db2e$export$2e2bcd8739ae039);
// code-reaper-ignore-file -- Alternative implementation of random numbers for the browser.
const $d93bae87fe11db2e$var$MAX_UINT32 = 4294967296;
function $d93bae87fe11db2e$export$2e2bcd8739ae039() {
    try {
        const buf = new Uint32Array(1);
        // buf now has a random uint32 value
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.crypto.getRandomValues(buf);
        // Turn it back into a value in [0,1)
        return buf[0] / $d93bae87fe11db2e$var$MAX_UINT32;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Math.random();
    }
}

});


parcelRegister("5TogZ", function(module, exports) {

$parcel$export(module.exports, "VIEW_SECURITY_FIELD_IN_THE_ISSUE_VIEW", () => $7c7de4893bb91a68$export$3df8f2db2d57cb81);
$parcel$export(module.exports, "ViewSecurityFieldInTheIssueViewSuccessTracker", () => $7c7de4893bb91a68$export$831902433fd2f47d);
$parcel$export(module.exports, "useSecurityFieldInTheIssueViewExperiencesFailed", () => $7c7de4893bb91a68$export$1ce855eb0c6cadc8);
$parcel$export(module.exports, "ViewSecurityFieldInTheIssueViewExperienceStart", () => $7c7de4893bb91a68$export$ec3a0b93f352171a);

var $5uXOq = parcelRequire("5uXOq");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $7c7de4893bb91a68$export$3df8f2db2d57cb81 = 'viewSecurityFieldInTheIssueView';
const $7c7de4893bb91a68$export$831902433fd2f47d = ({ experienceName: experienceName = $7c7de4893bb91a68$export$3df8f2db2d57cb81, hasVulnerabilities: hasVulnerabilities })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experienceName,
        attributes: {
            hasVulnerabilities: hasVulnerabilities
        }
    });
const $7c7de4893bb91a68$export$1ce855eb0c6cadc8 = ({ experienceName: experienceName = $7c7de4893bb91a68$export$3df8f2db2d57cb81 })=>(0, $93jKl.useExperienceFail)({
        experience: experienceName
    });
const $7c7de4893bb91a68$export$ec3a0b93f352171a = ({ experienceId: experienceId = Date.now().toString(), experienceName: experienceName = $7c7de4893bb91a68$export$3df8f2db2d57cb81, collect: collect })=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experienceId: experienceId,
        experience: experienceName,
        analyticsSource: "security",
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE),
        collect: collect || undefined
    });
};

});

parcelRegister("2hrDy", function(module, exports) {

$parcel$export(module.exports, "Vulnerability", () => $82d0a8084a1e812f$export$64ddc546e448f388);

var $1RTvt = parcelRequire("1RTvt");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $kEVMo = parcelRequire("kEVMo");

var $fVnbM = parcelRequire("fVnbM");

var $7rNJI = parcelRequire("7rNJI");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $lVl5L = parcelRequire("lVl5L");

var $54E0N = parcelRequire("54E0N");
const $82d0a8084a1e812f$var$SUMMARY_ITEM_TEST_ID = 'development-summary-vulnerability.ui.summary-item';


const $82d0a8084a1e812f$var$ConditionalVulnerabilityDropdown = (parcelRequire("3XtVI")).default;
const $82d0a8084a1e812f$export$64ddc546e448f388 = ({ vulnerabilityData: vulnerabilityData })=>{
    const data = (0, $8Uumt.useFragment)((0, $1RTvt.default), vulnerabilityData);
    const count = data.length;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $54E0N.default).summaryItemTitle,
        values: {
            count: count,
            styledCount: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82d0a8084a1e812f$var$BoldFont, null, count)
        }
    });
    const statusLozenge = // @ts-expect-error - Type '(DevOpsSecurityVulnerabilityStatus | null | undefined)[]' is not assignable to type '(DevOpsSecurityVulnerabilityStatus | null)[]'.
    count > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVl5L.PriorityStatusLozenge), {
        statuses: data.map((detail)=>detail.status)
    }) : null;
    const oneClickUrl = count === 1 ? data[0]?.url : null;
    const hasManyVulnerabilities = count > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, hasManyVulnerabilities ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82d0a8084a1e812f$var$ConditionalVulnerabilityDropdown, {
        vulnerabilityDropdownData: data,
        renderDropdownTrigger: ({ onClick: onClick, isSelected: isSelected, ref: ref, ...dropdownTriggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
                title: title,
                itemType: "vulnerability",
                itemCount: count,
                oneClickUrl: oneClickUrl,
                oneClickToolTipContent: formatMessage((0, $54E0N.default).summaryItemOneClickTooltip),
                secondaryData: statusLozenge,
                secondaryHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82d0a8084a1e812f$var$TriggerButton, {
                    ...dropdownTriggerProps,
                    isSelected: isSelected,
                    onClick: onClick,
                    appearance: "subtle",
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                        LEGACY_size: "medium",
                        spacing: "spacious",
                        label: formatMessage((0, $54E0N.default).summaryItemDropdownTriggerIconLabel),
                        size: "small"
                    })
                }),
                reference: ref,
                onClick: onClick,
                forceVisibleSecondary: isSelected,
                "data-testid": $82d0a8084a1e812f$var$SUMMARY_ITEM_TEST_ID
            })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rNJI.SummaryItem), {
        title: title,
        itemType: "vulnerability",
        itemCount: count,
        oneClickUrl: oneClickUrl,
        oneClickToolTipContent: formatMessage((0, $54E0N.default).summaryItemOneClickTooltip),
        secondaryData: statusLozenge,
        "data-testid": $82d0a8084a1e812f$var$SUMMARY_ITEM_TEST_ID
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $82d0a8084a1e812f$var$TriggerButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_w1ap1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $82d0a8084a1e812f$var$BoldFont = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1RTvt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc49439fd59a4cbc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8409b2c5cead166ce36e7678adf538e6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cc49439fd59a4cbc$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcvulnerabilitydropdownivllcdevpanelrelayprovider"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "main_developmentSummaryVulnerability_Vulnerability",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcvulnerabilitydropdownivllcdevpanelrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "indexOld_developmentSummaryVulnerability_VulnerabilityDropdown"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcvulnerabilitydropdownivllcdevpanelrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "vulnerabilityDropdownItem_developmentSummaryVulnerability_VulnerabilityDropdownItemEntryPoint_vulnerabilityDropdownData"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ],
    "type": "DevOpsSecurityVulnerabilityDetails"
};
$cc49439fd59a4cbc$var$node.hash = "7291243e1bab0862356387e7da4633fd";
var $cc49439fd59a4cbc$export$2e2bcd8739ae039 = $cc49439fd59a4cbc$var$node;

});

parcelRegister("lVl5L", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $c9abbfa09ceb3e07$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "PriorityStatusLozenge", () => $c9abbfa09ceb3e07$export$6e5dec10ef4abc92);

var $5uXOq = parcelRequire("5uXOq");

var $7qDUb = parcelRequire("7qDUb");

var $706xa = parcelRequire("706xa");

var $aYAc3 = parcelRequire("aYAc3");

var $koVbs = parcelRequire("koVbs");

var $ehvDU = parcelRequire("ehvDU");
const $c9abbfa09ceb3e07$var$getLozengeConfig = (status, count)=>{
    switch(status){
        case 'OPEN':
            return {
                message: count ? (0, $ehvDU.default).openCount : (0, $ehvDU.default).open,
                appearance: 'inprogress'
            };
        case 'IGNORED':
            return {
                message: count ? (0, $ehvDU.default).ignoredCount : (0, $ehvDU.default).ignored
            };
        case 'CLOSED':
            return {
                message: count ? (0, $ehvDU.default).closedCount : (0, $ehvDU.default).closed,
                appearance: 'success'
            };
        default:
            return {
                message: count ? (0, $ehvDU.default).unknownCount : (0, $ehvDU.default).unknown
            };
    }
};
const $c9abbfa09ceb3e07$export$9dbddef21059688 = 'software-security-common.common.ui.status-lozenge.lozenge';
const $c9abbfa09ceb3e07$export$f72db4ad1e9b3e6d = ({ status: status, count: count })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { message: message, ...lozengeProps } = $c9abbfa09ceb3e07$var$getLozengeConfig(status, count);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        ...lozengeProps,
        testId: `${$c9abbfa09ceb3e07$export$9dbddef21059688}-${status}`
    }, formatMessage(message, {
        count: count
    }));
};
const $c9abbfa09ceb3e07$var$getStatusScore = (status)=>{
    switch(status){
        case 'OPEN':
            return 1;
        case 'IGNORED':
            return 2;
        case 'UNKNOWN':
            return 3;
        case 'CLOSED':
            return 4;
        default:
            return 5;
    }
};
const $c9abbfa09ceb3e07$export$6e5dec10ef4abc92 = ({ statuses: statuses })=>{
    const sortedStatuses = (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(statuses, $c9abbfa09ceb3e07$var$getStatusScore);
    const priorityStatuses = (0, (/*@__PURE__*/$parcel$interopDefault($706xa)))(sortedStatuses, (status)=>status === sortedStatuses[0]);
    const priorityStatus = priorityStatuses[0] ?? null;
    // Hide the count when every status is of the same priority as it becomes noise.
    const count = statuses.length === priorityStatuses.length ? undefined : priorityStatuses.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9abbfa09ceb3e07$export$f72db4ad1e9b3e6d, {
        status: priorityStatus,
        count: count
    });
};

});
parcelRegister("706xa", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $aW9aS = parcelRequire("aW9aS");
/**
 * Creates a slice of `array` with elements taken from the beginning. Elements
 * are taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.takeWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeWhile(users, ['active', false]);
 * // => objects for ['barney', 'fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeWhile(users, 'active');
 * // => []
 */ function $518d9a00535749d5$var$takeWhile(array, predicate) {
    return array && array.length ? $aW9aS(array, $bxDef(predicate, 3)) : [];
}
module.exports = $518d9a00535749d5$var$takeWhile;

});
parcelRegister("aW9aS", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");
/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */ function $7f667000338f967e$var$baseWhile(array, predicate, isDrop, fromRight) {
    var length = array.length, index = fromRight ? length : -1;
    while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
    return isDrop ? $dM3Z8(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : $dM3Z8(array, fromRight ? index + 1 : 0, fromRight ? length : index);
}
module.exports = $7f667000338f967e$var$baseWhile;

});


parcelRegister("ehvDU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2520ea9320048660$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2520ea9320048660$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    open: {
        "id": "software-security-common.status-lozenge.open",
        "defaultMessage": "OPEN"
    },
    ignored: {
        "id": "software-security-common.status-lozenge.ignored",
        "defaultMessage": "IGNORED"
    },
    closed: {
        "id": "software-security-common.status-lozenge.closed",
        "defaultMessage": "CLOSED"
    },
    unknown: {
        "id": "software-security-common.status-lozenge.unknown",
        "defaultMessage": "UNKNOWN"
    },
    openCount: {
        "id": "software-security-common.status-lozenge.open-count",
        "defaultMessage": "{count, plural, one {# OPEN} other {# OPEN}}"
    },
    ignoredCount: {
        "id": "software-security-common.status-lozenge.ignored-count",
        "defaultMessage": "{count, plural, one {# IGNORED} other {# IGNORED}}"
    },
    closedCount: {
        "id": "software-security-common.status-lozenge.closed-count",
        "defaultMessage": "{count, plural, one {# CLOSED} other {# CLOSED}}"
    },
    unknownCount: {
        "id": "software-security-common.status-lozenge.unknown-count",
        "defaultMessage": "{count, plural, one {# UNKNOWN} other {# UNKNOWN}}"
    }
});

});


parcelRegister("54E0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $3933bdf3a568640b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3933bdf3a568640b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    summaryItemTitle: {
        "id": "development-summary-vulnerability.summary-item-title",
        "defaultMessage": "{count, plural,\n                    =0 {no vulnerabilities}\n                    one {{styledCount} vulnerability}\n                    other {{styledCount} vulnerabilities}\n                }"
    },
    summaryItemOneClickTooltip: {
        "id": "development-summary-vulnerability.summary-item-one-click-tooltip",
        "defaultMessage": "Open vulnerability"
    },
    summaryItemDropdownTriggerIconLabel: {
        "id": "development-summary-vulnerability.summary-item-dropdown-trigger-icon-label",
        "defaultMessage": "Show more"
    }
});

});

parcelRegister("3XtVI", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('vulnerability-dropdown-iv-llc-dev-panel', function() {
    return parcelRequire('fbVjo');
}, function() {
    return parcelRequire('h8NC3');
});

});


parcelRegister("dlUyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4b2ba0865d1c74a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e4b2ba0865d1c74a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    securityFieldHeadingTitle: {
        "id": "development-summary-security-field.security-field-heading-title",
        "defaultMessage": "Security"
    }
});

});

parcelRegister("1URgc", function(module, exports) {

$parcel$export(module.exports, "useProjectAri", () => $8e84f87c1f191d4a$export$8688254b761eadc4);

var $dXq4S = parcelRequire("dXq4S");

var $dAfqg = parcelRequire("dAfqg");

var $koeKL = parcelRequire("koeKL");
const $8e84f87c1f191d4a$export$8688254b761eadc4 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const cloudId = (0, $koeKL.useCloudId)();
    const projectAri = projectContext?.projectId.toString() ?? '';
    return (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        // Since we are in project context, empty string should not happen. If it happens, we will be able to monitor errors via the nearest error boundary, since the hasRelationship query will emit an error.
        resourceId: projectAri
    });
};

});




parcelRegister("5RHZ6", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('jiv-20508-remove-height-animation-dev-panel', function() {
    return parcelRequire('5otab');
}, function() {
    return parcelRequire('cXjK2');
});

});


$parcel$global.rlb("ckYFZ")
//# sourceMappingURL=async-dev-panel.26edd75c.js.map
